import { Base64EncodedString } from "@bonsai-components/utility-types";
import { LongString } from "../@types";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * `Base64` represents a base64 encoded string.
   * In the browser, `btoa` encodes ASCII strings to Base64.
   */
  Base64: { input: Base64EncodedString; output: Base64EncodedString; }
  /** An RFC-3339 compliant Full Date Scalar */
  Date: { input: Date; output: Date; }
  /** A slightly refined version of RFC-3339 compliant DateTime Scalar */
  DateTime: { input: Date; output: Date; }
  Duration: { input: string; output: string; }
  /** A JSON scalar */
  JSON: { input: Record<string, unknown>; output: Record<string, unknown>; }
  /** A 64-bit signed integer */
  Long: { input: LongString; output: LongString; }
  /** Contents may contain Markdown, HTML, or other text and should be passed through a Markdown parser by consumers */
  Markdown: { input: string; output: string; }
  /** An object scalar */
  Object: { input: string | number | boolean | string[]; output: string | number | boolean | string[]; }
  /** A file path relative to repository root (e.g., "src/main/java/Foo.java"). */
  Path: { input: string; output: string; }
  _FieldSet: { input: unknown; output: unknown; }
};

/** Moderne Personal Access Tokens */
export type AccessToken = {
  __typename?: 'AccessToken';
  /** The date and time the token was created. */
  created: Scalars['DateTime']['output'];
  /**
   * Optional description of the token.
   *
   * Useful for distinguishing between multiple tokens.
   */
  description?: Maybe<Scalars['String']['output']>;
  /** The date and time the token will expire. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The unique identifier for the access token.
   * This is not the same as the token itself.
   */
  id: Scalars['ID']['output'];
};

export type AccessTokenConnection = {
  __typename?: 'AccessTokenConnection';
  count: Scalars['Int']['output'];
  edges: Array<AccessTokenEdge>;
  pageInfo: PageInfo;
};

export type AccessTokenEdge = {
  __typename?: 'AccessTokenEdge';
  cursor: Scalars['String']['output'];
  node: AccessToken;
};

export type AccessTokenOrderByField =
  | 'CREATED'
  | 'EXPIRES_AT';

export type AccessTokenOrderByInput = {
  direction?: SortOrder;
  field: AccessTokenOrderByField;
};

export type AccessTokenWhereInput = {
  _and?: InputMaybe<Array<AccessTokenWhereInput>>;
  _not?: InputMaybe<AccessTokenWhereInput>;
  _or?: InputMaybe<Array<AccessTokenWhereInput>>;
  created?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
};

/**
 * One coding agent working on a changeset through `mod <agent> team join`, or the
 * `mod <agent> chat --changeset` before it. The only thing in a changeset with a lifecycle: a
 * revision lands or is refused, and a changeset never learns whether another agent will join.
 */
export type Agent = {
  __typename?: 'Agent';
  codingAgent: CodingAgent;
  /**
   * Null while the agent is working. One whose tool went silent for 15 minutes without saying it
   * ended, say on a machine that died, finished when it was last heard from, and is CANCELED.
   */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** The name the agent signed the team's roster with. Null until it signs. */
  name?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  /**
   * What the agent pushed, in the order it landed; each is a RepositoryRevision. Empty for an
   * agent that changed nothing.
   */
  revisions: Array<RepositoryChangeset>;
  /** @deprecated The roster no longer carries specializations. Always empty. */
  specializations: Array<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
  status: AgentStatus;
  /**
   * The agent's work as spans: what it did, when, and what it cost, never what it read or
   * wrote. The agent's own transcript is never kept. Empty until the agent exits and the
   * wrapper uploads it.
   */
  transcript: TranscriptConnection;
  /** The same spans as one OTLP JSON download. Null until the wrapper uploads them. */
  transcriptExport?: Maybe<TranscriptExport>;
  user: User;
};


/**
 * One coding agent working on a changeset through `mod <agent> team join`, or the
 * `mod <agent> chat --changeset` before it. The only thing in a changeset with a lifecycle: a
 * revision lands or is refused, and a changeset never learns whether another agent will join.
 */
export type AgentTranscriptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TranscriptWhereInput>;
};

export type AgentStatus =
  | 'CANCELED'
  | 'FAILED'
  | 'RUNNING'
  | 'SUCCEEDED';

/**
 * -----------------------------------------------------------------------------
 * Review
 * -----------------------------------------------------------------------------
 * Stub for AgentTeamReview - owned by changeset:reader, whose id is the changeset's
 */
export type AgentTeamReview = {
  __typename?: 'AgentTeamReview';
  /**
   * Every agent that joined the changeset, oldest first. An agent is on the list from the
   * moment it joins, so one that changed nothing is still on record.
   */
  agents: Array<Agent>;
  id: Scalars['ID']['output'];
  /**
   * The recipes the team fixed or wrote, as the recipe repositories the changeset holds.
   * Null while it holds none.
   */
  marketplace?: Maybe<RecipeMarketplace>;
  messageBoard: MessageBoard;
  /** What the team called itself on the message board. Null until it has. */
  name?: Maybe<Scalars['String']['output']>;
};

export type ArtifactoryConfiguration = {
  __typename?: 'ArtifactoryConfiguration';
  connectivity: HttpToolConnectivity;
  lastIngestedAt?: Maybe<Scalars['DateTime']['output']>;
  lstQuery?: Maybe<Array<Scalars['String']['output']>>;
  resourceId: Scalars['String']['output'];
  skipSsl: Scalars['Boolean']['output'];
  skipValidateConnectivity: Scalars['Boolean']['output'];
};

export type AuditLogExportFormat =
  | 'CEF'
  | 'CSV';

export type AuditLogExportFormatFilter = {
  _eq?: InputMaybe<AuditLogExportFormat>;
  _in?: InputMaybe<Array<AuditLogExportFormat>>;
  _neq?: InputMaybe<AuditLogExportFormat>;
  _nin?: InputMaybe<Array<AuditLogExportFormat>>;
};

/**
 * -----------------------------------------------------------------------------
 * Audit Log Download - State Machine
 * -----------------------------------------------------------------------------
 */
export type AuditLogsDownload = {
  id: Scalars['ID']['output'];
};

export type AuditLogsDownloadConnection = {
  __typename?: 'AuditLogsDownloadConnection';
  count: Scalars['Int']['output'];
  edges: Array<AuditLogsDownloadEdge>;
  pageInfo: PageInfo;
};

export type AuditLogsDownloadEdge = {
  __typename?: 'AuditLogsDownloadEdge';
  cursor: Scalars['String']['output'];
  node: AuditLogsDownload;
};

/** An audit log download failed. */
export type AuditLogsDownloadError = AuditLogsDownload & {
  __typename?: 'AuditLogsDownloadError';
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
};

/** An audit log download has completed successfully. */
export type AuditLogsDownloadFinished = AuditLogsDownload & {
  __typename?: 'AuditLogsDownloadFinished';
  /** URL path to download the file (relative to the service base URL). */
  downloadUrl: Scalars['String']['output'];
  finishedAt: Scalars['DateTime']['output'];
  format: AuditLogExportFormat;
  id: Scalars['ID']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export type AuditLogsDownloadOrderByField =
  | 'STARTED_AT';

export type AuditLogsDownloadOrderByInput = {
  direction?: SortOrder;
  field: AuditLogsDownloadOrderByField;
};

/** An audit log download is being processed. */
export type AuditLogsDownloadProcessing = AuditLogsDownload & {
  __typename?: 'AuditLogsDownloadProcessing';
  format: AuditLogExportFormat;
  id: Scalars['ID']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export type AuditLogsDownloadWhereInput = {
  _and?: InputMaybe<Array<AuditLogsDownloadWhereInput>>;
  _not?: InputMaybe<AuditLogsDownloadWhereInput>;
  _or?: InputMaybe<Array<AuditLogsDownloadWhereInput>>;
  format?: InputMaybe<AuditLogExportFormatFilter>;
  id?: InputMaybe<IdFilter>;
};

export type AzureDevOpsConfiguration = {
  __typename?: 'AzureDevOpsConfiguration';
  connectivity: HttpToolConnectivity;
  oauth?: Maybe<AzureDevOpsOauth>;
  resourceId: Scalars['String']['output'];
  skipSsl: Scalars['Boolean']['output'];
  skipValidateConnectivity: Scalars['Boolean']['output'];
};

export type AzureDevOpsConnection = ScmConnection & {
  __typename?: 'AzureDevOpsConnection';
  isAuthorized: Scalars['Boolean']['output'];
  resourceId: Scalars['String']['output'];
  tokens: Array<ScmTokenInfo>;
};

export type AzureDevOpsOauth = {
  __typename?: 'AzureDevOpsOauth';
  clientId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type BitbucketCloudConfiguration = {
  __typename?: 'BitbucketCloudConfiguration';
  connectivity: HttpToolConnectivity;
  oauth?: Maybe<BitbucketCloudOauth>;
  resourceId: Scalars['String']['output'];
  skipSsl: Scalars['Boolean']['output'];
  skipValidateConnectivity: Scalars['Boolean']['output'];
};

export type BitbucketCloudConnection = ScmConnection & {
  __typename?: 'BitbucketCloudConnection';
  isAuthorized: Scalars['Boolean']['output'];
  resourceId: Scalars['String']['output'];
  tokens: Array<ScmTokenInfo>;
};

export type BitbucketCloudOauth = {
  __typename?: 'BitbucketCloudOauth';
  clientId: Scalars['String']['output'];
};

export type BitbucketConfiguration = {
  __typename?: 'BitbucketConfiguration';
  connectivity: HttpToolConnectivity;
  oauth?: Maybe<BitbucketOauth>;
  resourceId: Scalars['String']['output'];
  skipSsl: Scalars['Boolean']['output'];
  skipValidateConnectivity: Scalars['Boolean']['output'];
};

export type BitbucketConnection = ScmConnection & {
  __typename?: 'BitbucketConnection';
  isAuthorized: Scalars['Boolean']['output'];
  resourceId: Scalars['String']['output'];
  tokens: Array<ScmTokenInfo>;
};

export type BitbucketOauth = {
  __typename?: 'BitbucketOauth';
  clientId: Scalars['String']['output'];
};

export type BooleanFilter = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BranchCommitOptions = CommitOptions & {
  __typename?: 'BranchCommitOptions';
  /** The branch name as requested. The branch actually pushed may differ, carrying a short hash of the base branch, and is reported on the repository of a succeeded result. */
  branchName?: Maybe<Scalars['String']['output']>;
};

/**
 * Only reflects CLOSE-triggered branch deletes. A MERGE with deleteSourceBranch: true always
 * reports SKIPPED regardless of whether the provider's bundled delete succeeded.
 */
export type BranchDeleteStatus =
  | 'FAILED'
  /**
   * The branch could not be confidently resolved (e.g. an included PR wasn't found in
   * the changelog index, or a fork PR's branch lives in a different repository than
   * the one a delete would target), so the delete was refused rather than risk
   * deleting the wrong branch.
   */
  | 'REFUSED_UNTRUSTED'
  | 'SKIPPED'
  | 'SUCCEEDED';

export type BuildState =
  | 'FAILED'
  | 'IN_PROGRESS'
  | 'NOT_REQUIRED'
  | 'PENDING'
  | 'SKIPPED'
  | 'SUCCESSFUL';

export type BuildStateFilter = {
  _eq?: InputMaybe<BuildState>;
  _in?: InputMaybe<Array<BuildState>>;
  _neq?: InputMaybe<BuildState>;
  _nin?: InputMaybe<Array<BuildState>>;
};

/**
 * A bulk pull request action (approve, merge, close) that operates on potentially
 * multiple repositories. Use `__typename` to determine the current state.
 *
 * Each `BulkPullRequestAction` contains individual `PullRequestAction` entries
 * representing the state of each pull request targeted by the bulk operation.
 */
export type BulkPullRequestAction = {
  actionType: PullRequestActionType;
  id: Scalars['ID']['output'];
  results: PullRequestActionConnection;
  user: User;
};


/**
 * A bulk pull request action (approve, merge, close) that operates on potentially
 * multiple repositories. Use `__typename` to determine the current state.
 *
 * Each `BulkPullRequestAction` contains individual `PullRequestAction` entries
 * representing the state of each pull request targeted by the bulk operation.
 */
export type BulkPullRequestActionResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PullRequestActionOrderByInput>>;
  where?: InputMaybe<PullRequestActionWhereInput>;
};

export type BulkPullRequestActionCanceled = BulkPullRequestAction & {
  __typename?: 'BulkPullRequestActionCanceled';
  actionType: PullRequestActionType;
  canceledBy: User;
  id: Scalars['ID']['output'];
  results: PullRequestActionConnection;
  user: User;
};


export type BulkPullRequestActionCanceledResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PullRequestActionOrderByInput>>;
  where?: InputMaybe<PullRequestActionWhereInput>;
};

export type BulkPullRequestActionConnection = {
  __typename?: 'BulkPullRequestActionConnection';
  count: Scalars['Int']['output'];
  edges: Array<BulkPullRequestActionEdge>;
  pageInfo: PageInfo;
};

export type BulkPullRequestActionEdge = {
  __typename?: 'BulkPullRequestActionEdge';
  cursor: Scalars['String']['output'];
  node: BulkPullRequestAction;
};

export type BulkPullRequestActionError = BulkPullRequestAction & {
  __typename?: 'BulkPullRequestActionError';
  actionType: PullRequestActionType;
  errorMessage: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  results: PullRequestActionConnection;
  user: User;
};


export type BulkPullRequestActionErrorResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PullRequestActionOrderByInput>>;
  where?: InputMaybe<PullRequestActionWhereInput>;
};

export type BulkPullRequestActionFinished = BulkPullRequestAction & {
  __typename?: 'BulkPullRequestActionFinished';
  actionType: PullRequestActionType;
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  results: PullRequestActionConnection;
  startedAt: Scalars['DateTime']['output'];
  user: User;
};


export type BulkPullRequestActionFinishedResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PullRequestActionOrderByInput>>;
  where?: InputMaybe<PullRequestActionWhereInput>;
};

export type BulkPullRequestActionOrderByField =
  /** Maps to the persisted `queuedAt` timestamp. */
  | 'CREATED_AT'
  | 'FINISHED_AT'
  | 'STARTED_AT';

export type BulkPullRequestActionOrderByInput = {
  direction?: SortOrder;
  field: BulkPullRequestActionOrderByField;
};

export type BulkPullRequestActionQueued = BulkPullRequestAction & {
  __typename?: 'BulkPullRequestActionQueued';
  actionType: PullRequestActionType;
  id: Scalars['ID']['output'];
  queuedAt: Scalars['DateTime']['output'];
  results: PullRequestActionConnection;
  user: User;
};


export type BulkPullRequestActionQueuedResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PullRequestActionOrderByInput>>;
  where?: InputMaybe<PullRequestActionWhereInput>;
};

export type BulkPullRequestActionRunning = BulkPullRequestAction & {
  __typename?: 'BulkPullRequestActionRunning';
  actionType: PullRequestActionType;
  id: Scalars['ID']['output'];
  results: PullRequestActionConnection;
  startedAt: Scalars['DateTime']['output'];
  user: User;
};


export type BulkPullRequestActionRunningResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PullRequestActionOrderByInput>>;
  where?: InputMaybe<PullRequestActionWhereInput>;
};

/**
 * The lifecycle state of a `BulkPullRequestAction`. Matches the `__typename`
 * of the concrete state types (Queued, Running, Finished, Canceled, Error).
 */
export type BulkPullRequestActionState =
  | 'CANCELED'
  | 'ERROR'
  | 'FINISHED'
  | 'QUEUED'
  | 'RUNNING';

export type BulkPullRequestActionStateFilter = {
  _eq?: InputMaybe<BulkPullRequestActionState>;
  _in?: InputMaybe<Array<BulkPullRequestActionState>>;
  _neq?: InputMaybe<BulkPullRequestActionState>;
  _nin?: InputMaybe<Array<BulkPullRequestActionState>>;
};

export type BulkPullRequestActionWhereInput = {
  _and?: InputMaybe<Array<BulkPullRequestActionWhereInput>>;
  _not?: InputMaybe<BulkPullRequestActionWhereInput>;
  _or?: InputMaybe<Array<BulkPullRequestActionWhereInput>>;
  actionType?: InputMaybe<PullRequestActionTypeFilter>;
  /**
   * Filter by `startedAt`. Matches RUNNING/FINISHED/ERROR/CANCELED states that
   * have a startedAt value; QUEUED entries (no startedAt) are excluded when a
   * bound is supplied.
   */
  startedAt?: InputMaybe<DateTimeFilter>;
  state?: InputMaybe<BulkPullRequestActionStateFilter>;
  user?: InputMaybe<UserWhereInput>;
};

/** A participant identity from the VCS provider. Not necessarily a Moderne user. */
export type ChangeParticipant = {
  __typename?: 'ChangeParticipant';
  /** Avatar URL from the VCS provider. */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Email address. */
  email?: Maybe<Scalars['String']['output']>;
  /** Display name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The roles this participant has across changelog entries. */
  roles: Array<ContributorRole>;
  /** Username/login on the VCS provider. */
  username?: Maybe<Scalars['String']['output']>;
};

/** Filter by changelog author. */
export type ChangelogAuthorWhereInput = {
  _and?: InputMaybe<Array<ChangelogAuthorWhereInput>>;
  _not?: InputMaybe<ChangelogAuthorWhereInput>;
  _or?: InputMaybe<Array<ChangelogAuthorWhereInput>>;
  email?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  /** The role of the contributor to filter on. */
  role?: InputMaybe<ContributorRole>;
  username?: InputMaybe<StringFilter>;
};

/**
 * A bulk pull request action (approve, merge, close) that operates on potentially
 * multiple repositories. Use `__typename` to determine the current state.
 *
 * Each `ChangelogBulkPullRequestAction` contains individual `ChangelogPullRequestAction` entries
 * representing the state of each repository targeted by the bulk operation.
 */
export type ChangelogBulkPullRequestAction = {
  actionType: ChangelogPullRequestActionType;
  id: Scalars['ID']['output'];
  results: ChangelogPullRequestActionConnection;
  user: User;
};


/**
 * A bulk pull request action (approve, merge, close) that operates on potentially
 * multiple repositories. Use `__typename` to determine the current state.
 *
 * Each `ChangelogBulkPullRequestAction` contains individual `ChangelogPullRequestAction` entries
 * representing the state of each repository targeted by the bulk operation.
 */
export type ChangelogBulkPullRequestActionResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogPullRequestActionOrderByInput>>;
  where?: InputMaybe<ChangelogPullRequestActionWhereInput>;
};

export type ChangelogBulkPullRequestActionCanceled = ChangelogBulkPullRequestAction & {
  __typename?: 'ChangelogBulkPullRequestActionCanceled';
  actionType: ChangelogPullRequestActionType;
  canceledBy: User;
  id: Scalars['ID']['output'];
  results: ChangelogPullRequestActionConnection;
  user: User;
};


export type ChangelogBulkPullRequestActionCanceledResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogPullRequestActionOrderByInput>>;
  where?: InputMaybe<ChangelogPullRequestActionWhereInput>;
};

export type ChangelogBulkPullRequestActionConnection = {
  __typename?: 'ChangelogBulkPullRequestActionConnection';
  count: Scalars['Int']['output'];
  edges: Array<ChangelogBulkPullRequestActionEdge>;
  pageInfo: PageInfo;
};

export type ChangelogBulkPullRequestActionEdge = {
  __typename?: 'ChangelogBulkPullRequestActionEdge';
  cursor: Scalars['String']['output'];
  node: ChangelogBulkPullRequestAction;
};

export type ChangelogBulkPullRequestActionError = ChangelogBulkPullRequestAction & {
  __typename?: 'ChangelogBulkPullRequestActionError';
  actionType: ChangelogPullRequestActionType;
  errorMessage: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  results: ChangelogPullRequestActionConnection;
  user: User;
};


export type ChangelogBulkPullRequestActionErrorResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogPullRequestActionOrderByInput>>;
  where?: InputMaybe<ChangelogPullRequestActionWhereInput>;
};

export type ChangelogBulkPullRequestActionFinished = ChangelogBulkPullRequestAction & {
  __typename?: 'ChangelogBulkPullRequestActionFinished';
  actionType: ChangelogPullRequestActionType;
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  results: ChangelogPullRequestActionConnection;
  startedAt: Scalars['DateTime']['output'];
  user: User;
};


export type ChangelogBulkPullRequestActionFinishedResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogPullRequestActionOrderByInput>>;
  where?: InputMaybe<ChangelogPullRequestActionWhereInput>;
};

export type ChangelogBulkPullRequestActionOrderByField =
  /** Maps to the persisted `queuedAt` timestamp. */
  | 'CREATED_AT'
  | 'FINISHED_AT'
  | 'STARTED_AT';

export type ChangelogBulkPullRequestActionOrderByInput = {
  direction?: SortOrder;
  field: ChangelogBulkPullRequestActionOrderByField;
};

export type ChangelogBulkPullRequestActionQueued = ChangelogBulkPullRequestAction & {
  __typename?: 'ChangelogBulkPullRequestActionQueued';
  actionType: ChangelogPullRequestActionType;
  id: Scalars['ID']['output'];
  queuedAt: Scalars['DateTime']['output'];
  results: ChangelogPullRequestActionConnection;
  user: User;
};


export type ChangelogBulkPullRequestActionQueuedResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogPullRequestActionOrderByInput>>;
  where?: InputMaybe<ChangelogPullRequestActionWhereInput>;
};

export type ChangelogBulkPullRequestActionRunning = ChangelogBulkPullRequestAction & {
  __typename?: 'ChangelogBulkPullRequestActionRunning';
  actionType: ChangelogPullRequestActionType;
  id: Scalars['ID']['output'];
  results: ChangelogPullRequestActionConnection;
  startedAt: Scalars['DateTime']['output'];
  user: User;
};


export type ChangelogBulkPullRequestActionRunningResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogPullRequestActionOrderByInput>>;
  where?: InputMaybe<ChangelogPullRequestActionWhereInput>;
};

/**
 * The lifecycle state of a `ChangelogBulkPullRequestAction`. Matches the `__typename`
 * of the concrete state types (Queued, Running, Finished, Canceled, Error).
 */
export type ChangelogBulkPullRequestActionState =
  | 'CANCELED'
  | 'ERROR'
  | 'FINISHED'
  | 'QUEUED'
  | 'RUNNING';

export type ChangelogBulkPullRequestActionStateFilter = {
  _eq?: InputMaybe<ChangelogBulkPullRequestActionState>;
  _in?: InputMaybe<Array<ChangelogBulkPullRequestActionState>>;
  _neq?: InputMaybe<ChangelogBulkPullRequestActionState>;
  _nin?: InputMaybe<Array<ChangelogBulkPullRequestActionState>>;
};

export type ChangelogBulkPullRequestActionWhereInput = {
  _and?: InputMaybe<Array<ChangelogBulkPullRequestActionWhereInput>>;
  _not?: InputMaybe<ChangelogBulkPullRequestActionWhereInput>;
  _or?: InputMaybe<Array<ChangelogBulkPullRequestActionWhereInput>>;
  actionType?: InputMaybe<ChangelogPullRequestActionTypeFilter>;
  /**
   * Filter by `startedAt`. Matches RUNNING/FINISHED/ERROR/CANCELED states that
   * have a startedAt value; QUEUED entries (no startedAt) are excluded when a
   * bound is supplied.
   */
  startedAt?: InputMaybe<DateTimeFilter>;
  state?: InputMaybe<ChangelogBulkPullRequestActionStateFilter>;
  user?: InputMaybe<UserWhereInput>;
};

/** A direct commit to a branch. */
export type ChangelogCommit = ChangelogEntry & {
  __typename?: 'ChangelogCommit';
  author: ChangeParticipant;
  branch: Scalars['String']['output'];
  buildState?: Maybe<BuildState>;
  changeset?: Maybe<OrganizationChangeset>;
  createdAt: Scalars['DateTime']['output'];
  diffstat: DiffStat;
  id: Scalars['ID']['output'];
  repository: Repository;
  /** The commit SHA. */
  sha: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

/**
 * A single entry in the changelog — either a commit or a pull request.
 * Use `__typename` to distinguish between `ChangelogCommit` and `ChangelogPullRequest`.
 */
export type ChangelogEntry = {
  /** The author of the commit or PR. */
  author: ChangeParticipant;
  /** The target branch (for PRs) or the branch committed to (for commits). */
  branch: Scalars['String']['output'];
  /**
   * CI status (e.g. from GitHub Actions, GitLab pipelines).
   * Null if no CI is configured or status has not been fetched yet.
   */
  buildState?: Maybe<BuildState>;
  /** If this activity was originated by Moderne, the changeset it belongs to. */
  changeset?: Maybe<OrganizationChangeset>;
  /** When this entry was created in the VCS provider. */
  createdAt: Scalars['DateTime']['output'];
  /** Lines added and removed. */
  diffstat: DiffStat;
  id: Scalars['ID']['output'];
  /** The repository this entry belongs to. */
  repository: Repository;
  /** Commit message (for commits) or PR title (for pull requests). */
  title: Scalars['String']['output'];
  /** When this entry was last updated in the VCS provider. */
  updatedAt: Scalars['DateTime']['output'];
  /** URL to the commit or PR in the VCS provider. */
  url: Scalars['String']['output'];
};

/**
 * =============================================================================
 * Connection
 * =============================================================================
 */
export type ChangelogEntryConnection = {
  __typename?: 'ChangelogEntryConnection';
  count: Scalars['Int']['output'];
  edges: Array<ChangelogEntryEdge>;
  pageInfo: PageInfo;
};

export type ChangelogEntryEdge = {
  __typename?: 'ChangelogEntryEdge';
  cursor: Scalars['String']['output'];
  node: ChangelogEntry;
};

export type ChangelogEntryOrderByField =
  | 'CREATED_AT'
  | 'REPOSITORY_PATH'
  | 'TITLE'
  | 'UPDATED_AT';

/**
 * =============================================================================
 * Ordering
 * =============================================================================
 */
export type ChangelogEntryOrderByInput = {
  direction?: SortOrder;
  field: ChangelogEntryOrderByField;
};

/** Discriminator for filtering by entry type. */
export type ChangelogEntryType =
  | 'COMMIT'
  | 'PULL_REQUEST';

export type ChangelogEntryTypeFilter = {
  _eq?: InputMaybe<ChangelogEntryType>;
  _in?: InputMaybe<Array<ChangelogEntryType>>;
  _neq?: InputMaybe<ChangelogEntryType>;
  _nin?: InputMaybe<Array<ChangelogEntryType>>;
};

/** Filter input for changelog entries. */
export type ChangelogEntryWhereInput = {
  _and?: InputMaybe<Array<ChangelogEntryWhereInput>>;
  _not?: InputMaybe<ChangelogEntryWhereInput>;
  _or?: InputMaybe<Array<ChangelogEntryWhereInput>>;
  /** Filter by author. */
  author?: InputMaybe<ChangelogAuthorWhereInput>;
  /** Filter by CI state. */
  buildState?: InputMaybe<BuildStateFilter>;
  /** Filter by changeset ID. */
  changesetId?: InputMaybe<StringFilter>;
  /** Filter by creation time. */
  createdAt?: InputMaybe<DateTimeFilter>;
  /** Filter by entry type (COMMIT or PULL_REQUEST). */
  entryType?: InputMaybe<ChangelogEntryTypeFilter>;
  /** Filter by pull request state (only applies to PRs). */
  pullRequestState?: InputMaybe<PullRequestStateFilter>;
  /** Filter by repository origin. */
  repositoryOrigin?: InputMaybe<StringFilter>;
  /** Filter by repository path. */
  repositoryPath?: InputMaybe<StringFilter>;
  /** Filter by review decision. */
  reviewDecision?: InputMaybe<ReviewDecisionFilter>;
  /** Full-text search on title. */
  title?: InputMaybe<StringFilter>;
  /** Filter by last updated time. */
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ChangelogParticipantConnection = {
  __typename?: 'ChangelogParticipantConnection';
  count: Scalars['Int']['output'];
  edges: Array<ChangelogParticipantEdge>;
  pageInfo: PageInfo;
};

export type ChangelogParticipantEdge = {
  __typename?: 'ChangelogParticipantEdge';
  cursor: Scalars['String']['output'];
  node: ChangeParticipant;
};

export type ChangelogParticipantOrderByField =
  | 'EMAIL'
  | 'NAME'
  | 'USERNAME';

export type ChangelogParticipantOrderByInput = {
  direction?: SortOrder;
  field: ChangelogParticipantOrderByField;
};

/** Filter input for participants. */
export type ChangelogParticipantWhereInput = {
  _and?: InputMaybe<Array<ChangelogParticipantWhereInput>>;
  _not?: InputMaybe<ChangelogParticipantWhereInput>;
  _or?: InputMaybe<Array<ChangelogParticipantWhereInput>>;
  email?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  /** Filter participants by role. */
  role?: InputMaybe<ContributorRole>;
  /**
   * Scopes participant aggregation to entries updated within this window.
   * Defaults to last 30 days if not specified.
   */
  updatedAt?: InputMaybe<DateTimeFilter>;
  username?: InputMaybe<StringFilter>;
};

/** A pull request (open, draft, merged, or closed). */
export type ChangelogPullRequest = ChangelogEntry & {
  __typename?: 'ChangelogPullRequest';
  /**
   * Actions (approve, merge, close) that have been applied to this pull request.
   * Default sort order is descending by startedAt.
   */
  actions: ChangelogPullRequestActionConnection;
  /** Lines added. */
  additions?: Maybe<Scalars['Int']['output']>;
  /** Reviewers who approved this pull request. */
  approvedBy?: Maybe<Array<ChangeParticipant>>;
  author: ChangeParticipant;
  branch: Scalars['String']['output'];
  buildState?: Maybe<BuildState>;
  changeset?: Maybe<OrganizationChangeset>;
  createdAt: Scalars['DateTime']['output'];
  /** Lines removed. */
  deletions?: Maybe<Scalars['Int']['output']>;
  diffstat: DiffStat;
  /** Whether this is a draft pull request. */
  draft: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The PR number. */
  number: Scalars['Int']['output'];
  repository: Repository;
  /** Reviewers assigned/requested on this pull request. */
  requestedReviewers?: Maybe<Array<ChangeParticipant>>;
  /** Review decision for the pull request. */
  reviewDecision?: Maybe<ReviewDecision>;
  /** The source branch of the pull request. */
  sourceBranch: Scalars['String']['output'];
  /** Current state of the pull request. */
  state: PullRequestState;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};


/** A pull request (open, draft, merged, or closed). */
export type ChangelogPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogPullRequestActionOrderByInput>>;
  where?: InputMaybe<ChangelogPullRequestActionWhereInput>;
};

/**
 * The state of an individual repository within a `ChangelogBulkPullRequestAction`.
 * Use `__typename` to determine the current state.
 */
export type ChangelogPullRequestAction = {
  pullRequest: ChangelogPullRequestRef;
};

export type ChangelogPullRequestActionCanceled = ChangelogPullRequestAction & {
  __typename?: 'ChangelogPullRequestActionCanceled';
  canceledBy: User;
  pullRequest: ChangelogPullRequestRef;
};

/**
 * =============================================================================
 * Connections
 * =============================================================================
 */
export type ChangelogPullRequestActionConnection = {
  __typename?: 'ChangelogPullRequestActionConnection';
  count: Scalars['Int']['output'];
  edges: Array<ChangelogPullRequestActionEdge>;
  pageInfo: PageInfo;
};

export type ChangelogPullRequestActionEdge = {
  __typename?: 'ChangelogPullRequestActionEdge';
  cursor: Scalars['String']['output'];
  node: ChangelogPullRequestAction;
};

export type ChangelogPullRequestActionFailed = ChangelogPullRequestAction & {
  __typename?: 'ChangelogPullRequestActionFailed';
  errorMessage: Scalars['String']['output'];
  finishedAt: Scalars['DateTime']['output'];
  pullRequest: ChangelogPullRequestRef;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ChangelogPullRequestActionOrderByField =
  | 'REPOSITORY_PATH'
  | 'STARTED_AT'
  | 'STATE';

export type ChangelogPullRequestActionOrderByInput = {
  direction?: SortOrder;
  field: ChangelogPullRequestActionOrderByField;
};

export type ChangelogPullRequestActionQueued = ChangelogPullRequestAction & {
  __typename?: 'ChangelogPullRequestActionQueued';
  pullRequest: ChangelogPullRequestRef;
};

export type ChangelogPullRequestActionRunning = ChangelogPullRequestAction & {
  __typename?: 'ChangelogPullRequestActionRunning';
  pullRequest: ChangelogPullRequestRef;
  startedAt: Scalars['DateTime']['output'];
};

export type ChangelogPullRequestActionState =
  | 'CANCELED'
  | 'FAILED'
  | 'IN_PROGRESS'
  | 'QUEUED'
  | 'SUCCESSFUL';

/**
 * =============================================================================
 * Filters and Ordering
 * =============================================================================
 */
export type ChangelogPullRequestActionStateFilter = {
  _eq?: InputMaybe<ChangelogPullRequestActionState>;
  _in?: InputMaybe<Array<ChangelogPullRequestActionState>>;
  _neq?: InputMaybe<ChangelogPullRequestActionState>;
  _nin?: InputMaybe<Array<ChangelogPullRequestActionState>>;
};

export type ChangelogPullRequestActionSucceeded = ChangelogPullRequestAction & {
  __typename?: 'ChangelogPullRequestActionSucceeded';
  finishedAt: Scalars['DateTime']['output'];
  pullRequest: ChangelogPullRequestRef;
  startedAt: Scalars['DateTime']['output'];
};

/**
 * =============================================================================
 * Action Enums
 * =============================================================================
 */
export type ChangelogPullRequestActionType =
  | 'APPROVE'
  | 'CLOSE'
  | 'MERGE';

export type ChangelogPullRequestActionTypeFilter = {
  _eq?: InputMaybe<ChangelogPullRequestActionType>;
  _in?: InputMaybe<Array<ChangelogPullRequestActionType>>;
  _neq?: InputMaybe<ChangelogPullRequestActionType>;
  _nin?: InputMaybe<Array<ChangelogPullRequestActionType>>;
};

export type ChangelogPullRequestActionWhereInput = {
  _and?: InputMaybe<Array<ChangelogPullRequestActionWhereInput>>;
  _not?: InputMaybe<ChangelogPullRequestActionWhereInput>;
  _or?: InputMaybe<Array<ChangelogPullRequestActionWhereInput>>;
  state?: InputMaybe<ChangelogPullRequestActionStateFilter>;
};

export type ChangelogPullRequestRef = {
  __typename?: 'ChangelogPullRequestRef';
  /** The pull request's source branch. */
  branch: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  origin: Scalars['String']['output'];
  repositoryPath: Scalars['String']['output'];
};

/** The installation is a recipe repository kept with a changeset, in effect for that changeset alone. */
export type ChangesetInstallScope = {
  __typename?: 'ChangesetInstallScope';
  changesetId: Scalars['ID']['output'];
};

export type CliDownloadInstructionLink = {
  __typename?: 'CliDownloadInstructionLink';
  label: Scalars['String']['output'];
  uri: Scalars['String']['output'];
};

export type CodeSearchContextLine = {
  __typename?: 'CodeSearchContextLine';
  line: Scalars['String']['output'];
  lineNumber: Scalars['Int']['output'];
};

export type CodeSearchCoverage = {
  __typename?: 'CodeSearchCoverage';
  /**
   * How many of them the index holds at their current commit. A repository whose LST is new
   * is added to the index within minutes.
   */
  indexed: Scalars['Int']['output'];
  /**
   * How many cannot be as things stand: they have no LST, or one the service cannot read or that
   * carries no search index. The rest are on their way into the index. A republished LST is
   * looked at afresh.
   */
  notIndexable: Scalars['Int']['output'];
  /** How many repositories the organization has. */
  repositories: Scalars['Int']['output'];
};

/** A run of lines from a file in the index. */
export type CodeSearchFileLines = {
  __typename?: 'CodeSearchFileLines';
  /** The commit the lines were read at. */
  commit: Scalars['String']['output'];
  /** How many lines the whole file has. */
  lineCount: Scalars['Int']['output'];
  lines: Array<CodeSearchContextLine>;
};

/** The part of a line that matched. */
export type CodeSearchFragment = {
  __typename?: 'CodeSearchFragment';
  length: Scalars['Int']['output'];
  /** What the filters that matched this span knew about it, in the order they matched. */
  notes: Array<CodeSearchNote>;
  /** In characters from the start of the line. */
  offset: Scalars['Int']['output'];
};

export type CodeSearchLineMatch = {
  __typename?: 'CodeSearchLineMatch';
  after: Array<CodeSearchContextLine>;
  before: Array<CodeSearchContextLine>;
  /**
   * The declarations that hold this line, outermost first, with the one that starts on it: each
   * one's kind and name, as `class` and `org.acme.Owner` then `method` and `org.acme.Owner.getPets`,
   * or `mainframe.program` and `CLMB010` then `mainframe.cobol.procedure.paragraph` and
   * `CLMB010.2050-EDIT-MASTER`. Empty for a line outside any, and for a file the index records no
   * declarations in.
   */
  declarations: Array<CodeSearchSymbol>;
  /**
   * The lines that declare the classes and methods this line sits in, or the COBOL program,
   * section and paragraph, outermost first. Empty for a line outside any, and for a file the index
   * records no declarations in.
   */
  enclosing: Array<CodeSearchContextLine>;
  fragments: Array<CodeSearchFragment>;
  line: Scalars['String']['output'];
  /** Counted from 1. */
  lineNumber: Scalars['Int']['output'];
};

/**
 * What the filter that decided a match knew and the matched line may not show: the symbol a name
 * filter matched (`mainframe.program/call CLMU040` at `CALL WS-EDIT-PGM`), the coordinate a `dependency:` glob
 * matched (`org.springframework:spring-web:5.3.31`), or the text a structural hole bound to.
 */
export type CodeSearchNote = {
  __typename?: 'CodeSearchNote';
  /**
   * The note in parts: a symbol's `kind`, `name`, `parent`, `parentKind` and `access`; a dependency's
   * `group`, `artifact` and `version`; a capture's `hole` and the `value` it bound to.
   */
  fields: Array<CodeSearchNoteField>;
  /** Whether text shows it: only when it says what the line and the query do not. */
  shown: Scalars['Boolean']['output'];
  /** `symbol`, `dependency` or `capture`. */
  source: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type CodeSearchNoteField = {
  __typename?: 'CodeSearchNoteField';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CodeSearchReindexResult = {
  __typename?: 'CodeSearchReindexResult';
  /** How many of the repositories are assembled again. */
  repositories: Scalars['Int']['output'];
  /** How many shards are rewritten for them. */
  shards: Scalars['Int']['output'];
  /**
   * The repositories that are not, as `origin/path@branch: why`: not in the organization or in
   * repos.csv, with no LST the index can take, or not yet in the index, which takes them in as they are.
   */
  skipped: Array<Scalars['String']['output']>;
};

/** A file with at least one match. */
export type CodeSearchResult = {
  __typename?: 'CodeSearchResult';
  /**
   * The commit the repository's LST was built from, which the match was found in. Pass it to
   * `codeSearchFileLines` to read more of the file as it was searched.
   */
  commit: Scalars['String']['output'];
  language?: Maybe<Scalars['String']['output']>;
  /** Empty when the query selects files rather than lines, as `select:file` does. */
  lineMatches: Array<CodeSearchLineMatch>;
  /**
   * What the filters that matched the file knew, each note once: its matches' notes, or, for a query
   * that selects files, what a `dependency:` or a name pattern matched in it.
   */
  notes: Array<CodeSearchNote>;
  path: Scalars['Path']['output'];
  repository: Repository;
};

/**
 * -----------------------------------------------------------------------------
 * Results
 * -----------------------------------------------------------------------------
 */
export type CodeSearchResultConnection = {
  __typename?: 'CodeSearchResultConnection';
  /** How much of the organization the search covered. */
  coverage: CodeSearchCoverage;
  edges: Array<CodeSearchResultEdge>;
  /**
   * A page can come back short, or empty, with `hasNextPage` still true: the search ran
   * out of time before filling it. `endCursor` is then where to resume.
   */
  pageInfo: PageInfo;
  /**
   * The changeset the search was kept as when `save` asked for one. The sweep fills it after this
   * page, until its `finishedAt` is set. Null otherwise.
   */
  saved?: Maybe<OrganizationSearch>;
  /**
   * What to know about how the query was read or how far the search got, such as a
   * filter that is not supported.
   */
  warnings: Array<Scalars['String']['output']>;
};

export type CodeSearchResultEdge = {
  __typename?: 'CodeSearchResultEdge';
  cursor: Scalars['String']['output'];
  node: CodeSearchResult;
};

export type CodeSearchSqlResult = {
  __typename?: 'CodeSearchSqlResult';
  columns: Array<Scalars['String']['output']>;
  complete: Scalars['Boolean']['output'];
  coverage?: Maybe<CodeSearchCoverage>;
  elapsedMillis: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  /** Whether `maxRows` cut the rows off. */
  more: Scalars['Boolean']['output'];
  /** Set while RUNNING: pass it back alone to keep waiting. */
  queryId?: Maybe<Scalars['ID']['output']>;
  /** Why not complete, in the MCP tool's terms (INDEX_COVERAGE_INCOMPLETE, SEARCH_NOT_EXHAUSTED, …). */
  reasons: Array<Scalars['String']['output']>;
  rows: Array<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * The changeset the search was kept as when `save` asked for one. The query fills it after this
   * answer, until its `finishedAt` is set. Null otherwise.
   */
  saved?: Maybe<OrganizationSearch>;
  status: CodeSearchSqlStatus;
  warnings: Array<Scalars['String']['output']>;
};

/**
 * -----------------------------------------------------------------------------
 * SQL
 * -----------------------------------------------------------------------------
 */
export type CodeSearchSqlStatus =
  | 'COMPLETED'
  | 'FAILED'
  | 'RUNNING';

/** A declaration the index records. */
export type CodeSearchSymbol = {
  __typename?: 'CodeSearchSymbol';
  /**
   * As the index spells it, and as `select:symbol.<kind>` takes it: `class`, `method`,
   * `mainframe.program`, `mainframe.cobol.procedure.paragraph`, ...
   */
  kind: Scalars['String']['output'];
  /** The qualified name, as `sym:` takes it. */
  name: Scalars['String']['output'];
};

/**
 * The language a code search's query is written in: the Sourcegraph-style expression `codeSearch`
 * takes, or DuckDB SQL over `search(...)` tables as `codeSearchSql` takes it.
 */
export type CodeSearchSyntax =
  | 'SOURCEGRAPH'
  | 'SQL';

/** The coding agent behind `mod <agent> chat`. */
export type CodingAgent =
  | 'AMP'
  | 'CLAUDE'
  | 'CODEX'
  | 'COPILOT'
  | 'CURSOR'
  | 'KIRO'
  | 'OPEN_CODE'
  | 'VSCODE'
  | 'WINDSURF';

export type Column = {
  __typename?: 'Column';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Input for creating a commit from a changeset. */
export type CommitInput = {
  /**
   * If unset, commit to the branch that the LST was generated from.
   *
   * A short hash of the base branch is appended to this name, so one repository committed at several base branches gets a branch for each. Committing the same base branch again lands on the same branch, and so updates its pull request.
   */
  branchName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Changeset ID (e.g., recipe run ID, batch changeset ID).
   * Resolved via federation to an OrganizationChangeset.
   */
  changesetId: Scalars['ID']['input'];
  /**
   * Git-author email to attribute the commit to (display only). This value is never
   * used to select SCM credentials — tokens are resolved from your authenticated
   * identity (or a token you supply explicitly via scmAccessTokens), never from this
   * field. If left blank, your first email will be used.
   */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Extended commit message (Base64 encoded). */
  extendedMessage?: InputMaybe<Scalars['Base64']['input']>;
  /** GPG key for signing commits. */
  gpgKey?: InputMaybe<GpgInput>;
  /** Commit message. */
  message: Scalars['String']['input'];
  /** Organization ID context for the changeset. */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Filter which repositories and files to include.
   * Evaluated in order - first matching rule wins for each repository.
   * Put repo-specific rules first, global fallback rules last.
   * If empty or not provided, all repositories and files in the changeset are included.
   */
  repositories?: InputMaybe<Array<RepositoryChangesetWhereInput>>;
  /**
   * Optional SCM access tokens you already hold, keyed by origin. When provided,
   * these are used instead of looking up your stored OAuth token for the matching
   * origin. These are your own tokens; they do not select another user's credentials.
   */
  scmAccessTokens?: InputMaybe<Array<ScmAccessToken>>;
  /** How to deliver the commit. Choose one strategy. */
  strategy: CommitStrategyInput;
};

export type CommitOption =
  | 'BRANCH'
  | 'DIRECT'
  | 'FORK'
  | 'FORK_AND_PULL_REQUEST'
  | 'NONE'
  | 'PULL_REQUEST';

/**
 * -----------------------------------------------------------------------------
 * Commit Options
 * -----------------------------------------------------------------------------
 */
export type CommitOptions = {
  /** The branch name as requested. The branch actually pushed may differ, carrying a short hash of the base branch, and is reported on the repository of a succeeded result. */
  branchName?: Maybe<Scalars['String']['output']>;
};

/** Commit delivery strategy. Choose one option. */
export type CommitStrategyInput = {
  /** Push directly to the origin remote. */
  direct?: InputMaybe<DirectCommitInput>;
  /** Push to a fork of the origin repository. */
  fork?: InputMaybe<ForkCommitInput>;
  /** Create a pull request from a branch on a fork. */
  forkAndPullRequest?: InputMaybe<ForkAndPullRequestCommitInput>;
  /** Create a pull request from a branch on the origin remote. */
  pullRequest?: InputMaybe<PullRequestCommitInput>;
};

export type Connector = {
  __typename?: 'Connector';
  id: Scalars['ID']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  /** Organization CSV sources this connector is configured to pull. Admin only. */
  organizationSources: Array<OrganizationSource>;
  personalAccessTokenConfiguration?: Maybe<PersonalAccessTokenConfiguration>;
  tools: Array<ConnectorTool>;
  uiConfiguration?: Maybe<UiConfiguration>;
  version: Scalars['String']['output'];
};

export type ConnectorConnection = {
  __typename?: 'ConnectorConnection';
  count: Scalars['Int']['output'];
  edges: Array<ConnectorEdge>;
  pageInfo: PageInfo;
};

export type ConnectorEdge = {
  __typename?: 'ConnectorEdge';
  cursor: Scalars['String']['output'];
  node: Connector;
};

export type ConnectorOrderByField =
  | 'NICKNAME'
  | 'VERSION';

export type ConnectorOrderByInput = {
  direction?: SortOrder;
  field: ConnectorOrderByField;
};

export type ConnectorTool = ArtifactoryConfiguration | AzureDevOpsConfiguration | BitbucketCloudConfiguration | BitbucketConfiguration | GenericHttpToolConfiguration | GitLabConfiguration | GithubConfiguration | GoConfiguration | LlmConfiguration | MavenConfiguration | NpmConfiguration | NugetConfiguration | OrganizationConfiguration | PypiConfiguration | S3Configuration;

export type ConnectorToolType =
  | 'ARTIFACTORY'
  | 'AZURE_DEVOPS'
  | 'BITBUCKET'
  | 'BITBUCKET_CLOUD'
  | 'GITHUB'
  | 'GITLAB'
  | 'GO'
  | 'HTTP_TOOL'
  | 'LLM'
  | 'MAVEN'
  | 'NPM'
  | 'NUGET'
  | 'ORGANIZATION'
  | 'PYPI'
  | 'S3';

export type ConnectorToolTypeFilter = {
  _eq?: InputMaybe<ConnectorToolType>;
  _in?: InputMaybe<Array<ConnectorToolType>>;
};

export type ConnectorWhereInput = {
  _and?: InputMaybe<Array<ConnectorWhereInput>>;
  _not?: InputMaybe<ConnectorWhereInput>;
  _or?: InputMaybe<Array<ConnectorWhereInput>>;
  id?: InputMaybe<IdFilter>;
  nickname?: InputMaybe<StringFilter>;
  toolType?: InputMaybe<ConnectorToolTypeFilter>;
  version?: InputMaybe<StringFilter>;
};

/** The participant's role for filtering. */
export type ContributorRole =
  | 'ASSIGNEE'
  | 'AUTHOR'
  | 'CLOSED_BY'
  | 'REVIEWER';

/**
 * -----------------------------------------------------------------------------
 * Conversation
 * -----------------------------------------------------------------------------
 */
export type Conversation = {
  __typename?: 'Conversation';
  id: Scalars['ID']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  messages: MessageConnection;
  organization: Organization;
  startedAt: Scalars['DateTime']['output'];
  /**
   * Current turn state for this conversation. Carries the server-
   * recommended poll cadence — clients should respect this rather than
   * hardcoding an interval.
   */
  turnState: ConversationTurnState;
  user: User;
};


/**
 * -----------------------------------------------------------------------------
 * Conversation
 * -----------------------------------------------------------------------------
 */
export type ConversationMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * -----------------------------------------------------------------------------
 * Conversation pagination & filtering
 * -----------------------------------------------------------------------------
 */
export type ConversationConnection = {
  __typename?: 'ConversationConnection';
  edges: Array<ConversationEdge>;
  pageInfo: PageInfo;
};

export type ConversationEdge = {
  __typename?: 'ConversationEdge';
  cursor: Scalars['String']['output'];
  node: Conversation;
};

export type ConversationOrderByField =
  | 'LAST_UPDATED_AT'
  | 'STARTED_AT';

export type ConversationOrderByInput = {
  direction?: SortOrder;
  field: ConversationOrderByField;
};

export type ConversationPhase =
  /** User message received, waiting for first LLM token. */
  | 'AWAITING_LLM'
  /** The previous turn ended in an error. */
  | 'ERRORED'
  /** No active turn. */
  | 'IDLE'
  /** LLM is streaming partial text. */
  | 'STREAMING_TEXT'
  /** A tool is executing (e.g. recipe run). */
  | 'TOOL_RUNNING';

/**
 * Represents the current phase of the conversation's active turn (if any).
 * Drives client poll cadence.
 */
export type ConversationTurnState = {
  __typename?: 'ConversationTurnState';
  /** When the currently-active turn started, if any. */
  activeTurnStartedAt?: Maybe<Scalars['DateTime']['output']>;
  phase: ConversationPhase;
  /** Server-recommended poll interval in milliseconds. */
  recommendedPollIntervalMs: Scalars['Int']['output'];
};

export type ConversationWhereInput = {
  _and?: InputMaybe<Array<ConversationWhereInput>>;
  _not?: InputMaybe<ConversationWhereInput>;
  _or?: InputMaybe<Array<ConversationWhereInput>>;
  id?: InputMaybe<IdFilter>;
  lastUpdatedAt?: InputMaybe<DateTimeFilter>;
  startedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<StringFilter>;
};

/**
 * Result of creating a new access token.
 * The token value is only available in this response.
 */
export type CreateAccessTokenResult = {
  __typename?: 'CreateAccessTokenResult';
  /** When the token was created. */
  created: Scalars['DateTime']['output'];
  /** The description provided when creating the token. */
  description?: Maybe<Scalars['String']['output']>;
  /** When the token will expire, or null if it never expires. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier for the token. Use this ID for revocation. */
  id: Scalars['ID']['output'];
  /** The actual token value. Store this securely - it cannot be retrieved again. */
  token: Scalars['String']['output'];
};

export type CreateConversationInput = {
  message: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type CreateUserOrganizationInput = {
  /** The name of the organization. */
  name: Scalars['String']['input'];
  /** Repositories to include in the organization. At least one is required. */
  repositories?: InputMaybe<Array<RepositoryInput>>;
};

export type DataGridFormat =
  | 'FLAT'
  | 'TREE';

export type DataTable = {
  dataTable: DataTableDescriptor;
  /**
   * The group identifying this data table bucket. For community tables this is
   * the group name (e.g., "architecture"). Null for ungrouped/private tables.
   */
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * A human-readable name for this data table instance, describing what it contains.
   * For example, "Method calls matching \`java.util.List add(..)\`".
   * Defaults to the data table's display name when not explicitly set.
   */
  instanceName: Scalars['String']['output'];
};

/** A data table is available for download but no download has been initiated yet. */
export type DataTableAvailable = DataTable & {
  __typename?: 'DataTableAvailable';
  changesetId: Scalars['ID']['output'];
  dataTable: DataTableDescriptor;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instanceName: Scalars['String']['output'];
};

export type DataTableConnection = {
  __typename?: 'DataTableConnection';
  count: Scalars['Int']['output'];
  edges: Array<DataTableEdge>;
  pageInfo: PageInfo;
};

export type DataTableDescriptor = {
  __typename?: 'DataTableDescriptor';
  columns: Array<Column>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DataTableEdge = {
  __typename?: 'DataTableEdge';
  cursor: Scalars['String']['output'];
  node: DataTable;
};

/** A data table download failed. */
export type DataTableError = DataTable & {
  __typename?: 'DataTableError';
  changesetId: Scalars['ID']['output'];
  dataTable: DataTableDescriptor;
  finishedAt: Scalars['DateTime']['output'];
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instanceName: Scalars['String']['output'];
  message: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  /** Who requested this download. Null for downloads that predate attribution. */
  user?: Maybe<User>;
};

/** A data table download has completed successfully. */
export type DataTableFinished = DataTable & {
  __typename?: 'DataTableFinished';
  changesetId: Scalars['ID']['output'];
  dataTable: DataTableDescriptor;
  /**
   * URL path to download the file (relative to the service base URL). It is signed, so it also
   * downloads without an Authorization header for 15 minutes after it is read. Append
   * `saveAs=<name>` to set the saved file name.
   */
  downloadUrl: Scalars['String']['output'];
  duration?: Maybe<Scalars['Duration']['output']>;
  finishedAt: Scalars['DateTime']['output'];
  format: DataTableFormat;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instanceName: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  /** Who requested this download. Null for downloads that predate attribution. */
  user?: Maybe<User>;
};

/**
 * -----------------------------------------------------------------------------
 * Data Tables
 * -----------------------------------------------------------------------------
 */
export type DataTableFormat =
  | 'CSV'
  | 'XLSX';

export type DataTableFormatFilter = {
  _eq?: InputMaybe<DataTableFormat>;
  _in?: InputMaybe<Array<DataTableFormat>>;
  _neq?: InputMaybe<DataTableFormat>;
  _nin?: InputMaybe<Array<DataTableFormat>>;
};

export type DataTableOrderByField =
  | 'DATA_TABLE'
  | 'STARTED_AT';

export type DataTableOrderByInput = {
  direction?: SortOrder;
  field: DataTableOrderByField;
};

/** A data table download is being processed. */
export type DataTableProcessing = DataTable & {
  __typename?: 'DataTableProcessing';
  changesetId: Scalars['ID']['output'];
  dataTable: DataTableDescriptor;
  format: DataTableFormat;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instanceName: Scalars['String']['output'];
  /** When a worker began extracting the table. */
  startedAt: Scalars['DateTime']['output'];
  /** Who requested this download. Null for downloads that predate attribution. */
  user?: Maybe<User>;
};

/** A data table download is waiting for a worker to pick it up. */
export type DataTableQueued = DataTable & {
  __typename?: 'DataTableQueued';
  changesetId: Scalars['ID']['output'];
  dataTable: DataTableDescriptor;
  format: DataTableFormat;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instanceName: Scalars['String']['output'];
  queuedAt: Scalars['DateTime']['output'];
  /** Who requested this download. Null for downloads that predate attribution. */
  user?: Maybe<User>;
};

/** A recipe's last known state in an organization, as `dataTableSql` reads it. */
export type DataTableRecipeState = {
  __typename?: 'DataTableRecipeState';
  /** The runs the rows come from, newest first. */
  changesets: Array<Scalars['ID']['output']>;
  /** The data table's full name. */
  dataTable: Scalars['String']['output'];
  /** What else to know of how the state was read, as that only the recipe's newest runs were. */
  notes: Array<Scalars['String']['output']>;
  /** The recipe's full name. */
  recipe: Scalars['String']['output'];
  /** How many repositories the organization has. */
  repositories: Scalars['Int']['output'];
  /** How many of those states are of an LST the repository has since replaced. */
  stale: Scalars['Int']['output'];
  /**
   * How many of them have a state, from a run of the recipe that finished them; the rest have
   * no rows until the recipe runs on them.
   */
  withState: Scalars['Int']['output'];
};

export type DataTableSqlMessage = Message & {
  __typename?: 'DataTableSqlMessage';
  id: Scalars['ID']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  sqlQuery: Scalars['String']['output'];
  state: MessageState;
  user: User;
};

export type DataTableSqlResult = {
  __typename?: 'DataTableSqlResult';
  columns: Array<Scalars['String']['output']>;
  elapsedMillis: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  /** Whether `maxRows` cut the rows off. */
  more: Scalars['Boolean']['output'];
  /** For a `recipe`, the state the rows are of. Null for a `changesetId`. */
  recipeState?: Maybe<DataTableRecipeState>;
  /** Each row's values in column order, as DuckDB renders them; null for SQL NULL. */
  rows: Array<Array<Maybe<Scalars['String']['output']>>>;
  status: DataTableSqlStatus;
};

export type DataTableSqlStatus =
  | 'COMPLETED'
  /** DuckDB refused the query, which `error` says why. */
  | 'FAILED';

export type DataTableWhereInput = {
  _and?: InputMaybe<Array<DataTableWhereInput>>;
  _not?: InputMaybe<DataTableWhereInput>;
  _or?: InputMaybe<Array<DataTableWhereInput>>;
  dataTable?: InputMaybe<StringFilter>;
  format?: InputMaybe<DataTableFormatFilter>;
  group?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
};

export type DataTablesMessage = Message & {
  __typename?: 'DataTablesMessage';
  dataTables: Array<DataTableDescriptor>;
  id: Scalars['ID']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  state: MessageState;
  user: User;
};

export type DateTimeFilter = {
  _eq?: InputMaybe<Scalars['DateTime']['input']>;
  _gt?: InputMaybe<Scalars['DateTime']['input']>;
  _gte?: InputMaybe<Scalars['DateTime']['input']>;
  _lt?: InputMaybe<Scalars['DateTime']['input']>;
  _lte?: InputMaybe<Scalars['DateTime']['input']>;
  _neq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DevCenter = {
  __typename?: 'DevCenter';
  /** The currently configured DevCenter recipe for this organization. */
  recipe?: Maybe<RecipeDescriptor>;
  /** DevCenter runs for this organization, ordered by start time descending. */
  runs: DevCenterRunConnection;
};


export type DevCenterRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DevCenterRunOrderByInput>>;
  where?: InputMaybe<DevCenterRunWhereInput>;
};

/** How DevCenter card results are aggregated across repositories. */
export type DevCenterAggregation =
  /** Count individual occurrences (e.g., security issues). */
  | 'PER_OCCURRENCE'
  /** One measure per card per repository (e.g., upgrade progress). */
  | 'PER_REPOSITORY';

/**
 * A DevCenter card represents a category of work (e.g., "Spring Boot 3", "Java 21", "Security").
 * Cards contain measures that track progress toward completion.
 */
export type DevCenterCard = {
  __typename?: 'DevCenterCard';
  /** How results are aggregated for this card. */
  aggregation: DevCenterAggregation;
  /** Description of what this card tracks. */
  description?: Maybe<Scalars['Markdown']['output']>;
  /** Display name of the card. */
  displayName: Scalars['Markdown']['output'];
  /** Recipe that can fix/complete the work tracked by this card. */
  fixRecipe?: Maybe<RecipeDescriptor>;
  /** Measures within this card, ordered by ordinal. */
  measures: Array<DevCenterMeasure>;
  /** Repositories where this card is not applicable. */
  repositoriesNotApplicable: Scalars['Int']['output'];
};

export type DevCenterCardDescriptor = {
  __typename?: 'DevCenterCardDescriptor';
  aggregation: DevCenterAggregation;
  description?: Maybe<Scalars['Markdown']['output']>;
  displayName: Scalars['Markdown']['output'];
  fixRecipe?: Maybe<RecipeDescriptor>;
  measures: Array<DevCenterMeasureDescriptor>;
};

/**
 * A measure within a DevCenter card representing a specific state or finding,
 * with a count from the run results.
 */
export type DevCenterMeasure = {
  __typename?: 'DevCenterMeasure';
  /**
   * Count of repositories or occurrences for this measure.
   * For PER_REPOSITORY: number of repositories in this state.
   * For PER_OCCURRENCE: total count of occurrences.
   */
  count: Scalars['Int']['output'];
  /** Description of what this measure represents. */
  description?: Maybe<Scalars['Markdown']['output']>;
  /** Display name of the measure. */
  displayName: Scalars['Markdown']['output'];
  /** Sort order relative to other measures in the card. */
  ordinal: Scalars['Int']['output'];
};

/**
 * A measure descriptor within a DevCenter card, representing metadata about
 * a specific state or finding. See DevCenterMeasure in changeset:reader
 * for the runtime version with counts.
 */
export type DevCenterMeasureDescriptor = {
  __typename?: 'DevCenterMeasureDescriptor';
  description?: Maybe<Scalars['Markdown']['output']>;
  displayName: Scalars['Markdown']['output'];
  ordinal: Scalars['Int']['output'];
};

/** Organization-level context from a DevCenter run. */
export type DevCenterOrganization = {
  __typename?: 'DevCenterOrganization';
  /** Number of unique contributing developers (last 90 days). */
  contributingDevelopers: Scalars['Int']['output'];
  /** Total lines of code across all repositories on platform. */
  linesOfCode: Scalars['Long']['output'];
  /** Repository counts at the time of the run. */
  repositories: DevCenterRepositories;
};

/** Repository counts from a DevCenter run. */
export type DevCenterRepositories = {
  __typename?: 'DevCenterRepositories';
  /** Repositories with no LST ingested at the time of the run. */
  repositoriesWithoutLst: Scalars['Int']['output'];
  /** Total repositories defined in the organization at the time of the run. */
  total: Scalars['Int']['output'];
};

/**
 * A DevCenter run represents the execution of a DevCenter recipe.
 * Use `__typename` to determine the current state.
 */
export type DevCenterRun = {
  /** The underlying recipe run changeset. */
  changeset?: Maybe<OrganizationChangeset>;
  id: Scalars['ID']['output'];
  /** When this DevCenter run started. */
  startedAt: Scalars['DateTime']['output'];
};

/** DevCenter run was canceled before completion. */
export type DevCenterRunCanceled = DevCenterRun & {
  __typename?: 'DevCenterRunCanceled';
  changeset?: Maybe<OrganizationChangeset>;
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export type DevCenterRunConnection = {
  __typename?: 'DevCenterRunConnection';
  count: Scalars['Int']['output'];
  edges: Array<DevCenterRunEdge>;
  pageInfo: PageInfo;
};

export type DevCenterRunEdge = {
  __typename?: 'DevCenterRunEdge';
  cursor: Scalars['String']['output'];
  node: DevCenterRun;
};

/** DevCenter run failed with an error. */
export type DevCenterRunError = DevCenterRun & {
  __typename?: 'DevCenterRunError';
  changeset?: Maybe<OrganizationChangeset>;
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Human-readable error message. */
  message: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
};

/** DevCenter run completed successfully with summarized results. */
export type DevCenterRunFinished = DevCenterRun & {
  __typename?: 'DevCenterRunFinished';
  changeset?: Maybe<OrganizationChangeset>;
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  organization: DevCenterOrganization;
  /** Security vulnerabilities found (from SecurityIssues data table). */
  security?: Maybe<DevCenterCard>;
  startedAt: Scalars['DateTime']['output'];
  /** Upgrade and migration opportunities found (from UpgradesAndMigrations data table). */
  upgradesAndMigrations: Array<DevCenterCard>;
};

export type DevCenterRunOrderByField =
  | 'STARTED_AT'
  | 'STATE';

export type DevCenterRunOrderByInput = {
  direction?: SortOrder;
  field: DevCenterRunOrderByField;
};

/** DevCenter recipe is currently running across repositories. */
export type DevCenterRunRunning = DevCenterRun & {
  __typename?: 'DevCenterRunRunning';
  changeset?: Maybe<OrganizationChangeset>;
  id: Scalars['ID']['output'];
  startedAt: Scalars['DateTime']['output'];
};

/** Execution state of a DevCenter run. */
export type DevCenterRunState =
  | 'CANCELED'
  | 'ERROR'
  | 'FINISHED'
  | 'RUNNING';

export type DevCenterRunStateFilter = {
  _eq?: InputMaybe<DevCenterRunState>;
  _in?: InputMaybe<Array<DevCenterRunState>>;
  _neq?: InputMaybe<DevCenterRunState>;
  _nin?: InputMaybe<Array<DevCenterRunState>>;
};

/** Filter input for DevCenter run queries. */
export type DevCenterRunWhereInput = {
  /** Logical AND - all conditions must match. */
  _and?: InputMaybe<Array<DevCenterRunWhereInput>>;
  /** Logical NOT - negates the condition. */
  _not?: InputMaybe<DevCenterRunWhereInput>;
  /** Logical OR - at least one condition must match. */
  _or?: InputMaybe<Array<DevCenterRunWhereInput>>;
  /** Filter by run ID. Use `where: { id: { _eq: "run-id" } }` to get a specific run. */
  id?: InputMaybe<IdFilter>;
  /** Filter by start time. */
  startedAt?: InputMaybe<DateTimeFilter>;
  /** Filter by run state. */
  state?: InputMaybe<DevCenterRunStateFilter>;
};

/**
 * Consecutive lines on one side of a diff that one change made what they are: removed them,
 * or wrote them and kept them through every change since.
 */
export type DiffBlameRange = {
  __typename?: 'DiffBlameRange';
  /** A RepositoryRevision, or the recipe run's result. */
  change: RepositoryChangeset;
  endingLine: Scalars['Int']['output'];
  /**
   * BEFORE for removed lines, numbered as in the base commit; AFTER for added lines, numbered
   * as in the revision. The numbers in the diff's hunk headers.
   */
  side: DiffSide;
  startingLine: Scalars['Int']['output'];
};

export type DiffSide =
  | 'AFTER'
  | 'BEFORE';

/** Aggregate line-level diff statistics. */
export type DiffStat = {
  __typename?: 'DiffStat';
  /** Total lines added. */
  additions: Scalars['Int']['output'];
  /** Total lines removed. */
  deletions: Scalars['Int']['output'];
};

/** Direct commit to origin. No additional options required. */
export type DirectCommitInput = {
  /** Placeholder field. Direct commits require no additional configuration. */
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Direct commit to repository completed successfully. */
export type DirectCommitSucceeded = RepositoryCommit & RepositoryCommitSucceeded & {
  __typename?: 'DirectCommitSucceeded';
  finishedAt: Scalars['DateTime']['output'];
  repository: Repository;
  resultLink?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
};

export type ErrorDetail =
  /**
   * The deadline expired before the operation could complete.
   *
   * For operations that change the state of the system, this error
   * may be returned even if the operation has completed successfully.
   * For example, a successful response from a server could have been
   * delayed long enough for the deadline to expire.
   *
   * HTTP Mapping: 504 Gateway Timeout
   * Error Type: UNAVAILABLE
   */
  | 'DEADLINE_EXCEEDED'
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   *
   * HTTP Mapping: 420 Enhance Your Calm
   * Error Type: UNAVAILABLE
   */
  | 'ENHANCE_YOUR_CALM'
  /**
   * The requested field is not found in the schema.
   *
   * This differs from `NOT_FOUND` in that `NOT_FOUND` should be used when a
   * query is valid, but is unable to return a result (if, for example, a
   * specific video id doesn't exist). `FIELD_NOT_FOUND` is intended to be
   * returned by the server to signify that the requested field is not known to exist.
   * This may be returned in lieu of failing the entire query.
   * See also `PERMISSION_DENIED` for cases where the
   * requested field is invalid only for the given user or class of users.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: BAD_REQUEST
   */
  | 'FIELD_NOT_FOUND'
  /**
   * The client specified an invalid argument.
   *
   * Note that this differs from `FAILED_PRECONDITION`.
   * `INVALID_ARGUMENT` indicates arguments that are problematic
   * regardless of the state of the system (e.g., a malformed file name).
   *
   * HTTP Mapping: 400 Bad Request
   * Error Type: BAD_REQUEST
   */
  | 'INVALID_ARGUMENT'
  /**
   * The provided cursor is not valid.
   *
   * The most common usage for this error is when a client is paginating
   * through a list that uses stateful cursors. In that case, the provided
   * cursor may be expired.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: NOT_FOUND
   */
  | 'INVALID_CURSOR'
  /**
   * Unable to perform operation because a required resource is missing.
   *
   * Example: Client is attempting to refresh a list, but the specified
   * list is expired. This requires an action by the client to get a new list.
   *
   * If the user is simply trying GET a resource that is not found,
   * use the NOT_FOUND error type. FAILED_PRECONDITION.MISSING_RESOURCE
   * is to be used particularly when the user is performing an operation
   * that requires a particular resource to exist.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   * Error Type: FAILED_PRECONDITION
   */
  | 'MISSING_RESOURCE'
  /**
   * Service Error.
   *
   * There is a problem with an upstream service.
   *
   * This may be returned if a gateway receives an unknown error from a service
   * or if a service is unreachable.
   * If a request times out which waiting on a response from a service,
   * `DEADLINE_EXCEEDED` may be returned instead.
   * If a service returns a more specific error Type, the specific error Type may
   * be returned instead.
   *
   * HTTP Mapping: 502 Bad Gateway
   * Error Type: UNAVAILABLE
   */
  | 'SERVICE_ERROR'
  /**
   * Request failed due to network errors.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  | 'TCP_FAILURE'
  /**
   * Request throttled based on server concurrency limits.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  | 'THROTTLED_CONCURRENCY'
  /**
   * Request throttled based on server CPU limits
   *
   * HTTP Mapping: 503 Unavailable.
   * Error Type: UNAVAILABLE
   */
  | 'THROTTLED_CPU'
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   *
   * HTTP Mapping: 429 Too Many Requests
   * Error Type: UNAVAILABLE
   */
  | 'TOO_MANY_REQUESTS'
  /**
   * The operation is not implemented or is not currently supported/enabled.
   *
   * HTTP Mapping: 501 Not Implemented
   * Error Type: BAD_REQUEST
   */
  | 'UNIMPLEMENTED'
  /**
   * Unknown error.
   *
   * This error should only be returned when no other error detail applies.
   * If a client sees an unknown errorDetail, it will be interpreted as UNKNOWN.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  | 'UNKNOWN';

export type ErrorMessage = Message & {
  __typename?: 'ErrorMessage';
  /**
   * Stable error code that clients may switch on for UI copy. The full
   * taxonomy (split into API-call errors vs in-conversation errors) is
   * maintained in `doc/moddy-polling-ui-handoff.md`. As of now:
   *
   *   Configuration / LLM provider:
   *     LLM_UNAVAILABLE, LLM_OVERLOADED, LLM_RATE_LIMITED, LLM_AUTH_FAILED,
   *     LLM_CONTEXT_TOO_LONG, LLM_TIMED_OUT, LLM_QUOTA_EXCEEDED,
   *     LLM_UNREACHABLE, LLM_EMPTY_RESPONSE, LLM_FAILED
   *
   *   Tool execution:
   *     TOOL_UNKNOWN, TOOL_FAILED
   *
   *   Turn lifecycle:
   *     TURN_LIMIT_EXCEEDED, CANCELLED
   *
   *   Fallback:
   *     INTERNAL
   *
   * API-call errors (returned in GraphQL `errors[]`, not as messages):
   * INVALID_CURSOR, FORBIDDEN, CONVERSATION_BUSY, MESSAGE_TOO_LONG,
   * CONVERSATION_NOT_FOUND, TOO_MANY_REQUESTS.
   */
  code?: Maybe<Scalars['String']['output']>;
  content: Scalars['Markdown']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  state: MessageState;
  user: User;
};

export type ErrorType =
  /**
   * Bad Request.
   *
   * There is a problem with the request.
   * Retrying the same request is not likely to succeed.
   * An example would be a query or argument that cannot be deserialized.
   *
   * HTTP Mapping: 400 Bad Request
   */
  | 'BAD_REQUEST'
  /**
   * The operation was rejected because the system is not in a state
   * required for the operation's execution.  For example, the directory
   * to be deleted is non-empty, an rmdir operation is applied to
   * a non-directory, etc.
   *
   * Service implementers can use the following guidelines to decide
   * between `FAILED_PRECONDITION` and `UNAVAILABLE`:
   *
   * - Use `UNAVAILABLE` if the client can retry just the failing call.
   * - Use `FAILED_PRECONDITION` if the client should not retry until
   * the system state has been explicitly fixed.  E.g., if an "rmdir"
   *      fails because the directory is non-empty, `FAILED_PRECONDITION`
   * should be returned since the client should not retry unless
   * the files are deleted from the directory.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   */
  | 'FAILED_PRECONDITION'
  /**
   * Internal error.
   *
   * An unexpected internal error was encountered. This means that some
   * invariants expected by the underlying system have been broken.
   * This error code is reserved for serious errors.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  | 'INTERNAL'
  /**
   * The requested entity was not found.
   *
   * This could apply to a resource that has never existed (e.g. bad resource id),
   * or a resource that no longer exists (e.g. cache expired.)
   *
   * Note to server developers: if a request is denied for an entire class
   * of users, such as gradual feature rollout or undocumented allowlist,
   * `NOT_FOUND` may be used. If a request is denied for some users within
   * a class of users, such as user-based access control, `PERMISSION_DENIED`
   * must be used.
   *
   * HTTP Mapping: 404 Not Found
   */
  | 'NOT_FOUND'
  /**
   * The caller does not have permission to execute the specified
   * operation.
   *
   * `PERMISSION_DENIED` must not be used for rejections
   * caused by exhausting some resource or quota.
   * `PERMISSION_DENIED` must not be used if the caller
   * cannot be identified (use `UNAUTHENTICATED`
   * instead for those errors).
   *
   * This error Type does not imply the
   * request is valid or the requested entity exists or satisfies
   * other pre-conditions.
   *
   * HTTP Mapping: 403 Forbidden
   */
  | 'PERMISSION_DENIED'
  /**
   * The request does not have valid authentication credentials.
   *
   * This is intended to be returned only for routes that require
   * authentication.
   *
   * HTTP Mapping: 401 Unauthorized
   */
  | 'UNAUTHENTICATED'
  /**
   * Currently Unavailable.
   *
   * The service is currently unavailable.  This is most likely a
   * transient condition, which can be corrected by retrying with
   * a backoff.
   *
   * HTTP Mapping: 503 Unavailable
   */
  | 'UNAVAILABLE'
  /**
   * Unknown error.
   *
   * For example, this error may be returned when
   * an error code received from another address space belongs to
   * an error space that is not known in this address space.  Also
   * errors raised by APIs that do not return enough error information
   * may be converted to this error.
   *
   * If a client sees an unknown errorType, it will be interpreted as UNKNOWN.
   * Unknown errors MUST NOT trigger any special behavior. These MAY be treated
   * by an implementation as being equivalent to INTERNAL.
   *
   * When possible, a more specific error should be provided.
   *
   * HTTP Mapping: 520 Unknown Error
   */
  | 'UNKNOWN';

export type ExchangeAuthorizationCodeInput = {
  /** The authorization ID returned from initiateAuthorization or from NeedsAuthorization. */
  authorizationId: Scalars['ID']['input'];
  /** Authorization code from the OAuth callback. */
  code: Scalars['String']['input'];
  /**
   * The redirect URI used in the authorization request.
   * Note: This field is deprecated - the server uses the stored redirect URI
   * from the authorization to ensure an exact match.
   */
  redirectUri: Scalars['String']['input'];
  /**
   * The state value returned in the OAuth callback (the `state` parameter for OAuth 2.0,
   * or `oauth_token` for Bitbucket OAuth 1.0a). Validated against the server-issued state
   * to prevent CSRF / authorization-code injection.
   */
  state: Scalars['String']['input'];
};

/** Result of exchanging an authorization code. */
export type ExchangeAuthorizationResult = {
  __typename?: 'ExchangeAuthorizationResult';
  /** Error message if exchange failed. */
  error?: Maybe<Scalars['String']['output']>;
  /** True if the exchange was successful and token was stored. */
  success: Scalars['Boolean']['output'];
};

/** A change to a single file within a repository changeset. */
export type FileChange = {
  /**
   * The source path after the change (from the diff's `+++ b/...` line).
   * Null for deleted files.
   */
  afterSourcePath?: Maybe<Scalars['Path']['output']>;
  /**
   * The source path before the change (from the diff's `--- a/...` line).
   * Null for newly created files.
   */
  beforeSourcePath?: Maybe<Scalars['Path']['output']>;
  /** Get the diff for this file. */
  diff?: Maybe<Patch>;
  /** Path to the file relative to repository root. */
  path: Scalars['Path']['output'];
};


/** A change to a single file within a repository changeset. */
export type FileChangeDiffArgs = {
  markupLevel?: InputMaybe<MarkupLevel>;
  showWhitespaceOnlyChanges?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection for file changes with aggregate statistics. */
export type FileChangeConnection = {
  __typename?: 'FileChangeConnection';
  /** Files with committable changes. */
  changed: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  edges: Array<FileChangeEdge>;
  /** Files with errors. */
  errors: Scalars['Int']['output'];
  pageInfo: PageInfo;
  /** Total files searched. */
  searched: Scalars['Int']['output'];
};

export type FileChangeEdge = {
  __typename?: 'FileChangeEdge';
  cursor: Scalars['String']['output'];
  node: FileChange;
};

export type FileChangeOrderByField =
  | 'PATH';

export type FileChangeOrderByInput = {
  direction?: SortOrder;
  field: FileChangeOrderByField;
};

/** Filter for file changes. */
export type FileChangeWhereInput = {
  /** Logical AND - all conditions must match. */
  _and?: InputMaybe<Array<FileChangeWhereInput>>;
  /** Logical NOT - negates the condition. */
  _not?: InputMaybe<FileChangeWhereInput>;
  /** Logical OR - at least one condition must match. */
  _or?: InputMaybe<Array<FileChangeWhereInput>>;
  /**
   * Only return files that contain at least one ERROR-level marker.
   * Note: this field is evaluated at the top level only. Placing it inside
   * _and / _or / _not is silently ignored.
   */
  errorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by file path using glob patterns. */
  path?: InputMaybe<PathFilter>;
};

/** Create a pull request from a branch on a fork. */
export type ForkAndPullRequestCommitInput = {
  /**
   * Auto-merge method after checks pass. Null means no auto-merge.
   * Best effort - silently ignored if not supported by the repository.
   */
  autoMergeMethod?: InputMaybe<MergeMethod>;
  /** Pull request body (Base64 encoded). */
  body?: InputMaybe<Scalars['Base64']['input']>;
  /** Create as a draft pull request. */
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  /** GitHub only: allow maintainers to edit the pull request. */
  maintainerCanModify?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization to create the fork in. If unset, creates in user's personal account. */
  organization?: InputMaybe<Scalars['String']['input']>;
  /** Prefix the fork name with the origin organization to avoid name collisions. */
  prefixOrganizationName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Recreate pull request if it was previously closed. */
  recreateClosedPullRequest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pull request title. If unset, uses the commit message. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Fork and pull request commit completed successfully. */
export type ForkAndPullRequestCommitSucceeded = RepositoryCommit & RepositoryCommitSucceeded & {
  __typename?: 'ForkAndPullRequestCommitSucceeded';
  finishedAt: Scalars['DateTime']['output'];
  /** Pull request status, resolved live from the SCM on read (one SCM request per open PR). */
  pullRequestStatus: PullRequestStatus;
  repository: Repository;
  resultLink?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
};

/** Commit to a fork of the origin repository. */
export type ForkCommitInput = {
  /** Organization to create the fork in. If unset, creates in user's personal account. */
  organization?: InputMaybe<Scalars['String']['input']>;
  /**
   * Prefix the fork name with the origin organization to avoid name collisions.
   * Example: openrewrite/rewrite -> myuser/openrewrite__rewrite
   */
  prefixOrganizationName?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ForkCommitOptions = CommitOptions & {
  __typename?: 'ForkCommitOptions';
  /** The branch name as requested. The branch actually pushed may differ, carrying a short hash of the base branch, and is reported on the repository of a succeeded result. */
  branchName?: Maybe<Scalars['String']['output']>;
  /**
   * If set, the fork will be created in this organization. Otherwise, the fork will be created in the user's
   * personal account.
   */
  organization?: Maybe<Scalars['String']['output']>;
  prefixOrganization: Scalars['Boolean']['output'];
};

/** Fork commit completed successfully. */
export type ForkCommitSucceeded = RepositoryCommit & RepositoryCommitSucceeded & {
  __typename?: 'ForkCommitSucceeded';
  finishedAt: Scalars['DateTime']['output'];
  repository: Repository;
  resultLink?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
};

export type ForkPullRequestOptions = CommitOptions & {
  __typename?: 'ForkPullRequestOptions';
  /** If allowed by the repository, set the pull request to automatically merge after all checks pass using the defined strategy. */
  autoMergeMethod?: Maybe<MergeMethod>;
  /** The branch name as requested. The branch actually pushed may differ, carrying a short hash of the base branch, and is reported on the repository of a succeeded result. */
  branchName?: Maybe<Scalars['String']['output']>;
  /** Recreate a pull request if it was already closed. */
  canRecreateClosedPullRequest: Scalars['Boolean']['output'];
  draft: Scalars['Boolean']['output'];
  /** GitHub only flag to allow maintainers to edit a pull request. */
  maintainerCanModify: Scalars['Boolean']['output'];
  /**
   * If set, the fork will be created in this organization. Otherwise, the fork will be created in the user's
   * personal account.
   */
  organization?: Maybe<Scalars['String']['output']>;
  prefixOrganization: Scalars['Boolean']['output'];
  pullRequestBody?: Maybe<Scalars['Base64']['output']>;
  /** If unset, the commit message will be used as the pull request title. */
  pullRequestTitle?: Maybe<Scalars['String']['output']>;
};

export type GenericHttpToolConfiguration = {
  __typename?: 'GenericHttpToolConfiguration';
  connectivity: HttpToolConnectivity;
  resourceId: Scalars['String']['output'];
  skipSsl: Scalars['Boolean']['output'];
  skipValidateConnectivity: Scalars['Boolean']['output'];
};

export type GitLabConfiguration = {
  __typename?: 'GitLabConfiguration';
  connectivity: HttpToolConnectivity;
  oauth?: Maybe<GitLabOauth>;
  resourceId: Scalars['String']['output'];
  skipSsl: Scalars['Boolean']['output'];
  skipValidateConnectivity: Scalars['Boolean']['output'];
};

export type GitLabConnection = ScmConnection & {
  __typename?: 'GitLabConnection';
  isAuthorized: Scalars['Boolean']['output'];
  resourceId: Scalars['String']['output'];
  tokens: Array<ScmTokenInfo>;
};

export type GitLabOauth = {
  __typename?: 'GitLabOauth';
  clientId: Scalars['String']['output'];
};

/**
 * A recipe repository kept with a changeset, where the agents working on the changeset fix and
 * add recipes.
 */
export type GitRecipeBundle = RecipeBundle & {
  __typename?: 'GitRecipeBundle';
  /**
   * The upstream commit the branch started at, an ancestor of every commit the branch has stood
   * at: `git log <baseCommit>..<branch>` is what the changeset added, with any newer upstream
   * commits a session pulled in. Null when `upstreamUrl` is.
   */
  baseCommit?: Maybe<Scalars['String']['output']>;
  /** The repository's one branch, which is named for the changeset. */
  branch: Scalars['String']['output'];
  /** What `git clone` takes, with the credentials the changeset's other remotes take. */
  cloneUrl: Scalars['String']['output'];
  /** The repository's name, such as `rewrite-migrate-java`. */
  packageName: Scalars['String']['output'];
  recipeCount?: Maybe<Scalars['Int']['output']>;
  requestedVersion?: Maybe<Scalars['String']['output']>;
  /**
   * The upstream repository the branch came from, as its first push said. Null when it did not
   * say, or the repository has no upstream.
   */
  upstreamUrl?: Maybe<Scalars['String']['output']>;
  /** The commit the repository's branch stands at. */
  version?: Maybe<Scalars['String']['output']>;
};

export type GithubConfiguration = {
  __typename?: 'GithubConfiguration';
  allowableOrganizations: Array<Scalars['String']['output']>;
  connectivity: HttpToolConnectivity;
  oauth?: Maybe<GithubOauth>;
  resourceId: Scalars['String']['output'];
  skipSsl: Scalars['Boolean']['output'];
  skipValidateConnectivity: Scalars['Boolean']['output'];
};

export type GithubConnection = ScmConnection & {
  __typename?: 'GithubConnection';
  isAuthorized: Scalars['Boolean']['output'];
  resourceId: Scalars['String']['output'];
  tokens: Array<ScmTokenInfo>;
};

export type GithubOauth = {
  __typename?: 'GithubOauth';
  clientId: Scalars['String']['output'];
  includePrivateRepos: Scalars['Boolean']['output'];
};

export type GoConfiguration = {
  __typename?: 'GoConfiguration';
  connectivity: HttpToolConnectivity;
  resourceId: Scalars['String']['output'];
  skipSsl: Scalars['Boolean']['output'];
  skipValidateConnectivity: Scalars['Boolean']['output'];
};

export type GoRecipeBundle = RecipeBundle & {
  __typename?: 'GoRecipeBundle';
  packageName: Scalars['String']['output'];
  recipeCount?: Maybe<Scalars['Int']['output']>;
  requestedVersion?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type GoRecipeBundleInput = {
  packageName: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

/**
 * -----------------------------------------------------------------------------
 * Shared Input Types
 * -----------------------------------------------------------------------------
 */
export type GpgInput = {
  passphrase?: InputMaybe<Scalars['String']['input']>;
  privateKey: Scalars['String']['input'];
  publicKey: Scalars['String']['input'];
};

export type HttpToolConnectivity = {
  __typename?: 'HttpToolConnectivity';
  connected: Scalars['Boolean']['output'];
  latency?: Maybe<Scalars['Duration']['output']>;
};

export type IdFilter = {
  _eq?: InputMaybe<Scalars['ID']['input']>;
  _in?: InputMaybe<Array<Scalars['ID']['input']>>;
  _neq?: InputMaybe<Scalars['ID']['input']>;
  _nin?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ImageFormat =
  | 'GIF'
  | 'JPEG'
  | 'PNG'
  | 'SVG';

/**
 * -----------------------------------------------------------------------------
 * Unified OAuth Input Types
 * -----------------------------------------------------------------------------
 */
export type InitiateAuthorizationInput = {
  /** The VCS origin to authorize (e.g., github.com, gitlab.com). */
  origin: Scalars['String']['input'];
  /**
   * The redirect URI where the VCS will send the callback.
   * Must match an allowed redirect URI in the OAuth app configuration.
   */
  redirectUri: Scalars['String']['input'];
};

export type IntFilter = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
};

export type License = {
  __typename?: 'License';
  key?: Maybe<Scalars['String']['output']>;
};

export type LlmConfiguration = {
  __typename?: 'LlmConfiguration';
  connectivity: HttpToolConnectivity;
  llmProvider: LlmProvider;
  resourceId: Scalars['String']['output'];
  skipSsl: Scalars['Boolean']['output'];
  skipValidateConnectivity: Scalars['Boolean']['output'];
};

export type LlmProvider =
  | 'ANTHROPIC'
  | 'GEMINI'
  | 'MISTRAL'
  | 'OPEN_AI';

/**
 * A recipe project built from source rather than published: the one-off recipe bundle a run cited,
 * which is the zip of the project's build. The run keeps the zip in its changeset at `packageName`,
 * and the fields from `remote` on are what the zip's manifest says built it, each null when the
 * manifest does not say. Only its uploader can cite a bundle, so the run's `user` uploaded it.
 */
export type LocalRecipeBundle = RecipeBundle & {
  __typename?: 'LocalRecipeBundle';
  /** When it was built. */
  builtAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who built it, as the CLI recorded it. */
  builtBy?: Maybe<Scalars['String']['output']>;
  /** The version of the Moderne CLI that built and packed it. */
  cliVersion?: Maybe<Scalars['String']['output']>;
  /** The commit the project was built from. */
  commit?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the project had changes not yet committed when it was built, so that `commit` alone
   * does not reproduce it.
   */
  dirty?: Maybe<Scalars['Boolean']['output']>;
  /** What built the project: `local-maven`, `local-gradle`, `local-npm` or `local-pip`. */
  ecosystem: Scalars['String']['output'];
  /**
   * The id a run cites the bundle by, which `mod config recipes bundle push` printed: the SHA-256
   * of the zip. Null when the run's changeset no longer holds the zip.
   */
  id?: Maybe<Scalars['String']['output']>;
  /**
   * Where the run's working set holds the zip, relative to the working set, such as
   * `.moderne/recipes/rewrite-spring.zip`.
   */
  packageName: Scalars['String']['output'];
  recipeCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The git remote the project's branch tracked, without credentials. A recipe fixed on a
   * changeset tracks that changeset's copy of its repository,
   * `<api>/changeset/<changeset id>/.moderne/recipes/<project>.git`.
   */
  remote?: Maybe<Scalars['String']['output']>;
  requestedVersion?: Maybe<Scalars['String']['output']>;
  /** The version of OpenRewrite it was built with. */
  rewriteVersion?: Maybe<Scalars['String']['output']>;
  /** A hash of the project's source, which the CLI versions a local project's recipes by. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * The LST artifact for a repository - the precomputed Lossless Semantic Tree
 * that recipe runs consume. Every repository has a conceptual artifact;
 * `published` reflects the upstream `mod publish` timestamp, while
 * `available` indicates whether the saas can route a recipe run to it yet.
 */
export type LstArtifact = {
  __typename?: 'LstArtifact';
  /**
   * Whether the artifact is reachable for a recipe run: true when the row has a
   * non-empty `publishUri` and no `enrichFailedReason`. A failed enrichment
   * preserves the publishUri as a diagnostic, so it is not evidence of
   * reachability; and a row whose LST has not been ingested yet arrives here with
   * its publishUri already withheld by the gateway projection.
   */
  available: Scalars['Boolean']['output'];
  /**
   * When the connector failed to enrich this row, the free-form reason it
   * recorded; null otherwise.
   */
  enrichFailedReason?: Maybe<Scalars['String']['output']>;
  /**
   * When `mod publish` produced an artifact into the customer's LST artifact
   * repository, or null if no artifact has been published. A non-null
   * `published` does NOT mean the artifact is reachable for a recipe run - that
   * signal lives on `available`.
   */
  published?: Maybe<Scalars['DateTime']['output']>;
};

export type LstArtifactWhereInput = {
  _and?: InputMaybe<Array<LstArtifactWhereInput>>;
  _not?: InputMaybe<LstArtifactWhereInput>;
  _or?: InputMaybe<Array<LstArtifactWhereInput>>;
  available?: InputMaybe<BooleanFilter>;
  published?: InputMaybe<DateTimeFilter>;
};

export type Marker = {
  id: Scalars['ID']['output'];
};

export type Markup = Marker & {
  __typename?: 'Markup';
  detail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level: MarkupLevel;
  message?: Maybe<Scalars['String']['output']>;
  /** The instance name, with options, of the recipe that added this markup; null when recipeName is. */
  recipeInstanceName?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the recipe that added this markup, the same value as RecipeDescriptor.id; null when
   * unknown, including for results recorded before markup carried its recipe.
   */
  recipeName?: Maybe<Scalars['String']['output']>;
};

export type MarkupLevel =
  | 'DEBUG'
  | 'ERROR'
  | 'INFO'
  | 'NONE'
  | 'WARNING';

export type MavenConfiguration = {
  __typename?: 'MavenConfiguration';
  /** True when this repo is polled for LST artifacts. */
  artifactSource: Scalars['Boolean']['output'];
  connectivity: HttpToolConnectivity;
  lastIngestedAt?: Maybe<Scalars['DateTime']['output']>;
  localRepository?: Maybe<Scalars['String']['output']>;
  /** True when this repo feeds recipes to the marketplace. */
  recipeSource: Scalars['Boolean']['output'];
  resourceId: Scalars['String']['output'];
  skipSsl: Scalars['Boolean']['output'];
  skipValidateConnectivity: Scalars['Boolean']['output'];
};

export type MavenRecipeBundle = RecipeBundle & {
  __typename?: 'MavenRecipeBundle';
  artifactId: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  packageName: Scalars['String']['output'];
  recipeCount?: Maybe<Scalars['Int']['output']>;
  requestedVersion?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * 256-char / non-blank limits mirror moderne-ui, closing the client-only bypass (#1462).
 * YAML left unbounded — composite Builder recipes can be large.
 */
export type MavenRecipeBundleInput = {
  artifactId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type MergeMethod =
  | 'MERGE'
  | 'REBASE'
  | 'SQUASH';

export type MergeOptions = {
  __typename?: 'MergeOptions';
  deleteSourceBranch: Scalars['Boolean']['output'];
  mergeMethod: MergeMethod;
};

export type Mergeable =
  | 'BLOCKED'
  | 'MERGEABLE'
  | 'UNKNOWN';

export type Message = {
  id: Scalars['ID']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  state: MessageState;
  user: User;
};

/** The git repository the team talks in: a message is a file, in a directory named for its topic. */
export type MessageBoard = {
  __typename?: 'MessageBoard';
  /** What `git clone` takes. It authenticates like the changeset's other remotes. */
  cloneUrl: Scalars['String']['output'];
  /** The messages in the order they were posted. */
  messages: MessageBoardMessageConnection;
  /**
   * The whole board as one PDF, rendered when the link is opened. The link is signed, so it
   * needs no Authorization header, and it expires 15 minutes after it is handed out.
   */
  pdfUrl: Scalars['String']['output'];
  /** The topics, in the order each was first posted to. */
  topics: Array<Scalars['String']['output']>;
};


/** The git repository the team talks in: a message is a file, in a directory named for its topic. */
export type MessageBoardMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MessageBoardMessageWhereInput>;
};

export type MessageBoardMessage = {
  __typename?: 'MessageBoardMessage';
  /**
   * The agent that posted it. Null for a message from outside any agent's work, such as one
   * from a person steering the team.
   */
  agent?: Maybe<Agent>;
  id: Scalars['ID']['output'];
  message: Scalars['Markdown']['output'];
  postedAt: Scalars['DateTime']['output'];
  topic: Scalars['String']['output'];
};

export type MessageBoardMessageConnection = {
  __typename?: 'MessageBoardMessageConnection';
  count: Scalars['Int']['output'];
  edges: Array<MessageBoardMessageEdge>;
  pageInfo: PageInfo;
};

export type MessageBoardMessageEdge = {
  __typename?: 'MessageBoardMessageEdge';
  cursor: Scalars['String']['output'];
  node: MessageBoardMessage;
};

export type MessageBoardMessageWhereInput = {
  /** The id of the agent that posted. */
  agent?: InputMaybe<IdFilter>;
  topic?: InputMaybe<StringFilter>;
};

/**
 * -----------------------------------------------------------------------------
 * Message pagination
 * -----------------------------------------------------------------------------
 */
export type MessageConnection = {
  __typename?: 'MessageConnection';
  edges: Array<MessageEdge>;
  pageInfo: PageInfo;
};

export type MessageEdge = {
  __typename?: 'MessageEdge';
  cursor: Scalars['String']['output'];
  node: Message;
};

/**
 * -----------------------------------------------------------------------------
 * Messages
 * The chatbot User uses email "moddy@moderne.io" by convention.
 * -----------------------------------------------------------------------------
 */
export type MessageState =
  | 'COMPLETED'
  | 'IN_PROGRESS';

/**
 * -----------------------------------------------------------------------------
 * Moddy (entry point, like RecipeMarketplace)
 * -----------------------------------------------------------------------------
 */
export type Moddy = {
  __typename?: 'Moddy';
  /**
   * When true, only administrators can create conversations or send messages.
   * Install-level policy flag; the UI uses this together with the viewer's admin
   * status to gate the Moddy menu entry.
   */
  adminOnly: Scalars['Boolean']['output'];
  conversations: ConversationConnection;
  /**
   * Configured model identifier (e.g. "claude-opus-5-5"). Null
   * when no provider is configured or the provider is configured without a
   * model override.
   */
  model?: Maybe<Scalars['String']['output']>;
  /**
   * Human-readable provider name (e.g. "Anthropic", "OpenAI"). Null when
   * no LLM provider is configured (in which case `capabilities.moddy` is
   * also false — clients should gate the chat composer on the capability,
   * not on this field).
   */
  providerName?: Maybe<Scalars['String']['output']>;
  /**
   * The effective system prompt for this context.
   * Cascades: user > organization > universal > built-in default.
   */
  systemPrompt: Prompt;
};


/**
 * -----------------------------------------------------------------------------
 * Moddy (entry point, like RecipeMarketplace)
 * -----------------------------------------------------------------------------
 */
export type ModdyConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConversationOrderByInput>>;
  where?: InputMaybe<ConversationWhereInput>;
};

export type MoreHelpLink = {
  __typename?: 'MoreHelpLink';
  label: Scalars['String']['output'];
  uri: Scalars['String']['output'];
};

/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type Mutation = {
  __typename?: 'Mutation';
  /** Approve pull requests in bulk. Returns the queued action for polling. */
  approveChangelogPullRequests: ChangelogBulkPullRequestActionQueued;
  /**
   * Approve, in bulk, the pull requests the committer created from a changeset.
   * Pass `commitId` and/or `repositories` to limit the action to one commit job
   * or a subset of the changeset's repositories; omit both to target every pull
   * request in the changeset. Returns the queued action for polling (also
   * surfaces under `OrganizationChangeset.bulkPullRequestActions`).
   */
  approvePullRequests: BulkPullRequestActionQueued;
  /** Cancel a pending bulk pull request action. */
  cancelBulkPullRequestAction: BulkPullRequestActionCanceled;
  /** Cancel a pending bulk pull request action. */
  cancelChangelogBulkPullRequestAction: ChangelogBulkPullRequestActionCanceled;
  /** Cancel a running commit operation. */
  cancelCommit: OrganizationCommitCanceled;
  /** Cancel a DevCenter run. Cancellation is best-effort and asynchronous. */
  cancelDevCenterRun: Scalars['ID']['output'];
  /**
   * Interrupt the currently-running turn for a conversation. The virtual
   * thread driving the turn is interrupted — a blocking LLM stream unwinds
   * immediately, and long-running downstream work (recipe runs) receives
   * a best-effort cancel via `cancelRecipeRun` on recipe-worker. Cheap
   * tool calls finish naturally. A terminal CANCELLED `ErrorMessage` is
   * appended to the log regardless.
   *
   * LLM-memory consistency on the next turn is preserved by the JSONL
   * collapse: `buildChatMessages` pairs every tool-origin row into an
   * `AiMessage(toolRequests)` + `ToolExecutionResultMessage` batch, and
   * only rows that actually persisted are rebuilt — partially-executed
   * tool batches are reconstructed from whichever tool-origin rows made
   * it to the log.
   *
   * Returns {@code true} when a running turn was actually interrupted,
   * {@code false} when the conversation was already idle (no-op, not an
   * error). {@code messageId} is accepted for client compatibility but
   * only the conversation's active turn is cancellable — there is never
   * more than one turn in flight.
   */
  cancelMessage: Scalars['Boolean']['output'];
  /** Cancel a recipe run. Cancellation is best-effort and asynchronous. */
  cancelRecipeRun: Scalars['ID']['output'];
  /** Clear the organization-level prompt override, falling back to universal. Admin-only — an organization prompt steers Moddy for every member of that org. */
  clearOrganizationPrompt: Scalars['Boolean']['output'];
  /** Clear the current user's prompt override, falling back to organization or universal. */
  clearUserPrompt: Scalars['Boolean']['output'];
  /** Close pull requests in bulk. Returns the queued action for polling. */
  closeChangelogPullRequests: ChangelogBulkPullRequestActionQueued;
  /**
   * Close, in bulk, the pull requests the committer created from a changeset.
   * Returns the queued action for polling.
   */
  closePullRequests: BulkPullRequestActionQueued;
  /** Create commits from a changeset (recipe run, batch change, etc.). */
  commit: OrganizationCommitQueued;
  /**
   * Creates a new Moderne Personal Access Token for the current user.
   * Returns the token value only once - it cannot be retrieved again.
   */
  createAccessToken: CreateAccessTokenResult;
  /**
   * Create a new conversation and send the first message. Uses the
   * effective prompt for the organization context. `waitForCompletion`
   * has the same semantics as on `sendMessage`.
   */
  createConversation: SendMessageResult;
  /** Create a new user-defined organization visible only to the current user. */
  createUserOrganization: Organization;
  /**
   * Deletes a user and all associated access tokens.
   * Returns true if the user was found and deleted.
   */
  deleteUser: Scalars['Boolean']['output'];
  /** Delete a user-defined organization. */
  deleteUserOrganization: Scalars['Boolean']['output'];
  /**
   * Start an asynchronous export of audit logs. Returns a task whose state
   * can be polled via auditLogsDownloads.
   */
  downloadAuditLogs: AuditLogsDownload;
  /**
   * Start or retrieve a data table download.
   * If the same data table + group + format combination was already requested,
   * returns the existing download state.
   */
  downloadDataTable: DataTable;
  /**
   * Exchange an OAuth authorization code for an access token.
   *
   * This unified mutation handles all OAuth 2.0 VCS providers.
   * The backend uses the authorizationId to look up:
   * - The origin and VCS type
   * - PKCE code_verifier (GitLab)
   *
   * On success, the token is stored and future requests will be authenticated.
   */
  exchangeAuthorizationCode: ExchangeAuthorizationResult;
  /**
   * Initiate OAuth authorization for a VCS origin.
   * Returns an authorization URL to redirect the user to.
   *
   * The backend constructs the full OAuth URL including:
   * - PKCE code_challenge for GitLab
   * - Correct scopes for each VCS type
   * - State parameter for CSRF protection
   *
   * The authorization ID should be passed to exchangeAuthorizationCode
   * after the user completes OAuth.
   */
  initiateAuthorization: OAuthAuthorization;
  /** Install a recipe bundle to the current user's personal marketplace. */
  installRecipesForCurrentUser: RecipeInstallation;
  /**
   * Install a recipe bundle to a specific organization's marketplace.
   * Requires the `admin` role.
   */
  installRecipesForOrganization: RecipeInstallation;
  /**
   * Install a recipe bundle to the universal marketplace (visible to all).
   * Requires the `admin` role.
   */
  installRecipesUniversal: RecipeInstallation;
  /** Merge pull requests in bulk. Returns the queued action for polling. */
  mergeChangelogPullRequests: ChangelogBulkPullRequestActionQueued;
  /**
   * Merge, in bulk, the pull requests the committer created from a changeset.
   * Returns the queued action for polling.
   */
  mergePullRequests: BulkPullRequestActionQueued;
  /**
   * Rediscovers which repositories users can read on their connected SCMs, as the nightly refresh
   * does: only this user's connections when `email` is given, every user's otherwise. Runs in the
   * background beside the answers it replaces, and returns how many SCM connections it covers.
   */
  refreshRepositoryAccess: Scalars['Int']['output'];
  /**
   * Reset poll cursors so the next poll cycle re-fetches and re-enriches
   * changelog entries from the given timestamp forward. Use this to backfill
   * data after deploying enrichment improvements.
   *
   * Admin-only: that re-fetch and re-enrichment is expensive and its
   * enrichment calls hit SCM REST APIs (pull-request and build-state
   * lookups), so this must not be reachable by unauthenticated or non-admin
   * callers.
   */
  reindexChangelog: ReindexResult;
  /**
   * Assemble repositories into the index again at the commits it holds them at, so that it takes in
   * an LST rebuilt at an unchanged commit, as a newer CLI rebuilds one; the index never asks again
   * for a commit it holds. Each shard holding one of them is rewritten with every repository of it
   * that repos.csv still names, and goes once newer shards hold them. It answers until then, so no
   * search sees a repository twice or not at all.
   *
   * Admin-only: each rewritten shard reads every LST it holds again, about 60, so the shards one
   * reindex may touch are capped by `moderne.code-search.reindex-max-shards`.
   */
  reindexCodeSearch: CodeSearchReindexResult;
  /**
   * Revokes an access token by ID.
   * Returns true if the token was revoked, false if not found.
   */
  revokeAccessToken: Scalars['Boolean']['output'];
  /**
   * Revokes all access tokens for a given user.
   * Returns true if all token were revoked, otherwise false.
   */
  revokeAllAccessTokens: Scalars['Boolean']['output'];
  /**
   * Revoke an SCM OAuth token for the current user and a specific origin.
   * This removes the stored token, disconnecting the user from the VCS.
   */
  revokeScmToken: RevokeTokenResult;
  /**
   * Start a DevCenter run for an organization.
   * Returns immediately with running status.
   */
  runDevCenter: DevCenterRunRunning;
  /**
   * Run a recipe against repositories.
   * Returns the recipe run in its initial queued state.
   */
  runRecipe: OrganizationRecipeRunQueued;
  /**
   * Request a visualization to be generated based on the provided descriptor.
   * Returns the existing visualization if already run with the same options,
   * otherwise queues a new visualization run.
   */
  runVisualization: Visualization;
  /**
   * Send a message to an existing conversation. Returns a handle for
   * polling — `initialCursor` is the cursor to pass to the next
   * `messages(after:)` query, and `turnState` carries the server-
   * recommended poll cadence.
   *
   * When `waitForCompletion: true`, the mutation blocks until the turn
   * completes (or the server cap of 4 minutes is reached, whichever comes
   * first). On cap, the mutation returns the current turn state rather
   * than erroring so the caller can continue polling.
   */
  sendMessage: SendMessageResult;
  /** Set the system prompt for a specific organization (overrides universal). Admin-only — an organization prompt steers Moddy for every member of that org. */
  setOrganizationPrompt: Prompt;
  /**
   * Turn continuous profiling on or off for this tenant. When enabled,
   * Pyroscope profiles for every service start landing in the Pyroscope UI
   * within seconds. The primary event the agent samples on is selected by
   * `event` (defaults to WALL); calling the mutation again with a different
   * event while profiling is already on rotates the agent to the new event.
   * Fails when the profiling capability is not enabled for the tenant.
   * Admin role required.
   */
  setProfiling: Scalars['Boolean']['output'];
  /** Set the universal (default) system prompt. Admin-only — the universal prompt steers Moddy tenant-wide. */
  setUniversalPrompt: Prompt;
  /** Set the system prompt for the current user (overrides organization and universal). */
  setUserPrompt: Prompt;
  /**
   * Uninstall a bundle from the current user's personal marketplace, identified by
   * package name or by a recipe id it provides (see `RecipeUninstallSelector`).
   * Returns the number of recipes removed (0 if nothing matched).
   */
  uninstallRecipesFromCurrentUser: RecipeUninstallation;
  /**
   * Uninstall a recipe bundle from a specific organization's marketplace.
   * Returns the number of recipes that were removed.
   * Requires the `admin` role.
   */
  uninstallRecipesFromOrganization: RecipeUninstallation;
  /**
   * Uninstall a recipe bundle from the universal marketplace.
   * Returns the number of recipes that were removed.
   * Requires the `admin` role.
   */
  uninstallRecipesUniversal: RecipeUninstallation;
  /** Update an existing user-defined organization. */
  updateUserOrganization: Organization;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationApproveChangelogPullRequestsArgs = {
  organizationId: Scalars['ID']['input'];
  selection: PullRequestSelectionInput;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationApprovePullRequestsArgs = {
  changesetId: Scalars['ID']['input'];
  commitId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  repositories?: InputMaybe<Array<RepositoryInput>>;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationCancelBulkPullRequestActionArgs = {
  id: Scalars['ID']['input'];
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationCancelChangelogBulkPullRequestActionArgs = {
  id: Scalars['ID']['input'];
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationCancelCommitArgs = {
  id: Scalars['ID']['input'];
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationCancelDevCenterRunArgs = {
  id: Scalars['ID']['input'];
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationCancelMessageArgs = {
  conversationId: Scalars['ID']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationCancelRecipeRunArgs = {
  id: Scalars['ID']['input'];
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationClearOrganizationPromptArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationCloseChangelogPullRequestsArgs = {
  organizationId: Scalars['ID']['input'];
  selection: PullRequestSelectionInput;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationClosePullRequestsArgs = {
  changesetId: Scalars['ID']['input'];
  commitId?: InputMaybe<Scalars['ID']['input']>;
  deleteSourceBranch?: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
  repositories?: InputMaybe<Array<RepositoryInput>>;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationCommitArgs = {
  input: CommitInput;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationCreateAccessTokenArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationCreateConversationArgs = {
  input: CreateConversationInput;
  waitForCompletion?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationCreateUserOrganizationArgs = {
  input: CreateUserOrganizationInput;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationDeleteUserArgs = {
  email: Scalars['String']['input'];
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationDeleteUserOrganizationArgs = {
  id: Scalars['ID']['input'];
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationDownloadAuditLogsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  format: AuditLogExportFormat;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationDownloadDataTableArgs = {
  changesetId: Scalars['ID']['input'];
  dataTable: Scalars['String']['input'];
  format: DataTableFormat;
  group?: InputMaybe<Scalars['String']['input']>;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationExchangeAuthorizationCodeArgs = {
  input: ExchangeAuthorizationCodeInput;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationInitiateAuthorizationArgs = {
  input: InitiateAuthorizationInput;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationInstallRecipesForCurrentUserArgs = {
  bundle: RecipeBundleInput;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationInstallRecipesForOrganizationArgs = {
  bundle: RecipeBundleInput;
  organizationId: Scalars['ID']['input'];
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationInstallRecipesUniversalArgs = {
  bundle: RecipeBundleInput;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationMergeChangelogPullRequestsArgs = {
  deleteSourceBranch?: Scalars['Boolean']['input'];
  mergeMethod: MergeMethod;
  organizationId: Scalars['ID']['input'];
  selection: PullRequestSelectionInput;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationMergePullRequestsArgs = {
  changesetId: Scalars['ID']['input'];
  commitId?: InputMaybe<Scalars['ID']['input']>;
  deleteSourceBranch?: Scalars['Boolean']['input'];
  mergeMethod: MergeMethod;
  organizationId: Scalars['ID']['input'];
  repositories?: InputMaybe<Array<RepositoryInput>>;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationRefreshRepositoryAccessArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationReindexChangelogArgs = {
  origin?: InputMaybe<Scalars['String']['input']>;
  since: Scalars['DateTime']['input'];
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationReindexCodeSearchArgs = {
  organizationId: Scalars['ID']['input'];
  repositories?: InputMaybe<Array<RepositoryInput>>;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationRevokeAccessTokenArgs = {
  id: Scalars['ID']['input'];
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationRevokeAllAccessTokensArgs = {
  email: Scalars['String']['input'];
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationRevokeScmTokenArgs = {
  input: RevokeScmTokenInput;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationRunDevCenterArgs = {
  input: RunDevCenterInput;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationRunRecipeArgs = {
  input: RunRecipeInput;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationRunVisualizationArgs = {
  options?: InputMaybe<Array<VisualizationOptionInput>>;
  organizationId: Scalars['ID']['input'];
  visualizationId: Scalars['ID']['input'];
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationSendMessageArgs = {
  conversationId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  waitForCompletion?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationSetOrganizationPromptArgs = {
  content: Scalars['Markdown']['input'];
  organizationId: Scalars['ID']['input'];
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationSetProfilingArgs = {
  enabled: Scalars['Boolean']['input'];
  event?: InputMaybe<ProfilingEvent>;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationSetUniversalPromptArgs = {
  content: Scalars['Markdown']['input'];
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationSetUserPromptArgs = {
  content: Scalars['Markdown']['input'];
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationUninstallRecipesFromCurrentUserArgs = {
  by: RecipeUninstallSelector;
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationUninstallRecipesFromOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
  packageName: Scalars['String']['input'];
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationUninstallRecipesUniversalArgs = {
  packageName: Scalars['String']['input'];
};


/**
 * -----------------------------------------------------------------------------
 * Mutations
 * -----------------------------------------------------------------------------
 */
export type MutationUpdateUserOrganizationArgs = {
  input: UpdateUserOrganizationInput;
};

export type NpmConfiguration = {
  __typename?: 'NpmConfiguration';
  connectivity: HttpToolConnectivity;
  resourceId: Scalars['String']['output'];
  skipSsl: Scalars['Boolean']['output'];
  skipValidateConnectivity: Scalars['Boolean']['output'];
};

export type NpmRecipeBundle = RecipeBundle & {
  __typename?: 'NpmRecipeBundle';
  packageName: Scalars['String']['output'];
  recipeCount?: Maybe<Scalars['Int']['output']>;
  requestedVersion?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type NpmRecipeBundleInput = {
  packageName: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type NugetConfiguration = {
  __typename?: 'NugetConfiguration';
  connectivity: HttpToolConnectivity;
  resourceId: Scalars['String']['output'];
  skipSsl: Scalars['Boolean']['output'];
  skipValidateConnectivity: Scalars['Boolean']['output'];
};

export type NugetRecipeBundle = RecipeBundle & {
  __typename?: 'NugetRecipeBundle';
  packageName: Scalars['String']['output'];
  recipeCount?: Maybe<Scalars['Int']['output']>;
  requestedVersion?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type NugetRecipeBundleInput = {
  packageName: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/**
 * Represents a pending OAuth authorization.
 * The UI should redirect to authorizationUrl, then call exchangeAuthorizationCode
 * with the id and extracted callback parameters.
 */
export type OAuthAuthorization = {
  __typename?: 'OAuthAuthorization';
  /**
   * The fully-constructed OAuth authorization URL.
   * UI should redirect the user to this URL.
   *
   * IMPORTANT: The UI must store the authorization ID before redirecting,
   * as it will be needed to call exchangeAuthorizationCode after the callback.
   * The redirect URI does not contain the authorization ID.
   */
  authorizationUrl: Scalars['String']['output'];
  /**
   * Query parameters the UI should extract from the OAuth callback URL
   * and pass to exchangeAuthorizationCode (e.g., ["code"]).
   */
  callbackParameters: Array<Scalars['String']['output']>;
  /** When this authorization expires. UI should treat expired authorizations as stale. */
  expiresAt: Scalars['DateTime']['output'];
  /**
   * Unique ID for this authorization attempt.
   * Used to look up stored PKCE state at exchange time.
   */
  id: Scalars['ID']['output'];
};

/**
 * RecipeDescriptor resolved from changeset-specific recipes.csv.
 * When a recipe run is created, the recipes.csv is copied to the changeset directory,
 * so we can resolve the recipe that was used at the time of the run (not the current global state).
 */
export type Option = {
  __typename?: 'Option';
  description: Scalars['String']['output'];
  /**  FIXME make this an enum? */
  displayName: Scalars['String']['output'];
  example?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  valid?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  value?: Maybe<Scalars['Object']['output']>;
};

/**
 * Stub for Organization - owned by organization service
 * Note: Subgraphs that extend Organization should use "extend type Organization" syntax
 */
export type Organization = {
  __typename?: 'Organization';
  /** PR and commit activity feed for repositories in this organization. */
  changelog: ChangelogEntryConnection;
  changesets: OrganizationChangesetConnection;
  /**
   * Direct children of this organization in the tree, paginated.
   * Useful for lazy-loading the org tree level by level — e.g. an org
   * selector that fetches the root, then the children of each folder
   * only when the user expands it.
   *
   * `where.depth` is ignored on this field — every direct child of a
   * given parent has the same depth, so the filter would be either
   * all-or-nothing. Use `where.name` and the boolean composers
   * (`_and`, `_or`, `_not`) for meaningful filtering.
   *
   * `orderBy` defaults to NAME ascending when unspecified.
   */
  children: OrganizationConnection;
  /** Commit options available in this tenant. */
  commitOptions: Array<CommitOption>;
  /** DevCenter provides organization-wide campaign progress tracking. */
  devCenter?: Maybe<DevCenter>;
  id: Scalars['ID']['output'];
  marketplace?: Maybe<RecipeMarketplace>;
  moddy: Moddy;
  name: Scalars['String']['output'];
  /**
   * The ancestor organizations of this organization, ordered from immediate parent towards root.
   * Does not include the epsilon root. Empty for the root organization and direct children of root.
   */
  parents: Array<Organization>;
  /**
   * All unique participants across the changelog for this organization,
   * aggregated from authors, assignees, closers, and reviewers.
   */
  participants: ChangelogParticipantConnection;
  repositories: RepositoryConnection;
  /**
   * The user who owns this organization. Null for global organizations,
   * non-null for user-defined organizations.
   */
  user?: Maybe<User>;
};


/**
 * Stub for Organization - owned by organization service
 * Note: Subgraphs that extend Organization should use "extend type Organization" syntax
 */
export type OrganizationChangelogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogEntryOrderByInput>>;
  where?: InputMaybe<ChangelogEntryWhereInput>;
};


/**
 * Stub for Organization - owned by organization service
 * Note: Subgraphs that extend Organization should use "extend type Organization" syntax
 */
export type OrganizationChangesetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationChangesetOrderByInput>>;
  where?: InputMaybe<OrganizationChangesetWhereInput>;
};


/**
 * Stub for Organization - owned by organization service
 * Note: Subgraphs that extend Organization should use "extend type Organization" syntax
 */
export type OrganizationChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationOrderByInput>>;
  where?: InputMaybe<OrganizationWhereInput>;
};


/**
 * Stub for Organization - owned by organization service
 * Note: Subgraphs that extend Organization should use "extend type Organization" syntax
 */
export type OrganizationParticipantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogParticipantOrderByInput>>;
  where?: InputMaybe<ChangelogParticipantWhereInput>;
};


/**
 * Stub for Organization - owned by organization service
 * Note: Subgraphs that extend Organization should use "extend type Organization" syntax
 */
export type OrganizationRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepositoryOrderByInput>>;
  where?: InputMaybe<RepositoryWhereInput>;
};

/**
 * An organization-wide changeset represents code changes or search results across multiple
 * repositories: a recipe run (OrganizationRecipeRun*), a revision that began by push
 * (OrganizationRevision), or a code search that was saved (OrganizationSearch). Any kind is
 * revised by the agents reviewing it, whose pushes become each repository's newest change.
 *
 * Note: This is a shared interface definition. Subgraphs that need to resolve this
 * interface must define the implementation types.
 */
export type OrganizationChangeset = {
  /** Bulk pull request actions (approve, merge, close) launched from this changeset. */
  bulkPullRequestActions: BulkPullRequestActionConnection;
  /**
   * Bulk pull request actions (approve, merge, close) initiated against pull
   * requests that belong to this changeset.
   *
   * Default sort: STARTED_AT DESC with QUEUED entries (no startedAt) appearing
   * last so polling clients still see in-flight actions.
   */
  changelogBulkPullRequestActions: ChangelogBulkPullRequestActionConnection;
  /** Commit operations initiated from this changeset. */
  commits?: Maybe<OrganizationCommitConnection>;
  createdAt: Scalars['DateTime']['output'];
  /**
   * Data tables produced by this recipe run.
   * Each data table starts as Available and transitions to Processing/Finished/Error
   * when downloadDataTable mutation is called.
   */
  dataTables: DataTableConnection;
  id: Scalars['ID']['output'];
  /**
   * What the changeset is called: a recipe run's instance name, what its first push named it, or
   * the name a saved search was given, its query when it was given none.
   */
  name: Scalars['String']['output'];
  /**
   * Each repository of the changeset at its newest change: a RepositoryRevision where one was
   * pushed, else what the recipe run left or what the saved search found.
   */
  repositories: RepositoryChangesetConnection;
  /**
   * The agents working on the changeset as one team: who they are, what they said to each
   * other, and the recipes they fixed. Null until an agent joins, which for a recipe run is
   * after the run is terminal and for a saved search after its sweep has ended, since neither
   * can be checked out before then.
   */
  review?: Maybe<AgentTeamReview>;
  user: User;
  /**
   * Visualizations produced by this changeset.
   * Each visualization starts as Available and transitions to Processing/Finished/Error
   * when runVisualization mutation is called.
   */
  visualizations: VisualizationConnection;
};


/**
 * An organization-wide changeset represents code changes or search results across multiple
 * repositories: a recipe run (OrganizationRecipeRun*), a revision that began by push
 * (OrganizationRevision), or a code search that was saved (OrganizationSearch). Any kind is
 * revised by the agents reviewing it, whose pushes become each repository's newest change.
 *
 * Note: This is a shared interface definition. Subgraphs that need to resolve this
 * interface must define the implementation types.
 */
export type OrganizationChangesetBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<BulkPullRequestActionWhereInput>;
};


/**
 * An organization-wide changeset represents code changes or search results across multiple
 * repositories: a recipe run (OrganizationRecipeRun*), a revision that began by push
 * (OrganizationRevision), or a code search that was saved (OrganizationSearch). Any kind is
 * revised by the agents reviewing it, whose pushes become each repository's newest change.
 *
 * Note: This is a shared interface definition. Subgraphs that need to resolve this
 * interface must define the implementation types.
 */
export type OrganizationChangesetChangelogBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogBulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<ChangelogBulkPullRequestActionWhereInput>;
};


/**
 * An organization-wide changeset represents code changes or search results across multiple
 * repositories: a recipe run (OrganizationRecipeRun*), a revision that began by push
 * (OrganizationRevision), or a code search that was saved (OrganizationSearch). Any kind is
 * revised by the agents reviewing it, whose pushes become each repository's newest change.
 *
 * Note: This is a shared interface definition. Subgraphs that need to resolve this
 * interface must define the implementation types.
 */
export type OrganizationChangesetCommitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationCommitOrderByInput>>;
  where?: InputMaybe<OrganizationCommitWhereInput>;
};


/**
 * An organization-wide changeset represents code changes or search results across multiple
 * repositories: a recipe run (OrganizationRecipeRun*), a revision that began by push
 * (OrganizationRevision), or a code search that was saved (OrganizationSearch). Any kind is
 * revised by the agents reviewing it, whose pushes become each repository's newest change.
 *
 * Note: This is a shared interface definition. Subgraphs that need to resolve this
 * interface must define the implementation types.
 */
export type OrganizationChangesetDataTablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataTableOrderByInput>>;
  where?: InputMaybe<DataTableWhereInput>;
};


/**
 * An organization-wide changeset represents code changes or search results across multiple
 * repositories: a recipe run (OrganizationRecipeRun*), a revision that began by push
 * (OrganizationRevision), or a code search that was saved (OrganizationSearch). Any kind is
 * revised by the agents reviewing it, whose pushes become each repository's newest change.
 *
 * Note: This is a shared interface definition. Subgraphs that need to resolve this
 * interface must define the implementation types.
 */
export type OrganizationChangesetRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepositoryChangesetOrderByInput>>;
  where?: InputMaybe<RepositoryChangesetWhereInput>;
};


/**
 * An organization-wide changeset represents code changes or search results across multiple
 * repositories: a recipe run (OrganizationRecipeRun*), a revision that began by push
 * (OrganizationRevision), or a code search that was saved (OrganizationSearch). Any kind is
 * revised by the agents reviewing it, whose pushes become each repository's newest change.
 *
 * Note: This is a shared interface definition. Subgraphs that need to resolve this
 * interface must define the implementation types.
 */
export type OrganizationChangesetVisualizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VisualizationOrderByInput>>;
  where?: InputMaybe<VisualizationWhereInput>;
};

/**
 * -----------------------------------------------------------------------------
 * Organization Changeset Connection
 * -----------------------------------------------------------------------------
 */
export type OrganizationChangesetConnection = {
  __typename?: 'OrganizationChangesetConnection';
  count: Scalars['Int']['output'];
  edges: Array<OrganizationChangesetEdge>;
  pageInfo: PageInfo;
};

export type OrganizationChangesetEdge = {
  __typename?: 'OrganizationChangesetEdge';
  cursor: Scalars['String']['output'];
  node: OrganizationChangeset;
  /**
   * The organization this changeset was run against.
   * May differ from the queried organization when the changeset belongs to a suborganization.
   * Null if the organization has been deleted or is temporarily unavailable.
   */
  organization?: Maybe<Organization>;
};

export type OrganizationChangesetOrderByField =
  | 'CREATED_AT'
  | 'TYPE'
  | 'USER';

export type OrganizationChangesetOrderByInput = {
  direction?: SortOrder;
  field: OrganizationChangesetOrderByField;
};

export type OrganizationChangesetType =
  | 'RECIPE_RUN'
  | 'REVISION'
  | 'SEARCH';

export type OrganizationChangesetTypeFilter = {
  _eq?: InputMaybe<OrganizationChangesetType>;
  _in?: InputMaybe<Array<OrganizationChangesetType>>;
  _neq?: InputMaybe<OrganizationChangesetType>;
  _nin?: InputMaybe<Array<OrganizationChangesetType>>;
};

export type OrganizationChangesetWhereInput = {
  _and?: InputMaybe<Array<OrganizationChangesetWhereInput>>;
  _not?: InputMaybe<OrganizationChangesetWhereInput>;
  _or?: InputMaybe<Array<OrganizationChangesetWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  type?: InputMaybe<OrganizationChangesetTypeFilter>;
  user?: InputMaybe<StringFilter>;
};

/**
 * An organization-level commit operation represents applying changes across multiple
 * repositories. Use `__typename` to determine the current state.
 */
export type OrganizationCommit = {
  /** Extended commit message (Base64 encoded). */
  extendedMessage?: Maybe<Scalars['Base64']['output']>;
  id: Scalars['ID']['output'];
  /** The commit message. */
  message: Scalars['String']['output'];
  /** The commit options (branch, PR settings, etc.). */
  options: CommitOptions;
  /** Paginated results per repository. */
  repositories: RepositoryCommitConnection;
  /** The user who initiated the commit. */
  user: User;
};


/**
 * An organization-level commit operation represents applying changes across multiple
 * repositories. Use `__typename` to determine the current state.
 */
export type OrganizationCommitRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepositoryCommitOrderByInput>>;
  where?: InputMaybe<RepositoryCommitWhereInput>;
};

/** Commit was canceled before completion. */
export type OrganizationCommitCanceled = OrganizationCommit & {
  __typename?: 'OrganizationCommitCanceled';
  /** Who or what initiated the cancellation. */
  canceledBy: User;
  extendedMessage?: Maybe<Scalars['Base64']['output']>;
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  options: CommitOptions;
  /** Paginated results per repository (partial). */
  repositories: RepositoryCommitConnection;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
};


/** Commit was canceled before completion. */
export type OrganizationCommitCanceledRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepositoryCommitOrderByInput>>;
  where?: InputMaybe<RepositoryCommitWhereInput>;
};

export type OrganizationCommitConnection = {
  __typename?: 'OrganizationCommitConnection';
  count: Scalars['Int']['output'];
  edges: Array<OrganizationCommitEdge>;
  pageInfo: PageInfo;
};

export type OrganizationCommitEdge = {
  __typename?: 'OrganizationCommitEdge';
  cursor: Scalars['String']['output'];
  node: OrganizationCommit;
};

/** Commit failed with an error. */
export type OrganizationCommitError = OrganizationCommit & {
  __typename?: 'OrganizationCommitError';
  /** Human-readable error message. */
  errorMessage: Scalars['String']['output'];
  extendedMessage?: Maybe<Scalars['Base64']['output']>;
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  options: CommitOptions;
  /** Paginated results per repository (partial). */
  repositories: RepositoryCommitConnection;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
};


/** Commit failed with an error. */
export type OrganizationCommitErrorRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepositoryCommitOrderByInput>>;
  where?: InputMaybe<RepositoryCommitWhereInput>;
};

/** Commit completed successfully (all or partial success). */
export type OrganizationCommitFinished = OrganizationCommit & {
  __typename?: 'OrganizationCommitFinished';
  extendedMessage?: Maybe<Scalars['Base64']['output']>;
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  options: CommitOptions;
  /** Paginated results per repository. */
  repositories: RepositoryCommitConnection;
  startedAt: Scalars['DateTime']['output'];
  user: User;
};


/** Commit completed successfully (all or partial success). */
export type OrganizationCommitFinishedRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepositoryCommitOrderByInput>>;
  where?: InputMaybe<RepositoryCommitWhereInput>;
};

export type OrganizationCommitOrderByField =
  | 'STARTED_AT';

export type OrganizationCommitOrderByInput = {
  direction?: SortOrder;
  field: OrganizationCommitOrderByField;
};

/** Commit is queued and waiting to be processed. */
export type OrganizationCommitQueued = OrganizationCommit & {
  __typename?: 'OrganizationCommitQueued';
  extendedMessage?: Maybe<Scalars['Base64']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  options: CommitOptions;
  /** Paginated results per repository. */
  repositories: RepositoryCommitConnection;
  /** When a rate-limited commit becomes eligible to resume. Null unless the commit is waiting on an SCM rate limit. */
  retryAfter?: Maybe<Scalars['DateTime']['output']>;
  startedAt: Scalars['DateTime']['output'];
  user: User;
};


/** Commit is queued and waiting to be processed. */
export type OrganizationCommitQueuedRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepositoryCommitOrderByInput>>;
  where?: InputMaybe<RepositoryCommitWhereInput>;
};

/** Commit is actively being processed across repositories. */
export type OrganizationCommitRunning = OrganizationCommit & {
  __typename?: 'OrganizationCommitRunning';
  extendedMessage?: Maybe<Scalars['Base64']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  options: CommitOptions;
  /** Paginated results per repository. */
  repositories: RepositoryCommitConnection;
  startedAt: Scalars['DateTime']['output'];
  user: User;
};


/** Commit is actively being processed across repositories. */
export type OrganizationCommitRunningRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepositoryCommitOrderByInput>>;
  where?: InputMaybe<RepositoryCommitWhereInput>;
};

/** Filter input for organization-level commit queries. */
export type OrganizationCommitWhereInput = {
  /** Logical AND - all conditions must match. */
  _and?: InputMaybe<Array<OrganizationCommitWhereInput>>;
  /** Logical NOT - negates the condition. */
  _not?: InputMaybe<OrganizationCommitWhereInput>;
  /** Logical OR - at least one condition must match. */
  _or?: InputMaybe<Array<OrganizationCommitWhereInput>>;
  /** Filter by commit ID. */
  id?: InputMaybe<IdFilter>;
  /** Filter by when the commit started. */
  startedAt?: InputMaybe<DateTimeFilter>;
};

export type OrganizationConfiguration = {
  __typename?: 'OrganizationConfiguration';
  connectivity: HttpToolConnectivity;
  resourceId: Scalars['String']['output'];
  skipSsl: Scalars['Boolean']['output'];
  skipValidateConnectivity: Scalars['Boolean']['output'];
};

export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  count: Scalars['Int']['output'];
  edges: Array<OrganizationEdge>;
  pageInfo: PageInfo;
};

export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  cursor: Scalars['String']['output'];
  node: Organization;
};

/** The installation lives in a specific organization's marketplace. */
export type OrganizationInstallScope = {
  __typename?: 'OrganizationInstallScope';
  organization: Organization;
};

export type OrganizationOrderByField =
  | 'NAME';

export type OrganizationOrderByInput = {
  direction?: SortOrder;
  field: OrganizationOrderByField;
};

/**
 * OrganizationRecipeRun implements OrganizationChangeset in changesetreader.
 * Federation requires that all concrete implementing types also carry fields
 * added to the interface via @interfaceObject. Mirror the same pattern used
 * by changeset-committer for its `commits` field. The field is @shareable
 * because both the OrganizationChangeset and OrganizationRecipeRun
 * @interfaceObject stubs resolve to the same underlying data.
 */
export type OrganizationRecipeRun = {
  /** Bulk pull request actions (approve, merge, close) launched from this recipe run. */
  bulkPullRequestActions: BulkPullRequestActionConnection;
  /** Bulk pull request actions for recipe-run changesets. */
  changelogBulkPullRequestActions: ChangelogBulkPullRequestActionConnection;
  /** Commit operations initiated from this recipe run. */
  commits?: Maybe<OrganizationCommitConnection>;
  createdAt: Scalars['DateTime']['output'];
  /**
   * Data tables produced by this recipe run.
   * Each data table starts as Available and transitions to Processing/Finished/Error
   * when downloadDataTable mutation is called.
   */
  dataTables: DataTableConnection;
  id: Scalars['ID']['output'];
  /**
   * Monotonic high-water mark advanced by every state writer (sync monitor,
   * run monitor, processor). Treat as a content version: poll a tiny query
   * selecting `__typename` + `lastUpdatedAt` cheaply and only refetch the
   * heavy `repositories`/`totals` selections when this value changes.
   */
  lastUpdatedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  options: Array<RecipeOptionValue>;
  priority: RecipeRunPriority;
  recipe?: Maybe<RecipeDescriptor>;
  repositories: RepositoryChangesetConnection;
  review?: Maybe<AgentTeamReview>;
  /**
   * The changeset the run was kept to, when it was: of its organization's repositories, the run
   * covered only the ones this changeset has results in. Null for a run over the whole organization,
   * and for a viewer who cannot see the changeset.
   */
  scope?: Maybe<OrganizationChangeset>;
  user: User;
  /** Visualizations produced by this recipe run. */
  visualizations: VisualizationConnection;
};


/**
 * OrganizationRecipeRun implements OrganizationChangeset in changesetreader.
 * Federation requires that all concrete implementing types also carry fields
 * added to the interface via @interfaceObject. Mirror the same pattern used
 * by changeset-committer for its `commits` field. The field is @shareable
 * because both the OrganizationChangeset and OrganizationRecipeRun
 * @interfaceObject stubs resolve to the same underlying data.
 */
export type OrganizationRecipeRunBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<BulkPullRequestActionWhereInput>;
};


/**
 * OrganizationRecipeRun implements OrganizationChangeset in changesetreader.
 * Federation requires that all concrete implementing types also carry fields
 * added to the interface via @interfaceObject. Mirror the same pattern used
 * by changeset-committer for its `commits` field. The field is @shareable
 * because both the OrganizationChangeset and OrganizationRecipeRun
 * @interfaceObject stubs resolve to the same underlying data.
 */
export type OrganizationRecipeRunChangelogBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogBulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<ChangelogBulkPullRequestActionWhereInput>;
};


/**
 * OrganizationRecipeRun implements OrganizationChangeset in changesetreader.
 * Federation requires that all concrete implementing types also carry fields
 * added to the interface via @interfaceObject. Mirror the same pattern used
 * by changeset-committer for its `commits` field. The field is @shareable
 * because both the OrganizationChangeset and OrganizationRecipeRun
 * @interfaceObject stubs resolve to the same underlying data.
 */
export type OrganizationRecipeRunCommitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationCommitOrderByInput>>;
  where?: InputMaybe<OrganizationCommitWhereInput>;
};


/**
 * OrganizationRecipeRun implements OrganizationChangeset in changesetreader.
 * Federation requires that all concrete implementing types also carry fields
 * added to the interface via @interfaceObject. Mirror the same pattern used
 * by changeset-committer for its `commits` field. The field is @shareable
 * because both the OrganizationChangeset and OrganizationRecipeRun
 * @interfaceObject stubs resolve to the same underlying data.
 */
export type OrganizationRecipeRunDataTablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataTableOrderByInput>>;
  where?: InputMaybe<DataTableWhereInput>;
};


/**
 * OrganizationRecipeRun implements OrganizationChangeset in changesetreader.
 * Federation requires that all concrete implementing types also carry fields
 * added to the interface via @interfaceObject. Mirror the same pattern used
 * by changeset-committer for its `commits` field. The field is @shareable
 * because both the OrganizationChangeset and OrganizationRecipeRun
 * @interfaceObject stubs resolve to the same underlying data.
 */
export type OrganizationRecipeRunRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepositoryChangesetOrderByInput>>;
  where?: InputMaybe<RepositoryChangesetWhereInput>;
};


/**
 * OrganizationRecipeRun implements OrganizationChangeset in changesetreader.
 * Federation requires that all concrete implementing types also carry fields
 * added to the interface via @interfaceObject. Mirror the same pattern used
 * by changeset-committer for its `commits` field. The field is @shareable
 * because both the OrganizationChangeset and OrganizationRecipeRun
 * @interfaceObject stubs resolve to the same underlying data.
 */
export type OrganizationRecipeRunVisualizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VisualizationOrderByInput>>;
  where?: InputMaybe<VisualizationWhereInput>;
};

export type OrganizationRecipeRunCanceled = OrganizationChangeset & OrganizationRecipeRun & {
  __typename?: 'OrganizationRecipeRunCanceled';
  /** Bulk pull request actions (approve, merge, close) launched from this changeset. */
  bulkPullRequestActions: BulkPullRequestActionConnection;
  /** Alias for finishedAt - when the run was canceled */
  canceledAt: Scalars['DateTime']['output'];
  /**
   * Bulk pull request actions (approve, merge, close) initiated against pull
   * requests that belong to this changeset.
   *
   * Default sort: STARTED_AT DESC with QUEUED entries (no startedAt) appearing
   * last so polling clients still see in-flight actions.
   */
  changelogBulkPullRequestActions: ChangelogBulkPullRequestActionConnection;
  /** Commit operations initiated from this changeset. */
  commits?: Maybe<OrganizationCommitConnection>;
  createdAt: Scalars['DateTime']['output'];
  /**
   * Data tables produced by this recipe run.
   * Each data table starts as Available and transitions to Processing/Finished/Error
   * when downloadDataTable mutation is called.
   */
  dataTables: DataTableConnection;
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /**
   * Monotonic high-water mark advanced by every state writer (sync monitor,
   * run monitor, processor). Treat as a content version: poll a tiny query
   * selecting `__typename` + `lastUpdatedAt` cheaply and only refetch the
   * heavy `repositories`/`totals` selections when this value changes.
   */
  lastUpdatedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  options: Array<RecipeOptionValue>;
  priority: RecipeRunPriority;
  recipe?: Maybe<RecipeDescriptor>;
  repositories: RepositoryChangesetConnection;
  review?: Maybe<AgentTeamReview>;
  /**
   * The changeset the run was kept to, when it was: of its organization's repositories, the run
   * covered only the ones this changeset has results in. Null for a run over the whole organization,
   * and for a viewer who cannot see the changeset.
   */
  scope?: Maybe<OrganizationChangeset>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  /** Visualizations produced by this recipe run. */
  visualizations: VisualizationConnection;
};


export type OrganizationRecipeRunCanceledBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<BulkPullRequestActionWhereInput>;
};


export type OrganizationRecipeRunCanceledChangelogBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogBulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<ChangelogBulkPullRequestActionWhereInput>;
};


export type OrganizationRecipeRunCanceledCommitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationCommitOrderByInput>>;
  where?: InputMaybe<OrganizationCommitWhereInput>;
};


export type OrganizationRecipeRunCanceledDataTablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataTableOrderByInput>>;
  where?: InputMaybe<DataTableWhereInput>;
};


export type OrganizationRecipeRunCanceledRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepositoryChangesetOrderByInput>>;
  where?: InputMaybe<RepositoryChangesetWhereInput>;
};


export type OrganizationRecipeRunCanceledVisualizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VisualizationOrderByInput>>;
  where?: InputMaybe<VisualizationWhereInput>;
};

/**
 * -----------------------------------------------------------------------------
 * Organization Recipe Run Connection
 * -----------------------------------------------------------------------------
 */
export type OrganizationRecipeRunConnection = {
  __typename?: 'OrganizationRecipeRunConnection';
  count: Scalars['Int']['output'];
  edges: Array<OrganizationRecipeRunEdge>;
  pageInfo: PageInfo;
};

export type OrganizationRecipeRunEdge = {
  __typename?: 'OrganizationRecipeRunEdge';
  cursor: Scalars['String']['output'];
  node: OrganizationRecipeRun;
};

export type OrganizationRecipeRunError = OrganizationChangeset & OrganizationRecipeRun & {
  __typename?: 'OrganizationRecipeRunError';
  /** Bulk pull request actions (approve, merge, close) launched from this changeset. */
  bulkPullRequestActions: BulkPullRequestActionConnection;
  /**
   * Bulk pull request actions (approve, merge, close) initiated against pull
   * requests that belong to this changeset.
   *
   * Default sort: STARTED_AT DESC with QUEUED entries (no startedAt) appearing
   * last so polling clients still see in-flight actions.
   */
  changelogBulkPullRequestActions: ChangelogBulkPullRequestActionConnection;
  /** Commit operations initiated from this changeset. */
  commits?: Maybe<OrganizationCommitConnection>;
  createdAt: Scalars['DateTime']['output'];
  /**
   * Data tables produced by this recipe run.
   * Each data table starts as Available and transitions to Processing/Finished/Error
   * when downloadDataTable mutation is called.
   */
  dataTables: DataTableConnection;
  errorMessage?: Maybe<Scalars['String']['output']>;
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /**
   * Monotonic high-water mark advanced by every state writer (sync monitor,
   * run monitor, processor). Treat as a content version: poll a tiny query
   * selecting `__typename` + `lastUpdatedAt` cheaply and only refetch the
   * heavy `repositories`/`totals` selections when this value changes.
   */
  lastUpdatedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  options: Array<RecipeOptionValue>;
  priority: RecipeRunPriority;
  recipe?: Maybe<RecipeDescriptor>;
  repositories: RepositoryChangesetConnection;
  review?: Maybe<AgentTeamReview>;
  /**
   * The changeset the run was kept to, when it was: of its organization's repositories, the run
   * covered only the ones this changeset has results in. Null for a run over the whole organization,
   * and for a viewer who cannot see the changeset.
   */
  scope?: Maybe<OrganizationChangeset>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  /** Visualizations produced by this recipe run. */
  visualizations: VisualizationConnection;
};


export type OrganizationRecipeRunErrorBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<BulkPullRequestActionWhereInput>;
};


export type OrganizationRecipeRunErrorChangelogBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogBulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<ChangelogBulkPullRequestActionWhereInput>;
};


export type OrganizationRecipeRunErrorCommitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationCommitOrderByInput>>;
  where?: InputMaybe<OrganizationCommitWhereInput>;
};


export type OrganizationRecipeRunErrorDataTablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataTableOrderByInput>>;
  where?: InputMaybe<DataTableWhereInput>;
};


export type OrganizationRecipeRunErrorRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepositoryChangesetOrderByInput>>;
  where?: InputMaybe<RepositoryChangesetWhereInput>;
};


export type OrganizationRecipeRunErrorVisualizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VisualizationOrderByInput>>;
  where?: InputMaybe<VisualizationWhereInput>;
};

export type OrganizationRecipeRunFinished = OrganizationChangeset & OrganizationRecipeRun & {
  __typename?: 'OrganizationRecipeRunFinished';
  /** Bulk pull request actions (approve, merge, close) launched from this changeset. */
  bulkPullRequestActions: BulkPullRequestActionConnection;
  /**
   * Bulk pull request actions (approve, merge, close) initiated against pull
   * requests that belong to this changeset.
   *
   * Default sort: STARTED_AT DESC with QUEUED entries (no startedAt) appearing
   * last so polling clients still see in-flight actions.
   */
  changelogBulkPullRequestActions: ChangelogBulkPullRequestActionConnection;
  /** Commit operations initiated from this changeset. */
  commits?: Maybe<OrganizationCommitConnection>;
  createdAt: Scalars['DateTime']['output'];
  /**
   * Data tables produced by this recipe run.
   * Each data table starts as Available and transitions to Processing/Finished/Error
   * when downloadDataTable mutation is called.
   */
  dataTables: DataTableConnection;
  duration?: Maybe<Scalars['Duration']['output']>;
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /**
   * Monotonic high-water mark advanced by every state writer (sync monitor,
   * run monitor, processor). Treat as a content version: poll a tiny query
   * selecting `__typename` + `lastUpdatedAt` cheaply and only refetch the
   * heavy `repositories`/`totals` selections when this value changes.
   */
  lastUpdatedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  options: Array<RecipeOptionValue>;
  priority: RecipeRunPriority;
  recipe?: Maybe<RecipeDescriptor>;
  repositories: RepositoryChangesetConnection;
  review?: Maybe<AgentTeamReview>;
  /**
   * The changeset the run was kept to, when it was: of its organization's repositories, the run
   * covered only the ones this changeset has results in. Null for a run over the whole organization,
   * and for a viewer who cannot see the changeset.
   */
  scope?: Maybe<OrganizationChangeset>;
  startedAt: Scalars['DateTime']['output'];
  totals: RecipeRunTotals;
  user: User;
  /** Visualizations produced by this recipe run. */
  visualizations: VisualizationConnection;
};


export type OrganizationRecipeRunFinishedBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<BulkPullRequestActionWhereInput>;
};


export type OrganizationRecipeRunFinishedChangelogBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogBulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<ChangelogBulkPullRequestActionWhereInput>;
};


export type OrganizationRecipeRunFinishedCommitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationCommitOrderByInput>>;
  where?: InputMaybe<OrganizationCommitWhereInput>;
};


export type OrganizationRecipeRunFinishedDataTablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataTableOrderByInput>>;
  where?: InputMaybe<DataTableWhereInput>;
};


export type OrganizationRecipeRunFinishedRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepositoryChangesetOrderByInput>>;
  where?: InputMaybe<RepositoryChangesetWhereInput>;
};


export type OrganizationRecipeRunFinishedVisualizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VisualizationOrderByInput>>;
  where?: InputMaybe<VisualizationWhereInput>;
};

export type OrganizationRecipeRunOrderByField =
  | 'ENDED_AT'
  | 'STARTED_AT'
  | 'STATE'
  | 'USER';

export type OrganizationRecipeRunOrderByInput = {
  direction?: SortOrder;
  field: OrganizationRecipeRunOrderByField;
};

/**
 * -----------------------------------------------------------------------------
 * Entity Stub - Worker returns ID, marketplace resolves full type
 * -----------------------------------------------------------------------------
 */
export type OrganizationRecipeRunQueued = OrganizationChangeset & OrganizationRecipeRun & {
  __typename?: 'OrganizationRecipeRunQueued';
  /** Bulk pull request actions (approve, merge, close) launched from this changeset. */
  bulkPullRequestActions: BulkPullRequestActionConnection;
  /**
   * Bulk pull request actions (approve, merge, close) initiated against pull
   * requests that belong to this changeset.
   *
   * Default sort: STARTED_AT DESC with QUEUED entries (no startedAt) appearing
   * last so polling clients still see in-flight actions.
   */
  changelogBulkPullRequestActions: ChangelogBulkPullRequestActionConnection;
  /** Commit operations initiated from this changeset. */
  commits?: Maybe<OrganizationCommitConnection>;
  createdAt: Scalars['DateTime']['output'];
  /**
   * Data tables produced by this recipe run.
   * Each data table starts as Available and transitions to Processing/Finished/Error
   * when downloadDataTable mutation is called.
   */
  dataTables: DataTableConnection;
  id: Scalars['ID']['output'];
  /**
   * Monotonic high-water mark advanced by every state writer (sync monitor,
   * run monitor, processor). Treat as a content version: poll a tiny query
   * selecting `__typename` + `lastUpdatedAt` cheaply and only refetch the
   * heavy `repositories`/`totals` selections when this value changes.
   */
  lastUpdatedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  options: Array<RecipeOptionValue>;
  priority: RecipeRunPriority;
  queuedAt: Scalars['DateTime']['output'];
  recipe?: Maybe<RecipeDescriptor>;
  repositories: RepositoryChangesetConnection;
  review?: Maybe<AgentTeamReview>;
  /**
   * The changeset the run was kept to, when it was: of its organization's repositories, the run
   * covered only the ones this changeset has results in. Null for a run over the whole organization,
   * and for a viewer who cannot see the changeset.
   */
  scope?: Maybe<OrganizationChangeset>;
  user: User;
  /** Visualizations produced by this recipe run. */
  visualizations: VisualizationConnection;
};


/**
 * -----------------------------------------------------------------------------
 * Entity Stub - Worker returns ID, marketplace resolves full type
 * -----------------------------------------------------------------------------
 */
export type OrganizationRecipeRunQueuedBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<BulkPullRequestActionWhereInput>;
};


/**
 * -----------------------------------------------------------------------------
 * Entity Stub - Worker returns ID, marketplace resolves full type
 * -----------------------------------------------------------------------------
 */
export type OrganizationRecipeRunQueuedChangelogBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogBulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<ChangelogBulkPullRequestActionWhereInput>;
};


/**
 * -----------------------------------------------------------------------------
 * Entity Stub - Worker returns ID, marketplace resolves full type
 * -----------------------------------------------------------------------------
 */
export type OrganizationRecipeRunQueuedCommitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationCommitOrderByInput>>;
  where?: InputMaybe<OrganizationCommitWhereInput>;
};


/**
 * -----------------------------------------------------------------------------
 * Entity Stub - Worker returns ID, marketplace resolves full type
 * -----------------------------------------------------------------------------
 */
export type OrganizationRecipeRunQueuedDataTablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataTableOrderByInput>>;
  where?: InputMaybe<DataTableWhereInput>;
};


/**
 * -----------------------------------------------------------------------------
 * Entity Stub - Worker returns ID, marketplace resolves full type
 * -----------------------------------------------------------------------------
 */
export type OrganizationRecipeRunQueuedRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepositoryChangesetOrderByInput>>;
  where?: InputMaybe<RepositoryChangesetWhereInput>;
};


/**
 * -----------------------------------------------------------------------------
 * Entity Stub - Worker returns ID, marketplace resolves full type
 * -----------------------------------------------------------------------------
 */
export type OrganizationRecipeRunQueuedVisualizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VisualizationOrderByInput>>;
  where?: InputMaybe<VisualizationWhereInput>;
};

export type OrganizationRecipeRunRunning = OrganizationChangeset & OrganizationRecipeRun & {
  __typename?: 'OrganizationRecipeRunRunning';
  /** Bulk pull request actions (approve, merge, close) launched from this changeset. */
  bulkPullRequestActions: BulkPullRequestActionConnection;
  /**
   * Bulk pull request actions (approve, merge, close) initiated against pull
   * requests that belong to this changeset.
   *
   * Default sort: STARTED_AT DESC with QUEUED entries (no startedAt) appearing
   * last so polling clients still see in-flight actions.
   */
  changelogBulkPullRequestActions: ChangelogBulkPullRequestActionConnection;
  /** Commit operations initiated from this changeset. */
  commits?: Maybe<OrganizationCommitConnection>;
  createdAt: Scalars['DateTime']['output'];
  /**
   * Data tables produced by this recipe run.
   * Each data table starts as Available and transitions to Processing/Finished/Error
   * when downloadDataTable mutation is called.
   */
  dataTables: DataTableConnection;
  id: Scalars['ID']['output'];
  /**
   * Monotonic high-water mark advanced by every state writer (sync monitor,
   * run monitor, processor). Treat as a content version: poll a tiny query
   * selecting `__typename` + `lastUpdatedAt` cheaply and only refetch the
   * heavy `repositories`/`totals` selections when this value changes.
   */
  lastUpdatedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  options: Array<RecipeOptionValue>;
  priority: RecipeRunPriority;
  recipe?: Maybe<RecipeDescriptor>;
  repositories: RepositoryChangesetConnection;
  review?: Maybe<AgentTeamReview>;
  /**
   * The changeset the run was kept to, when it was: of its organization's repositories, the run
   * covered only the ones this changeset has results in. Null for a run over the whole organization,
   * and for a viewer who cannot see the changeset.
   */
  scope?: Maybe<OrganizationChangeset>;
  startedAt: Scalars['DateTime']['output'];
  totals?: Maybe<RecipeRunTotals>;
  user: User;
  /** Visualizations produced by this recipe run. */
  visualizations: VisualizationConnection;
};


export type OrganizationRecipeRunRunningBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<BulkPullRequestActionWhereInput>;
};


export type OrganizationRecipeRunRunningChangelogBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogBulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<ChangelogBulkPullRequestActionWhereInput>;
};


export type OrganizationRecipeRunRunningCommitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationCommitOrderByInput>>;
  where?: InputMaybe<OrganizationCommitWhereInput>;
};


export type OrganizationRecipeRunRunningDataTablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataTableOrderByInput>>;
  where?: InputMaybe<DataTableWhereInput>;
};


export type OrganizationRecipeRunRunningRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepositoryChangesetOrderByInput>>;
  where?: InputMaybe<RepositoryChangesetWhereInput>;
};


export type OrganizationRecipeRunRunningVisualizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VisualizationOrderByInput>>;
  where?: InputMaybe<VisualizationWhereInput>;
};

export type OrganizationRecipeRunState =
  | 'CANCELED'
  | 'ERROR'
  | 'FINISHED'
  | 'QUEUED'
  | 'RUNNING'
  | 'SYNCING';

export type OrganizationRecipeRunStateFilter = {
  _eq?: InputMaybe<OrganizationRecipeRunState>;
  _in?: InputMaybe<Array<OrganizationRecipeRunState>>;
  _neq?: InputMaybe<OrganizationRecipeRunState>;
  _nin?: InputMaybe<Array<OrganizationRecipeRunState>>;
};

/**
 * Deprecated: recipe runs no longer emit a Syncing state. A run that syncs
 * intrinsically (`mod run --sync-csv`) starts in Running immediately.
 */
export type OrganizationRecipeRunSyncing = OrganizationChangeset & OrganizationRecipeRun & {
  __typename?: 'OrganizationRecipeRunSyncing';
  /** Bulk pull request actions (approve, merge, close) launched from this changeset. */
  bulkPullRequestActions: BulkPullRequestActionConnection;
  /**
   * Bulk pull request actions (approve, merge, close) initiated against pull
   * requests that belong to this changeset.
   *
   * Default sort: STARTED_AT DESC with QUEUED entries (no startedAt) appearing
   * last so polling clients still see in-flight actions.
   */
  changelogBulkPullRequestActions: ChangelogBulkPullRequestActionConnection;
  /** Commit operations initiated from this changeset. */
  commits?: Maybe<OrganizationCommitConnection>;
  createdAt: Scalars['DateTime']['output'];
  /**
   * Data tables produced by this recipe run.
   * Each data table starts as Available and transitions to Processing/Finished/Error
   * when downloadDataTable mutation is called.
   */
  dataTables: DataTableConnection;
  id: Scalars['ID']['output'];
  /**
   * Monotonic high-water mark advanced by every state writer (sync monitor,
   * run monitor, processor). Treat as a content version: poll a tiny query
   * selecting `__typename` + `lastUpdatedAt` cheaply and only refetch the
   * heavy `repositories`/`totals` selections when this value changes.
   */
  lastUpdatedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  options: Array<RecipeOptionValue>;
  priority: RecipeRunPriority;
  recipe?: Maybe<RecipeDescriptor>;
  repositories: RepositoryChangesetConnection;
  review?: Maybe<AgentTeamReview>;
  /**
   * The changeset the run was kept to, when it was: of its organization's repositories, the run
   * covered only the ones this changeset has results in. Null for a run over the whole organization,
   * and for a viewer who cannot see the changeset.
   */
  scope?: Maybe<OrganizationChangeset>;
  startedAt: Scalars['DateTime']['output'];
  user: User;
  /** Visualizations produced by this recipe run. */
  visualizations: VisualizationConnection;
};


/**
 * Deprecated: recipe runs no longer emit a Syncing state. A run that syncs
 * intrinsically (`mod run --sync-csv`) starts in Running immediately.
 */
export type OrganizationRecipeRunSyncingBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<BulkPullRequestActionWhereInput>;
};


/**
 * Deprecated: recipe runs no longer emit a Syncing state. A run that syncs
 * intrinsically (`mod run --sync-csv`) starts in Running immediately.
 */
export type OrganizationRecipeRunSyncingChangelogBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogBulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<ChangelogBulkPullRequestActionWhereInput>;
};


/**
 * Deprecated: recipe runs no longer emit a Syncing state. A run that syncs
 * intrinsically (`mod run --sync-csv`) starts in Running immediately.
 */
export type OrganizationRecipeRunSyncingCommitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationCommitOrderByInput>>;
  where?: InputMaybe<OrganizationCommitWhereInput>;
};


/**
 * Deprecated: recipe runs no longer emit a Syncing state. A run that syncs
 * intrinsically (`mod run --sync-csv`) starts in Running immediately.
 */
export type OrganizationRecipeRunSyncingDataTablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataTableOrderByInput>>;
  where?: InputMaybe<DataTableWhereInput>;
};


/**
 * Deprecated: recipe runs no longer emit a Syncing state. A run that syncs
 * intrinsically (`mod run --sync-csv`) starts in Running immediately.
 */
export type OrganizationRecipeRunSyncingRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepositoryChangesetOrderByInput>>;
  where?: InputMaybe<RepositoryChangesetWhereInput>;
};


/**
 * Deprecated: recipe runs no longer emit a Syncing state. A run that syncs
 * intrinsically (`mod run --sync-csv`) starts in Running immediately.
 */
export type OrganizationRecipeRunSyncingVisualizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VisualizationOrderByInput>>;
  where?: InputMaybe<VisualizationWhereInput>;
};

export type OrganizationRecipeRunWhereInput = {
  _and?: InputMaybe<Array<OrganizationRecipeRunWhereInput>>;
  _not?: InputMaybe<OrganizationRecipeRunWhereInput>;
  _or?: InputMaybe<Array<OrganizationRecipeRunWhereInput>>;
  id?: InputMaybe<IdFilter>;
  startedAt?: InputMaybe<DateTimeFilter>;
  state?: InputMaybe<OrganizationRecipeRunStateFilter>;
  user?: InputMaybe<StringFilter>;
};

/**
 * A changeset that began by push rather than by recipe run: what `mod exec` or a coding agent
 * did across a working set with no recipe before it. Nothing but the interface: its review
 * says who and how, its repositories say what.
 */
export type OrganizationRevision = OrganizationChangeset & {
  __typename?: 'OrganizationRevision';
  /** Bulk pull request actions (approve, merge, close) launched from this changeset. */
  bulkPullRequestActions: BulkPullRequestActionConnection;
  /**
   * Bulk pull request actions (approve, merge, close) initiated against pull
   * requests that belong to this changeset.
   *
   * Default sort: STARTED_AT DESC with QUEUED entries (no startedAt) appearing
   * last so polling clients still see in-flight actions.
   */
  changelogBulkPullRequestActions: ChangelogBulkPullRequestActionConnection;
  /** Commit operations initiated from this changeset. */
  commits?: Maybe<OrganizationCommitConnection>;
  createdAt: Scalars['DateTime']['output'];
  dataTables: DataTableConnection;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  repositories: RepositoryChangesetConnection;
  review?: Maybe<AgentTeamReview>;
  user: User;
  visualizations: VisualizationConnection;
};


/**
 * A changeset that began by push rather than by recipe run: what `mod exec` or a coding agent
 * did across a working set with no recipe before it. Nothing but the interface: its review
 * says who and how, its repositories say what.
 */
export type OrganizationRevisionBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<BulkPullRequestActionWhereInput>;
};


/**
 * A changeset that began by push rather than by recipe run: what `mod exec` or a coding agent
 * did across a working set with no recipe before it. Nothing but the interface: its review
 * says who and how, its repositories say what.
 */
export type OrganizationRevisionChangelogBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogBulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<ChangelogBulkPullRequestActionWhereInput>;
};


/**
 * A changeset that began by push rather than by recipe run: what `mod exec` or a coding agent
 * did across a working set with no recipe before it. Nothing but the interface: its review
 * says who and how, its repositories say what.
 */
export type OrganizationRevisionCommitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationCommitOrderByInput>>;
  where?: InputMaybe<OrganizationCommitWhereInput>;
};


/**
 * A changeset that began by push rather than by recipe run: what `mod exec` or a coding agent
 * did across a working set with no recipe before it. Nothing but the interface: its review
 * says who and how, its repositories say what.
 */
export type OrganizationRevisionDataTablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataTableOrderByInput>>;
  where?: InputMaybe<DataTableWhereInput>;
};


/**
 * A changeset that began by push rather than by recipe run: what `mod exec` or a coding agent
 * did across a working set with no recipe before it. Nothing but the interface: its review
 * says who and how, its repositories say what.
 */
export type OrganizationRevisionRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepositoryChangesetOrderByInput>>;
  where?: InputMaybe<RepositoryChangesetWhereInput>;
};


/**
 * A changeset that began by push rather than by recipe run: what `mod exec` or a coding agent
 * did across a working set with no recipe before it. Nothing but the interface: its review
 * says who and how, its repositories say what.
 */
export type OrganizationRevisionVisualizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VisualizationOrderByInput>>;
  where?: InputMaybe<VisualizationWhereInput>;
};

/**
 * A changeset a saved code search made: the repositories where the query matched, each with the
 * files and lines it matched in, kept as a recipe run's search results are, so a team can join it
 * and push to it like any changeset. Running until `finishedAt`.
 */
export type OrganizationSearch = OrganizationChangeset & {
  __typename?: 'OrganizationSearch';
  /** Bulk pull request actions (approve, merge, close) launched from this changeset. */
  bulkPullRequestActions: BulkPullRequestActionConnection;
  /**
   * Bulk pull request actions (approve, merge, close) initiated against pull
   * requests that belong to this changeset.
   *
   * Default sort: STARTED_AT DESC with QUEUED entries (no startedAt) appearing
   * last so polling clients still see in-flight actions.
   */
  changelogBulkPullRequestActions: ChangelogBulkPullRequestActionConnection;
  /** Commit operations initiated from this changeset. */
  commits?: Maybe<OrganizationCommitConnection>;
  /**
   * How much of the organization the search covered, once it finished. Null while it runs, and
   * for a search that stopped without saying how far it got.
   */
  coverage?: Maybe<OrganizationSearchCoverage>;
  createdAt: Scalars['DateTime']['output'];
  /**
   * The data tables on the changeset: the ones the sessions on it pushed, and the rows of an SQL
   * search where the search kept them as a table.
   */
  dataTables: DataTableConnection;
  /**
   * Why it ended without finishing, when it did: what the sweep said stopped it, or that it went
   * silent. A sweep that failed or was stopped recorded what it had found. One that went silent
   * recorded nothing, since a sweep records its repositories as it ends, so save the search again.
   */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * When the sweep ended; null while it runs. The sweep is heard from with every repository it
   * covers, so one not heard from for an hour that never said it ended, as when the code search
   * service restarts mid-sweep, ended when it was last heard from, with an `error` saying so.
   * The changeset can be checked out, and so joined, once this is set.
   */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The query as it was given. */
  query: Scalars['String']['output'];
  /**
   * Every repository the search has covered, at its newest change: a RepositoryRevision where a
   * push landed, else a RepositorySearchResult with what the search found there. The sweep
   * records its repositories as it writes their results, towards the end of its run, so `count`
   * stays low while the search runs and fills in as it finishes. `where: {onlyWithResults: true}`
   * keeps the repositories it found something in and the ones pushed to, which is what a team
   * joining the changeset syncs; `orderBy: RESULTS` ranks them by the files the search matched.
   */
  repositories: RepositoryChangesetConnection;
  review?: Maybe<AgentTeamReview>;
  syntax: CodeSearchSyntax;
  user: User;
  /** Always empty: a search produces no visualizations. */
  visualizations: VisualizationConnection;
};


/**
 * A changeset a saved code search made: the repositories where the query matched, each with the
 * files and lines it matched in, kept as a recipe run's search results are, so a team can join it
 * and push to it like any changeset. Running until `finishedAt`.
 */
export type OrganizationSearchBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<BulkPullRequestActionWhereInput>;
};


/**
 * A changeset a saved code search made: the repositories where the query matched, each with the
 * files and lines it matched in, kept as a recipe run's search results are, so a team can join it
 * and push to it like any changeset. Running until `finishedAt`.
 */
export type OrganizationSearchChangelogBulkPullRequestActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangelogBulkPullRequestActionOrderByInput>>;
  where?: InputMaybe<ChangelogBulkPullRequestActionWhereInput>;
};


/**
 * A changeset a saved code search made: the repositories where the query matched, each with the
 * files and lines it matched in, kept as a recipe run's search results are, so a team can join it
 * and push to it like any changeset. Running until `finishedAt`.
 */
export type OrganizationSearchCommitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationCommitOrderByInput>>;
  where?: InputMaybe<OrganizationCommitWhereInput>;
};


/**
 * A changeset a saved code search made: the repositories where the query matched, each with the
 * files and lines it matched in, kept as a recipe run's search results are, so a team can join it
 * and push to it like any changeset. Running until `finishedAt`.
 */
export type OrganizationSearchDataTablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataTableOrderByInput>>;
  where?: InputMaybe<DataTableWhereInput>;
};


/**
 * A changeset a saved code search made: the repositories where the query matched, each with the
 * files and lines it matched in, kept as a recipe run's search results are, so a team can join it
 * and push to it like any changeset. Running until `finishedAt`.
 */
export type OrganizationSearchRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepositoryChangesetOrderByInput>>;
  where?: InputMaybe<RepositoryChangesetWhereInput>;
};


/**
 * A changeset a saved code search made: the repositories where the query matched, each with the
 * files and lines it matched in, kept as a recipe run's search results are, so a team can join it
 * and push to it like any changeset. Running until `finishedAt`.
 */
export type OrganizationSearchVisualizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VisualizationOrderByInput>>;
  where?: InputMaybe<VisualizationWhereInput>;
};

/**
 * How much of its organization a search covered: every repository the organization has, the ones
 * the code search index held at their current commit, and the ones it could not hold.
 */
export type OrganizationSearchCoverage = {
  __typename?: 'OrganizationSearchCoverage';
  indexed: Scalars['Int']['output'];
  notIndexable: Scalars['Int']['output'];
  repositories: Scalars['Int']['output'];
};

export type OrganizationSource = {
  __typename?: 'OrganizationSource';
  /** The downloadable structure-only repos.csv for this source; null only in the rare empty-slot case. */
  download?: Maybe<OrganizationSourceDownload>;
  /** Stable id unique within its Connector: "<connectorId>:<sha-256 of the source URI>". */
  id: Scalars['ID']['output'];
  kind: OrganizationSourceKind;
  /** The source URI (http/s3/gcs) or permanent-dir-relative path (file). */
  location: Scalars['String']['output'];
};

export type OrganizationSourceDownload = {
  __typename?: 'OrganizationSourceDownload';
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  sizeBytes: Scalars['Int']['output'];
  /** Admin-gated URL serving the structure-only repos.csv for this source. */
  url: Scalars['String']['output'];
};

export type OrganizationSourceKind =
  | 'FILE'
  | 'GCS'
  | 'HTTP'
  | 'S3';

export type OrganizationWhereInput = {
  _and?: InputMaybe<Array<OrganizationWhereInput>>;
  _not?: InputMaybe<OrganizationWhereInput>;
  _or?: InputMaybe<Array<OrganizationWhereInput>>;
  /**
   * Filter by depth in the organization hierarchy.
   * The root organization ("_root") is depth 0, its direct children are depth 1, etc.
   */
  depth?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Patch = {
  __typename?: 'Patch';
  /** Sanitized diff (does not include markers) */
  diff: Scalars['String']['output'];
  /**
   * A diff with search and markup markers included in fenced
   * {{UUID}} wrappers that correspond to ids in the markers list.
   */
  fencedMarkerDiff: Scalars['String']['output'];
  markers: Array<Marker>;
};

/** Filter for file paths using glob patterns. */
export type PathFilter = {
  /** Exact path match. */
  _eq?: InputMaybe<Scalars['Path']['input']>;
  /** Glob pattern match. Examples: **\/*.java, src/main/** */
  _glob?: InputMaybe<Scalars['String']['input']>;
  /** Match any of the exact paths. */
  _in?: InputMaybe<Array<Scalars['Path']['input']>>;
  /** Exclude any of the exact paths. */
  _nin?: InputMaybe<Array<Scalars['Path']['input']>>;
};

export type PersonalAccessTokenConfiguration = {
  __typename?: 'PersonalAccessTokenConfiguration';
  maxExpiryDays?: Maybe<Scalars['Int']['output']>;
};

export type PipRecipeBundle = RecipeBundle & {
  __typename?: 'PipRecipeBundle';
  packageName: Scalars['String']['output'];
  recipeCount?: Maybe<Scalars['Int']['output']>;
  requestedVersion?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type PipRecipeBundleInput = {
  packageName: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformCapabilities = {
  __typename?: 'PlatformCapabilities';
  changelog: Scalars['Boolean']['output'];
  codeSearch: Scalars['Boolean']['output'];
  connector: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  moddy: Scalars['Boolean']['output'];
  profiling: Profiling;
};

export type Profiling = {
  __typename?: 'Profiling';
  /** Whether the per-tenant Pyroscope ASG, S3 bucket, and IAM are provisioned. */
  deployed: Scalars['Boolean']['output'];
  /** The currently active profiling session, or null when profiling is off. Flipped by setProfiling. */
  session?: Maybe<ProfilingSession>;
};

/**
 * The primary event the Pyroscope agent samples on. async-profiler can only
 * collect one of these at a time as the primary event; alloc and lock
 * sampling run on separate channels and are always on.
 */
export type ProfilingEvent =
  /**
   * CPU samples taken while threads are on-CPU. Best for finding hot
   * methods. Threads parked in syscalls, blocking I/O, or Object.wait()
   * are invisible — for those see WALL.
   */
  | 'CPU'
  /**
   * Wall-clock samples taken for every thread regardless of state. Shows
   * where threads spend their time including off-CPU blocking (I/O,
   * locks, Process.waitFor, sleeps). Use when diagnosing "the JVM looks
   * alive but the actuator stopped answering" scenarios.
   */
  | 'WALL';

export type ProfilingSession = {
  __typename?: 'ProfilingSession';
  /** The primary profiling event the in-process agent is sampling. */
  event: ProfilingEvent;
  /** When profiling was turned on. */
  startedAt: Scalars['DateTime']['output'];
  /** The user who turned profiling on. */
  user: User;
};

/**
 * -----------------------------------------------------------------------------
 * Prompt
 * -----------------------------------------------------------------------------
 */
export type Prompt = {
  __typename?: 'Prompt';
  content: Scalars['Markdown']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  lastUpdatedBy: User;
};

/**
 * The state of an individual pull request within a `BulkPullRequestAction`.
 * Use `__typename` to determine the current state.
 */
export type PullRequestAction = {
  /**
   * The commit job whose pull request this result acted on. Bulk actions are
   * changeset-scoped, so filter on this to show only one commit job's activity.
   * Null only for actions enqueued before this field existed -- a shrinking
   * population, but one a per-commit view will otherwise render as empty.
   */
  commitId?: Maybe<Scalars['ID']['output']>;
  pullRequest: PullRequestRef;
};

export type PullRequestActionCanceled = PullRequestAction & {
  __typename?: 'PullRequestActionCanceled';
  canceledBy: User;
  commitId?: Maybe<Scalars['ID']['output']>;
  pullRequest: PullRequestRef;
};

/**
 * =============================================================================
 * Connections
 * =============================================================================
 */
export type PullRequestActionConnection = {
  __typename?: 'PullRequestActionConnection';
  count: Scalars['Int']['output'];
  edges: Array<PullRequestActionEdge>;
  pageInfo: PageInfo;
};

export type PullRequestActionEdge = {
  __typename?: 'PullRequestActionEdge';
  cursor: Scalars['String']['output'];
  node: PullRequestAction;
};

export type PullRequestActionFailed = PullRequestAction & {
  __typename?: 'PullRequestActionFailed';
  commitId?: Maybe<Scalars['ID']['output']>;
  errorMessage: Scalars['String']['output'];
  finishedAt: Scalars['DateTime']['output'];
  pullRequest: PullRequestRef;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PullRequestActionOrderByField =
  | 'REPOSITORY_PATH'
  | 'STARTED_AT'
  | 'STATE';

export type PullRequestActionOrderByInput = {
  direction?: SortOrder;
  field: PullRequestActionOrderByField;
};

export type PullRequestActionQueued = PullRequestAction & {
  __typename?: 'PullRequestActionQueued';
  commitId?: Maybe<Scalars['ID']['output']>;
  pullRequest: PullRequestRef;
};

export type PullRequestActionRunning = PullRequestAction & {
  __typename?: 'PullRequestActionRunning';
  commitId?: Maybe<Scalars['ID']['output']>;
  pullRequest: PullRequestRef;
  startedAt: Scalars['DateTime']['output'];
};

export type PullRequestActionState =
  | 'CANCELED'
  | 'FAILED'
  | 'IN_PROGRESS'
  | 'QUEUED'
  | 'SUCCESSFUL';

/**
 * =============================================================================
 * Filters and Ordering
 * =============================================================================
 */
export type PullRequestActionStateFilter = {
  _eq?: InputMaybe<PullRequestActionState>;
  _in?: InputMaybe<Array<PullRequestActionState>>;
  _neq?: InputMaybe<PullRequestActionState>;
  _nin?: InputMaybe<Array<PullRequestActionState>>;
};

export type PullRequestActionSucceeded = PullRequestAction & {
  __typename?: 'PullRequestActionSucceeded';
  branchDeleteStatus: BranchDeleteStatus;
  commitId?: Maybe<Scalars['ID']['output']>;
  finishedAt: Scalars['DateTime']['output'];
  pullRequest: PullRequestRef;
  startedAt: Scalars['DateTime']['output'];
};

export type PullRequestActionType =
  | 'APPROVE'
  | 'CLOSE'
  | 'MERGE';

export type PullRequestActionTypeFilter = {
  _eq?: InputMaybe<PullRequestActionType>;
  _in?: InputMaybe<Array<PullRequestActionType>>;
  _neq?: InputMaybe<PullRequestActionType>;
  _nin?: InputMaybe<Array<PullRequestActionType>>;
};

export type PullRequestActionWhereInput = {
  _and?: InputMaybe<Array<PullRequestActionWhereInput>>;
  _not?: InputMaybe<PullRequestActionWhereInput>;
  _or?: InputMaybe<Array<PullRequestActionWhereInput>>;
  /**
   * Narrow a changeset-scoped action's results to the pull requests one commit job
   * opened. Unattributed results (see `PullRequestAction.commitId`) match `_neq` and
   * `_nin` as well as the job you asked for, and `IDFilter` has no `_isNull`, so they
   * cannot be selected on their own.
   */
  commitId?: InputMaybe<IdFilter>;
  state?: InputMaybe<PullRequestActionStateFilter>;
};

/** Create a pull request from a branch on the origin remote. */
export type PullRequestCommitInput = {
  /**
   * Auto-merge method after checks pass. Null means no auto-merge.
   * Best effort - silently ignored if not supported by the repository.
   */
  autoMergeMethod?: InputMaybe<MergeMethod>;
  /** Pull request body (Base64 encoded). */
  body?: InputMaybe<Scalars['Base64']['input']>;
  /** Create as a draft pull request. */
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Recreate pull request if it was previously closed. */
  recreateClosedPullRequest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pull request title. If unset, uses the commit message. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Pull request commit completed successfully. */
export type PullRequestCommitSucceeded = RepositoryCommit & RepositoryCommitSucceeded & {
  __typename?: 'PullRequestCommitSucceeded';
  finishedAt: Scalars['DateTime']['output'];
  /** Pull request status, resolved live from the SCM on read (one SCM request per open PR). */
  pullRequestStatus: PullRequestStatus;
  repository: Repository;
  resultLink?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
};

/**
 * =============================================================================
 * Pull Request Input
 * =============================================================================
 */
export type PullRequestInput = {
  /** Pull request number. */
  number: Scalars['Int']['input'];
  repository: RepositoryInput;
};

export type PullRequestOptions = CommitOptions & {
  __typename?: 'PullRequestOptions';
  /** If allowed by the repository, set the pull request to automatically merge after all checks pass using the defined strategy. */
  autoMergeMethod?: Maybe<MergeMethod>;
  /** The branch name as requested. The branch actually pushed may differ, carrying a short hash of the base branch, and is reported on the repository of a succeeded result. */
  branchName?: Maybe<Scalars['String']['output']>;
  /** Recreate a pull request if it was already closed. */
  canRecreateClosedPullRequest: Scalars['Boolean']['output'];
  draft: Scalars['Boolean']['output'];
  pullRequestBody?: Maybe<Scalars['Base64']['output']>;
  /** If unset, the commit message will be used as the pull request title. */
  pullRequestTitle?: Maybe<Scalars['String']['output']>;
};

/**
 * -----------------------------------------------------------------------------
 * Bulk Pull Request Actions - Changeset Scoped
 * -----------------------------------------------------------------------------
 * Approve, merge, and close (in bulk) the pull requests the committer created
 * from a changeset. The committer resolves the target PRs from its own commit
 * records, so callers pass the changeset (and optionally a repository subset)
 * rather than explicit PR numbers. This set is always available (base platform),
 * so committer-produced PRs can be mass-actioned even when the changelog
 * capability is off. The changelog service exposes a parallel, filter-based set
 * (approveChangelogPullRequests, etc.).
 */
export type PullRequestRef = {
  __typename?: 'PullRequestRef';
  /** The pull request's source branch. */
  branch: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  origin: Scalars['String']['output'];
  repositoryPath: Scalars['String']['output'];
};

/**
 * Selects pull requests for a bulk action.
 *
 * The `where` filter defines a base set of matching PRs. The optional `pullRequests`
 * modifier can include or exclude specific PRs from that base set.
 *
 * Examples:
 * - Filter-only: `{ where: { ... } }` — all matching PRs
 * - Explicit: `{ pullRequests: { include: [...] } }` — exactly those PRs
 * - Filter + exclusions: `{ where: { ... }, pullRequests: { exclude: [...] } }` — matching minus excluded
 * - Filter + additions: `{ where: { ... }, pullRequests: { include: [...] } }` — matching plus included
 */
export type PullRequestSelectionInput = {
  /** Modify the base set by including or excluding specific PRs. */
  pullRequests?: InputMaybe<PullRequestSelectionModifier>;
  /** Filter for the base set of PRs. Omit to start with an empty set. */
  where?: InputMaybe<ChangelogEntryWhereInput>;
};

/**
 * Modifies a PR selection by either including or excluding specific PRs.
 * Exactly one field must be set.
 */
export type PullRequestSelectionModifier = {
  /** Remove these PRs from the base set. */
  exclude?: InputMaybe<Array<PullRequestInput>>;
  /** Add these PRs to the base set. */
  include?: InputMaybe<Array<PullRequestInput>>;
};

/**
 * =============================================================================
 * Enums (redeclared identically for federation merging)
 * =============================================================================
 */
export type PullRequestState =
  | 'CLOSED'
  | 'DRAFT'
  | 'MERGED'
  | 'OPEN';

export type PullRequestStateFilter = {
  _eq?: InputMaybe<PullRequestState>;
  _in?: InputMaybe<Array<PullRequestState>>;
  _neq?: InputMaybe<PullRequestState>;
  _nin?: InputMaybe<Array<PullRequestState>>;
};

export type PullRequestStatus = {
  __typename?: 'PullRequestStatus';
  buildState?: Maybe<BuildState>;
  /** Can this pull request be merged or not */
  mergeable: Mergeable;
  /** Additional status flags that block this pull request. Can depend on the SCM service provider. */
  otherBlockingReasons: Array<Scalars['String']['output']>;
  /**
   * When the pull request was merged or closed. The provider's own timestamp on GitHub,
   * Bitbucket Data Center and Azure DevOps; GitLab and Bitbucket Cloud don't report one,
   * so those fall back to when Moderne observed the transition and advance on every read
   * until the commit job finishes. Null while open, and for pull requests already
   * terminal before this shipped -- those are never re-queried.
   */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  review: ReviewStatus;
  state: PullRequestState;
};

export type PypiConfiguration = {
  __typename?: 'PypiConfiguration';
  connectivity: HttpToolConnectivity;
  resourceId: Scalars['String']['output'];
  skipSsl: Scalars['Boolean']['output'];
  skipValidateConnectivity: Scalars['Boolean']['output'];
};

/**  Base schema types - all other schemas extend these */
export type Query = {
  __typename?: 'Query';
  /**
   * Query audit log downloads with pagination and filtering.
   * Use where: { id: { _eq: "..." } } to poll a specific download.
   */
  auditLogsDownloads: AuditLogsDownloadConnection;
  /** Get a bulk pull request action by ID to poll for progress. */
  bulkPullRequestAction?: Maybe<BulkPullRequestAction>;
  /**
   * Returns which optional platform features are enabled in this deployment.
   * Each field defaults to false and is overridden to true by the corresponding
   * optional service when it is present in the supergraph composition.
   */
  capabilities: PlatformCapabilities;
  /** Get a bulk pull request action by ID to poll for progress. */
  changelogBulkPullRequestAction?: Maybe<ChangelogBulkPullRequestAction>;
  /**
   * Search the code of an organization's repositories. Results are files with their matching
   * lines, limited to repositories the caller can read, in a stable order that `after` resumes.
   * The index is kept in step with the organization's LSTs on its own, so a search answers at
   * once; `coverage` says how many of the organization's repositories it covers.
   *
   * The query is a Sourcegraph-style expression: plain text and `/regular expressions/`,
   * combined with `AND`, `OR` and `NOT`, and narrowed by path and language with `file:`
   * and `lang:`. The index is built from LSTs, so the other filters match resolved types
   * rather than text: `call:` (the call sites of a method, such as
   * `call:java.util.List.add`, calls on subtypes included), `ref:` (the uses of a type),
   * `dependency:` (the calls and references that come from a dependency, by name and
   * optionally the version resolved, such as `dependency:com.fasterxml.*:jackson*:2.15.x`),
   * `sym:` (a declared name), and `extends:`, `implements:`, `annotated:`, `returns:` and
   * `throws:` (declarations).
   *
   * With `save`, the search is also kept as a changeset, an OrganizationSearch, which a team can
   * join: every repository the query matches, each with the files and lines it matched, and every
   * match as a row of the changeset's `org.openrewrite.table.SearchResults` table, the table a
   * search recipe produces. The page is answered as usual, with the changeset as `saved`, and the
   * sweep goes on until the changeset's `finishedAt` is set. `name` is what to call the changeset
   * and comes only with `save`. A save is of the whole search, so it takes no `after`.
   */
  codeSearch: CodeSearchResultConnection;
  /**
   * Lines of a file a `codeSearch` result names, to show a match in more of its context than the
   * result does. Lines are counted from 1, as `lineNumber` counts them, and at most 2,000 come back
   * at a time. Pass the result's `commit` to read the file as it was searched; without it, the lines
   * come from the repository's current LST, which can be newer than the search.
   */
  codeSearchFileLines: CodeSearchFileLines;
  /**
   * DuckDB SQL over the organization's code search results, as the `codeSearchSql` MCP tool runs it:
   * `search('<query>')`, `search_lines('<query>')`, `search_matches('<query>')` and `organizations()`,
   * and `recipe('<recipe>', '<data table>')`, a recipe's data table as the newest run of it that
   * finished each repository left it, or with a changeset id in place of the recipe, that changeset's
   * table. A query still running after about twenty seconds answers RUNNING with a `queryId`; call
   * again with the `queryId` alone to keep waiting.
   *
   * With `save`, the query runs to its end and is kept as a changeset, an OrganizationSearch: every
   * row, whatever `maxRows` says, as the changeset's `io.moderne.codesearch.SqlResults` table, and
   * each row as a mark on the line it names in that repository's results and as a row of the
   * changeset's `org.openrewrite.table.SearchResults` table. The SELECT must have `origin`, `path`,
   * `branch`, `file` and `line_number` (`search_lines`) or `start_line` (`search_matches`, whose
   * columns mark the exact range), or the save is refused. The answer is COMPLETED with the
   * changeset as `saved` and no rows. `name` is what to call the changeset and comes only with
   * `save`. A save takes `sql`, not a `queryId`.
   */
  codeSearchSql: CodeSearchSqlResult;
  connectors: ConnectorConnection;
  /**
   * Look up a single conversation by id. Returns null when no conversation
   * matches or the caller does not have access. Restores the v1 query the
   * moderne-ui client already references.
   */
  conversation?: Maybe<Conversation>;
  /** Returns the currently authenticated user. */
  currentUser: User;
  /**
   * DuckDB SQL over one data table, as the `processDataTableSql` MCP tool runs it: the table's rows
   * as the relation `data_table`, such as
   * `SELECT repositoryPath, count(*) AS files FROM data_table GROUP BY ALL`. `{CSV_PATH}`, as the
   * tool takes the table, reads as `data_table` too. Every row names its repository in
   * `repositoryOrigin`, `repositoryPath` and `repositoryBranch`.
   *
   * Name the table's changeset with `changesetId` for every repository's rows of the table there,
   * the ones the recipe run produced and the ones sessions pushed to the changeset. Or name a recipe
   * with `recipe` and an `organizationId` for the recipe's last known state in the organization, so
   * that you need no changeset id: each repository's rows of the newest run of the recipe that
   * finished it, on the organization, on one above it or on one below it. A repository whose newest
   * result is an error keeps the rows from before it, one whose newest result found nothing has
   * none, and a run of a one-off recipe bundle never counts. Only runs given the same `options` as
   * the recipe was run with count, so a recipe run with options needs them; `asOf` reads the state
   * as it was then. The rows then also have `finished_at` (when the run they came from finished the
   * repository) and `stale` (whether the repository's LST has changed since), and `recipeState` says
   * how much of the organization has a state.
   *
   * `recipe` is a recipe's full name or, as `runRecipe` takes one, the end of it after a dot when
   * no other recipe that has run there ends the same way, as `FindSqlInjection`. `dataTable` is the
   * table's name, as `org.openrewrite.table.SourcesFileResults`, or the end of it after a dot,
   * `SourcesFileResults`, when no other table's name ends the same way; a name more than one table
   * has is refused rather than taken for either. The query answers at once, with at most `maxRows`
   * rows, so aggregate rather than select a large table whole. Only whoever can see the changeset,
   * or the organization, can query its tables; one they may not see is one that is not found.
   */
  dataTableSql: DataTableSqlResult;
  /** Get available DevCenter recipes for configuration. */
  devCenterRecipes: Array<RecipeDescriptor>;
  /** Request a new license lease key */
  license: License;
  organization: Organization;
  organizations: OrganizationConnection;
  /** Returns connections for all SCM providers. */
  scmConnections: Array<ScmConnection>;
  /** Returns users with option to filter by role. */
  users: UserConnection;
  verifyToken?: Maybe<Scalars['String']['output']>;
};


/**  Base schema types - all other schemas extend these */
export type QueryAuditLogsDownloadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuditLogsDownloadOrderByInput>>;
  where?: InputMaybe<AuditLogsDownloadWhereInput>;
};


/**  Base schema types - all other schemas extend these */
export type QueryBulkPullRequestActionArgs = {
  id: Scalars['ID']['input'];
};


/**  Base schema types - all other schemas extend these */
export type QueryChangelogBulkPullRequestActionArgs = {
  id: Scalars['ID']['input'];
};


/**  Base schema types - all other schemas extend these */
export type QueryCodeSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  query: Scalars['String']['input'];
  save?: InputMaybe<Scalars['Boolean']['input']>;
};


/**  Base schema types - all other schemas extend these */
export type QueryCodeSearchFileLinesArgs = {
  commit?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  path: Scalars['String']['input'];
  repository: RepositoryInput;
  to?: InputMaybe<Scalars['Int']['input']>;
};


/**  Base schema types - all other schemas extend these */
export type QueryCodeSearchSqlArgs = {
  maxRows?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  queryId?: InputMaybe<Scalars['ID']['input']>;
  save?: InputMaybe<Scalars['Boolean']['input']>;
  sql?: InputMaybe<Scalars['String']['input']>;
};


/**  Base schema types - all other schemas extend these */
export type QueryConnectorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConnectorOrderByInput>>;
  where?: InputMaybe<ConnectorWhereInput>;
};


/**  Base schema types - all other schemas extend these */
export type QueryConversationArgs = {
  conversationId: Scalars['ID']['input'];
};


/**  Base schema types - all other schemas extend these */
export type QueryDataTableSqlArgs = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  changesetId?: InputMaybe<Scalars['ID']['input']>;
  dataTable: Scalars['String']['input'];
  maxRows?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  recipe?: InputMaybe<Scalars['String']['input']>;
  sql: Scalars['String']['input'];
};


/**  Base schema types - all other schemas extend these */
export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


/**  Base schema types - all other schemas extend these */
export type QueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationOrderByInput>>;
  where?: InputMaybe<OrganizationWhereInput>;
};


/**  Base schema types - all other schemas extend these */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserOrderByInput>>;
  where?: InputMaybe<UserWhereInput>;
};


/**  Base schema types - all other schemas extend these */
export type QueryVerifyTokenArgs = {
  origin: Scalars['String']['input'];
  scmType: ScmType;
};

export type RecipeBundle = {
  /**
   * Number of top-level recipes contributed by this bundle's package.
   * Null when the bundle has not yet been resolved into the marketplace
   * (e.g. an installation still in progress).
   */
  recipeCount?: Maybe<Scalars['Int']['output']>;
  requestedVersion?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type RecipeBundleConnection = {
  __typename?: 'RecipeBundleConnection';
  count: Scalars['Int']['output'];
  edges: Array<RecipeBundleEdge>;
  pageInfo: PageInfo;
};

export type RecipeBundleEdge = {
  __typename?: 'RecipeBundleEdge';
  cursor: Scalars['String']['output'];
  node: RecipeBundle;
};

export type RecipeBundleInput = {
  go?: InputMaybe<GoRecipeBundleInput>;
  maven?: InputMaybe<MavenRecipeBundleInput>;
  npm?: InputMaybe<NpmRecipeBundleInput>;
  nuget?: InputMaybe<NugetRecipeBundleInput>;
  pip?: InputMaybe<PipRecipeBundleInput>;
  yaml?: InputMaybe<YamlRecipeBundleInput>;
};

export type RecipeBundleOrderByField =
  | 'ECOSYSTEM'
  | 'PACKAGE_NAME'
  | 'REQUESTED_VERSION'
  | 'VERSION';

export type RecipeBundleOrderByInput = {
  direction?: SortOrder;
  field: RecipeBundleOrderByField;
};

/** Filter input for RecipeBundle queries. */
export type RecipeBundleWhereInput = {
  _and?: InputMaybe<Array<RecipeBundleWhereInput>>;
  _not?: InputMaybe<RecipeBundleWhereInput>;
  _or?: InputMaybe<Array<RecipeBundleWhereInput>>;
  /** Filter by ecosystem. */
  ecosystem?: InputMaybe<RecipeEcosystemFilter>;
  /** Filter by package name (e.g., "org.openrewrite:rewrite-java"). */
  packageName?: InputMaybe<StringFilter>;
  /** Filter by requested version (the version requested before resolution). */
  requestedVersion?: InputMaybe<StringFilter>;
  /** Filter by resolved version. */
  version?: InputMaybe<StringFilter>;
};

export type RecipeCategory = {
  __typename?: 'RecipeCategory';
  categories: RecipeCategoryConnection;
  description: Scalars['Markdown']['output'];
  displayName: Scalars['Markdown']['output'];
  id: Scalars['ID']['output'];
  parents: Array<RecipeCategory>;
  /** Total number of unique recipes in this category, including all subcategories recursively. */
  recipeCount: Scalars['Int']['output'];
  recipes: RecipeDescriptorConnection;
};


export type RecipeCategoryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecipeCategoryOrderByInput>>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


export type RecipeCategoryRecipesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecipeOrderByInput>>;
  where?: InputMaybe<RecipeWhereInput>;
};

export type RecipeCategoryConnection = {
  __typename?: 'RecipeCategoryConnection';
  count: Scalars['Int']['output'];
  edges: Array<RecipeCategoryEdge>;
  pageInfo: PageInfo;
};

export type RecipeCategoryEdge = {
  __typename?: 'RecipeCategoryEdge';
  cursor: Scalars['String']['output'];
  node: RecipeCategory;
};

export type RecipeCategoryOrderByField =
  | 'DISPLAY_NAME'
  | 'RECIPE_COUNT';

export type RecipeCategoryOrderByInput = {
  direction?: SortOrder;
  field: RecipeCategoryOrderByField;
};

/** Filter input for RecipeCategory queries. */
export type RecipeCategoryWhereInput = {
  _and?: InputMaybe<Array<RecipeCategoryWhereInput>>;
  _not?: InputMaybe<RecipeCategoryWhereInput>;
  _or?: InputMaybe<Array<RecipeCategoryWhereInput>>;
  /** Filter by display name. */
  displayName?: InputMaybe<StringFilter>;
  /** Filter by category ID. */
  id?: InputMaybe<IdFilter>;
  /** Filter by parent category ID. Use null to find root categories. */
  parentId?: InputMaybe<IdFilter>;
};

/**
 * -----------------------------------------------------------------------------
 * Entity stubs - resolved by other subgraphs.
 * Declared so DGS codegen emits reference classes moddy can instantiate; the
 * owning subgraph hydrates the rest of the fields via federation.
 * -----------------------------------------------------------------------------
 */
export type RecipeDescriptor = {
  __typename?: 'RecipeDescriptor';
  bundle: RecipeBundle;
  dataTables: Array<DataTableDescriptor>;
  description: Scalars['Markdown']['output'];
  /**
   * Expensive recipe detail fields that require resolving the full recipe bundle.
   * Returns a state machine: query once to trigger resolution, poll until Finished.
   */
  detail: RecipeDetail;
  /** DevCenter card descriptors for this recipe, or null if not a DevCenter recipe. */
  devCenterCards?: Maybe<Array<DevCenterCardDescriptor>>;
  displayName: Scalars['Markdown']['output'];
  id: Scalars['ID']['output'];
  /**
   * A user-defined name for this recipe instance, which may differ from displayName
   * when the same recipe is used multiple times in a composite recipe with different options.
   */
  instanceName?: Maybe<Scalars['String']['output']>;
  options: Array<Option>;
  recipeCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Where the bundle that provides this recipe was installed. Only user-scope installs are
   * attributed, so this is a `UserInstallScope` or null; null means the recipe came from an
   * organization or the universal marketplace.
   */
  scope?: Maybe<RecipeInstallationScope>;
  /**
   * URL to the recipe's source file on GitHub, used to power the "Go to sources"
   * link. Currently only OpenRewrite (org.openrewrite) recipes have a source URL;
   * null for all other recipes.
   */
  sourceUrl?: Maybe<Scalars['String']['output']>;
};

export type RecipeDescriptorConnection = {
  __typename?: 'RecipeDescriptorConnection';
  count: Scalars['Int']['output'];
  edges: Array<RecipeDescriptorEdge>;
  pageInfo: PageInfo;
};

export type RecipeDescriptorEdge = {
  __typename?: 'RecipeDescriptorEdge';
  cursor: Scalars['String']['output'];
  node: RecipeDescriptor;
  /**
   * Relevance score for this recipe in the context of a search query.
   * For semantic search, this represents the search relevance (0.0 to 1.0).
   * For filter-based queries, this is always 1.0.
   */
  relevance: Scalars['Float']['output'];
};

/**
 * State machine for recipe detail resolution. Querying the `detail` field on a
 * RecipeDescriptor triggers background resolution of the full recipe bundle.
 * Poll until `__typename` is `RecipeDetailFinished`.
 */
export type RecipeDetail = {
  startedAt: Scalars['DateTime']['output'];
};

export type RecipeDetailError = RecipeDetail & {
  __typename?: 'RecipeDetailError';
  finishedAt: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export type RecipeDetailFinished = RecipeDetail & {
  __typename?: 'RecipeDetailFinished';
  finishedAt: Scalars['DateTime']['output'];
  /**
   * Flat vertices-and-edges representation of this composite recipe tree with
   * Singleton deduplication pre-applied. Used by the Builder UI to visualize
   * a composite recipe in a single round trip regardless of tree depth.
   * Atomic (leaf) recipes return a single-vertex graph.
   */
  graph: RecipeGraph;
  preconditions: Array<RecipeDescriptor>;
  /**
   * The list of recipes that make up this composite recipe.
   * Returns an empty connection for non-composite (leaf) recipes.
   */
  recipeList: RecipeDescriptorConnection;
  startedAt: Scalars['DateTime']['output'];
  /** Tags associated with this recipe for categorization and filtering. */
  tags: Array<Scalars['String']['output']>;
};


export type RecipeDetailFinishedRecipeListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type RecipeDetailLoading = RecipeDetail & {
  __typename?: 'RecipeDetailLoading';
  startedAt: Scalars['DateTime']['output'];
};

export type RecipeEcosystem =
  | 'Git'
  | 'Go'
  | 'Maven'
  | 'NPM'
  | 'Nuget'
  | 'Pip'
  | 'YAML';

export type RecipeEcosystemFilter = {
  _eq?: InputMaybe<RecipeEcosystem>;
  _in?: InputMaybe<Array<RecipeEcosystem>>;
  _neq?: InputMaybe<RecipeEcosystem>;
  _nin?: InputMaybe<Array<RecipeEcosystem>>;
};

/**
 * Flat vertices-and-edges representation of a composite recipe with
 * `org.openrewrite.Singleton` deduplication pre-applied. Produced by the
 * marketplace backend and served to visualization clients in one round trip.
 */
export type RecipeGraph = {
  __typename?: 'RecipeGraph';
  edges: Array<RecipeGraphEdge>;
  /** ID of the root (entry-point) vertex in the graph. */
  rootVertexId: Scalars['Int']['output'];
  vertices: Array<RecipeGraphVertex>;
};

export type RecipeGraphEdge = {
  __typename?: 'RecipeGraphEdge';
  from: Scalars['Int']['output'];
  to: Scalars['Int']['output'];
  type: RecipeGraphEdgeType;
};

export type RecipeGraphEdgeType =
  /** Target recipe is used as a precondition on the parent composite recipe. */
  | 'PRECONDITION'
  /** Target recipe appears in the parent composite recipe's recipeList. */
  | 'RECIPE'
  /**
   * Back-pointer to a previously emitted Singleton recipe. Used in place of
   * a RECIPE or PRECONDITION edge whenever a Singleton recipe would otherwise
   * be re-expanded into the graph; the target's full subtree is reachable
   * from the original occurrence.
   */
  | 'REFERENCE';

/**
 * A vertex in a RecipeGraph: a full recipe occurrence with its configured
 * options. Recipes that declare `org.openrewrite.Singleton` as a precondition
 * are deduplicated — additional occurrences are expressed as REFERENCE edges
 * pointing back to the first occurrence rather than as separate vertices.
 */
export type RecipeGraphVertex = {
  __typename?: 'RecipeGraphVertex';
  /**
   * The recipe this vertex represents. Carries recipe name (as `id`),
   * displayName, instanceName, options, bundle, dataTables, etc. — reuse
   * the existing RecipeDescriptor type rather than duplicating fields here.
   */
  descriptor: RecipeDescriptor;
  id: Scalars['Int']['output'];
  /**
   * True if this recipe declares `org.openrewrite.Singleton` as a precondition,
   * meaning additional occurrences in the graph appear as REFERENCE edges
   * pointing back to this vertex.
   */
  isSingleton: Scalars['Boolean']['output'];
};

export type RecipeInput = {
  /**
   * Fully-qualified recipe ID.
   * Example: `org.openrewrite.java.search.FindMethods`
   */
  id: Scalars['ID']['input'];
  options?: InputMaybe<Array<RecipeOptionInput>>;
};

/**
 * Common fields for all recipe installation states.
 * Use `__typename` to determine the current state.
 */
export type RecipeInstallation = {
  bundle: RecipeBundle;
  id: Scalars['ID']['output'];
  startedAt: Scalars['DateTime']['output'];
};

/**
 * -----------------------------------------------------------------------------
 * Recipe Installation Connection (Pagination)
 * -----------------------------------------------------------------------------
 */
export type RecipeInstallationConnection = {
  __typename?: 'RecipeInstallationConnection';
  count: Scalars['Int']['output'];
  edges: Array<RecipeInstallationEdge>;
  pageInfo: PageInfo;
};

export type RecipeInstallationEdge = {
  __typename?: 'RecipeInstallationEdge';
  cursor: Scalars['String']['output'];
  node: RecipeInstallation;
  /**
   * The organization to which this installation was made. If the installation is a universal
   * or user installation, this field will be null.
   * @deprecated Use `scope` instead. It discriminates universal/org/user explicitly.
   */
  organization?: Maybe<Organization>;
  /**
   * The user who initiated this installation. Null when the install pre-dates the
   * introduction of this column or its state record has been pruned by retention.
   */
  requestedBy?: Maybe<User>;
  /** Where this installation lives: universal, an organization, or a specific user. */
  scope: RecipeInstallationScope;
  /**
   * The user whose marketplace this installation was made to. If the installation is a
   * universal or organization installation, this field will be null.
   * @deprecated Use `scope` instead. It discriminates universal/org/user explicitly.
   */
  user?: Maybe<User>;
};

/** Installation failed with an error. */
export type RecipeInstallationError = RecipeInstallation & {
  __typename?: 'RecipeInstallationError';
  bundle: RecipeBundle;
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Human-readable error message. */
  message: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
};

/** Installation completed successfully. */
export type RecipeInstallationFinished = RecipeInstallation & {
  __typename?: 'RecipeInstallationFinished';
  bundle: RecipeBundle;
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The recipes that were installed. */
  recipes: Array<RecipeDescriptor>;
  startedAt: Scalars['DateTime']['output'];
};

export type RecipeInstallationOrderByField =
  | 'ECOSYSTEM'
  | 'FINISHED_AT'
  | 'PACKAGE_NAME'
  | 'STARTED_AT'
  | 'STATUS'
  | 'VERSION';

export type RecipeInstallationOrderByInput = {
  direction?: SortOrder;
  field: RecipeInstallationOrderByField;
};

/** Installation is actively loading and resolving the recipe bundle. */
export type RecipeInstallationProcessing = RecipeInstallation & {
  __typename?: 'RecipeInstallationProcessing';
  bundle: RecipeBundle;
  id: Scalars['ID']['output'];
  /** Progress from 0.0 to 1.0, if available. */
  progress?: Maybe<Scalars['Float']['output']>;
  startedAt: Scalars['DateTime']['output'];
};

/** Installation is queued and waiting to be processed. */
export type RecipeInstallationQueued = RecipeInstallation & {
  __typename?: 'RecipeInstallationQueued';
  bundle: RecipeBundle;
  id: Scalars['ID']['output'];
  startedAt: Scalars['DateTime']['output'];
};

/** Discriminates where a `RecipeInstallation` lives. */
export type RecipeInstallationScope = ChangesetInstallScope | OrganizationInstallScope | UniversalInstallScope | UserInstallScope;

export type RecipeInstallationScopeFilter = {
  _eq?: InputMaybe<RecipeInstallationScopeType>;
  _in?: InputMaybe<Array<RecipeInstallationScopeType>>;
  _neq?: InputMaybe<RecipeInstallationScopeType>;
  _nin?: InputMaybe<Array<RecipeInstallationScopeType>>;
};

/**
 * The kind of scope a `RecipeInstallation` lives in -- the discriminant of the
 * `RecipeInstallationScope` union, exposed here for `where` filtering.
 */
export type RecipeInstallationScopeType =
  | 'CHANGESET'
  | 'ORGANIZATION'
  | 'UNIVERSAL'
  | 'USER';

export type RecipeInstallationStatus =
  | 'ERROR'
  | 'FINISHED'
  | 'PROCESSING'
  | 'QUEUED';

export type RecipeInstallationStatusFilter = {
  _eq?: InputMaybe<RecipeInstallationStatus>;
  _in?: InputMaybe<Array<RecipeInstallationStatus>>;
  _neq?: InputMaybe<RecipeInstallationStatus>;
  _nin?: InputMaybe<Array<RecipeInstallationStatus>>;
};

export type RecipeInstallationWhereInput = {
  _and?: InputMaybe<Array<RecipeInstallationWhereInput>>;
  _not?: InputMaybe<RecipeInstallationWhereInput>;
  _or?: InputMaybe<Array<RecipeInstallationWhereInput>>;
  /** Filter by bundle properties (packageName, ecosystem, version, etc.). */
  bundle?: InputMaybe<RecipeBundleWhereInput>;
  id?: InputMaybe<IdFilter>;
  organization?: InputMaybe<IdFilter>;
  /**
   * Filter by scope kind (universal, organization, or user). Complements the
   * `organization`/`user` filters, which match a specific id/email; this matches
   * the kind of scope. Can only narrow the set of installations already visible
   * to the caller -- it is not an access-control bypass.
   */
  scope?: InputMaybe<RecipeInstallationScopeFilter>;
  startedAt?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<RecipeInstallationStatusFilter>;
  user?: InputMaybe<UserWhereInput>;
};

export type RecipeMarketplace = {
  __typename?: 'RecipeMarketplace';
  categories: RecipeCategoryConnection;
  installations: RecipeInstallationConnection;
  recipes: RecipeDescriptorConnection;
};


export type RecipeMarketplaceCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecipeCategoryOrderByInput>>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


export type RecipeMarketplaceInstallationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecipeInstallationOrderByInput>>;
  where?: InputMaybe<RecipeInstallationWhereInput>;
};


export type RecipeMarketplaceRecipesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecipeOrderByInput>>;
  where?: InputMaybe<RecipeWhereInput>;
};

export type RecipeOptionInput = {
  /** Option name. Example: `methodPattern` */
  name: Scalars['String']['input'];
  /** Option value. Example: `java.util.List add(..)` */
  value: Scalars['Object']['input'];
};

export type RecipeOptionValue = {
  __typename?: 'RecipeOptionValue';
  name: Scalars['String']['output'];
  value: Scalars['Object']['output'];
};

export type RecipeOptionsMessage = Message & {
  __typename?: 'RecipeOptionsMessage';
  id: Scalars['ID']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  options: Array<Option>;
  state: MessageState;
  user: User;
};

export type RecipeOrderByField =
  | 'DISPLAY_NAME'
  | 'ID'
  | 'RECIPE_COUNT'
  | 'RELEVANCE';

export type RecipeOrderByInput = {
  direction?: SortOrder;
  field: RecipeOrderByField;
};

/**
 * -----------------------------------------------------------------------------
 * Recipe Run File Change
 * -----------------------------------------------------------------------------
 */
export type RecipeRunFileChange = FileChange & {
  __typename?: 'RecipeRunFileChange';
  afterSourcePath?: Maybe<Scalars['Path']['output']>;
  beforeSourcePath?: Maybe<Scalars['Path']['output']>;
  diff?: Maybe<Patch>;
  path: Scalars['Path']['output'];
  /**
   * Recipe chains that contributed changes to this file. Each inner list is one
   * mutation event's call stack, ordered root composite first to leaf recipe last
   * (the leaf is the narrowest recipe that actually performed the change).
   */
  recipesThatMadeChanges: Array<Array<RecipeDescriptor>>;
};


/**
 * -----------------------------------------------------------------------------
 * Recipe Run File Change
 * -----------------------------------------------------------------------------
 */
export type RecipeRunFileChangeDiffArgs = {
  markupLevel?: InputMaybe<MarkupLevel>;
  showWhitespaceOnlyChanges?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Long-running recipe execution started by the LLM. Carries a typed
 * progress envelope while IN_PROGRESS — clients should read `progress`
 * rather than poking at a free-form payload. When the run reaches a
 * terminal state, `recipeRun` resolves via federation.
 */
export type RecipeRunMessage = Message & {
  __typename?: 'RecipeRunMessage';
  id: Scalars['ID']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  /** Typed progress snapshot while the run is IN_PROGRESS. */
  progress?: Maybe<RecipeRunProgress>;
  recipeRun?: Maybe<OrganizationRecipeRun>;
  state: MessageState;
  user: User;
};

/**
 * Priority level for recipe runs, by how many repositories a run covers, each counted once however
 * many of the organization's organizations list it.
 * HIGH priority runs cover at most 100 repositories, as a run over a small organization or one kept to
 * a changeset does.
 * LOW priority runs cover more.
 */
export type RecipeRunPriority =
  | 'HIGH'
  | 'LOW';

/** Typed progress envelope for an in-flight recipe run. */
export type RecipeRunProgress = {
  __typename?: 'RecipeRunProgress';
  recipeRunId?: Maybe<Scalars['ID']['output']>;
  reposFinished?: Maybe<Scalars['Int']['output']>;
  reposQueued?: Maybe<Scalars['Int']['output']>;
  reposRunning?: Maybe<Scalars['Int']['output']>;
  reposTotal?: Maybe<Scalars['Int']['output']>;
};

export type RecipeRunTotals = {
  __typename?: 'RecipeRunTotals';
  filesChanged: Scalars['Int']['output'];
  filesSearched: Scalars['Int']['output'];
  filesWithResults: Scalars['Int']['output'];
  repositoriesInProgress: Scalars['Int']['output'];
  repositoriesSuccessful: Scalars['Int']['output'];
  repositoriesWithErrors: Scalars['Int']['output'];
  repositoriesWithNoChanges: Scalars['Int']['output'];
  repositoriesWithResults: Scalars['Int']['output'];
  timeSavings?: Maybe<Scalars['Duration']['output']>;
  totalMarkers: Scalars['Int']['output'];
};

export type RecipeSearchMessage = Message & {
  __typename?: 'RecipeSearchMessage';
  id: Scalars['ID']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  searchResults: Array<RecipeDescriptor>;
  state: MessageState;
  user: User;
};

/** Identifies the installed bundle to uninstall — exactly one field must be set. */
export type RecipeUninstallSelector = {
  /** The bundle's package name, as listed on a non-YAML `RecipeBundle`. */
  packageName?: InputMaybe<Scalars['String']['input']>;
  /**
   * A recipe id provided by the bundle to uninstall, resolved to the bundle's package
   * name server-side.
   *
   * Removes the ENTIRE bundle that provides this recipe — every recipe that bundle
   * installed, not just this one. For a single-recipe bundle (such as a Builder recipe)
   * that is exactly the one recipe; for a multi-recipe bundle it removes all of them.
   */
  recipeId?: InputMaybe<Scalars['String']['input']>;
};

/** Result of an uninstall operation. */
export type RecipeUninstallation = {
  __typename?: 'RecipeUninstallation';
  /** The number of recipes that were removed. */
  removedCount: Scalars['Int']['output'];
};

/**
 * Filter input for Recipe queries.
 * Use `query` for semantic search, or use field filters for exact matching.
 */
export type RecipeWhereInput = {
  _and?: InputMaybe<Array<RecipeWhereInput>>;
  _not?: InputMaybe<RecipeWhereInput>;
  _or?: InputMaybe<Array<RecipeWhereInput>>;
  /** Filter by display name. */
  displayName?: InputMaybe<StringFilter>;
  /** Filter by recipe ID (fully qualified recipe name). */
  id?: InputMaybe<StringFilter>;
  /** Semantic search query - searches recipe names, descriptions, and content. */
  query?: InputMaybe<Scalars['String']['input']>;
};

export type ReindexResult = {
  __typename?: 'ReindexResult';
  /** Number of repository cursors that were reset. */
  resetCount: Scalars['Int']['output'];
  /** The timestamp cursors were rewound to. */
  since: Scalars['DateTime']['output'];
};

/**
 * The current viewer's read access to a specific repository (per-repo SCM check, not just a
 * token for the origin).
 */
export type RepoAccess =
  /** The viewer has a token for the origin and read access to the repository. */
  | 'ALLOWED'
  /** The viewer can't read this repository — either access is explicitly denied, or auth:z failed closed on a transient SCM/resolution error or invalid input (see RepoAccess in core). Surface a "you don't have access" message rather than empty results. */
  | 'DENIED'
  /** The viewer has no SCM token for the origin, so access can't be evaluated. Surface an authorize prompt. */
  | 'UNAUTHENTICATED';

/**
 * Repository-level changeset types for viewing changes within a repository.
 * Used by organization-level changesets and by SCM for commit operations.
 * Stub for Repository - owned by organization service
 * Using regular type (not extend) because DGS codegen needs to generate the class
 */
export type Repository = {
  __typename?: 'Repository';
  branch: Scalars['String']['output'];
  changeset?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lstArtifact: LstArtifact;
  origin: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

/**
 * Authorization status for accessing repository content.
 * Resolved by the changeset reader using a batch check against the authorization service.
 */
export type RepositoryAuthorization = {
  __typename?: 'RepositoryAuthorization';
  /**
   * The current viewer's read access to this specific repository. Drives whether the UI
   * renders content (ALLOWED), a "you don't have access" message (DENIED), or an authorize
   * prompt (UNAUTHENTICATED).
   */
  access: RepoAccess;
  /**
   * What to tell the viewer when `access` isn't ALLOWED, e.g. that their token needs SAML SSO
   * authorization or that the SCM is rate-limiting access checks.
   */
  message?: Maybe<Scalars['String']['output']>;
  /** The VCS origin (e.g., github.com). */
  origin: Scalars['String']['output'];
};

export type RepositoryChangeset = {
  /**
   * Authorization status for accessing this repository's content.
   * Check this before accessing file results.
   */
  authorization: RepositoryAuthorization;
  repository: Repository;
  /** File-level changes within this repository. */
  results: FileChangeConnection;
};


export type RepositoryChangesetResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileChangeOrderByInput>>;
  where?: InputMaybe<FileChangeWhereInput>;
};

/**
 * Paginated connection for repository changesets.
 *
 * `completed` indicates how many repositories have finished processing:
 * - For BatchChange: completed always equals count (all repositories are pre-processed).
 * - For OrganizationRecipeRun: completed counts repository runs in a terminal state
 *   (regardless of success/failure), excluding canceled runs. A canceled run shows
 *   the completion status reached prior to cancellation.
 *
 * Sync totals (`syncPending`, `synced`, `syncFailed`, `syncCanceled`, `syncSkipped`)
 * track repository sync progress as each repository's LST is synced. Their sum equals `count`.
 */
export type RepositoryChangesetConnection = {
  __typename?: 'RepositoryChangesetConnection';
  completed: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  edges: Array<RepositoryChangesetEdge>;
  pageInfo: PageInfo;
  /**
   * Every SCM organization (the first segment of a repository path) among this connection's
   * repositories, with its repository count. Ignores pagination, so it lists organizations whose
   * repositories are not in the requested page. Null where the resolver does not compute it.
   */
  scmOrganizations?: Maybe<Array<ScmOrganizationRepositoryCount>>;
  /** Repositories whose sync was canceled before completion. */
  syncCanceled: Scalars['Int']['output'];
  /** Repositories that failed to sync. */
  syncFailed: Scalars['Int']['output'];
  /** Repositories not yet synced. */
  syncPending: Scalars['Int']['output'];
  /** Repositories the CLI skipped during sync (typically: no LST available). */
  syncSkipped: Scalars['Int']['output'];
  /** Repositories successfully synced. */
  synced: Scalars['Int']['output'];
};

export type RepositoryChangesetEdge = {
  __typename?: 'RepositoryChangesetEdge';
  cursor: Scalars['String']['output'];
  node: RepositoryChangeset;
};

export type RepositoryChangesetOrderByField =
  | 'FILES_CHANGED'
  | 'ORIGIN'
  | 'PATH'
  /**
   * The repository's `results` count, so a search-only recipe (which changes no files) can
   * rank repositories by how much it found.
   */
  | 'RESULTS'
  /**
   * Run result state (the displayed status: Queued/Running/Success/Error/No LST/Canceled).
   * A repository that finished but whose recipe produced error markers sorts as ERROR,
   * matching how it is rendered, so error repositories group together rather than being
   * interleaved with finished ones.
   */
  | 'STATE'
  | 'SYNC_STATUS';

/**
 * -----------------------------------------------------------------------------
 * Ordering
 * -----------------------------------------------------------------------------
 */
export type RepositoryChangesetOrderByInput = {
  direction?: SortOrder;
  field: RepositoryChangesetOrderByField;
};

/**
 * Result state of a repository within a changeset. A RepositoryRevision has no state of its own,
 * since a push either landed or was refused, and neither has a RepositorySearchResult, which is
 * what a search found; both count as SUCCESS here.
 */
export type RepositoryChangesetState =
  | 'CANCELED'
  | 'ERROR'
  | 'NO_LST'
  | 'QUEUED'
  | 'RUNNING'
  | 'SUCCESS';

export type RepositoryChangesetStateFilter = {
  _eq?: InputMaybe<RepositoryChangesetState>;
  _in?: InputMaybe<Array<RepositoryChangesetState>>;
  _neq?: InputMaybe<RepositoryChangesetState>;
  _nin?: InputMaybe<Array<RepositoryChangesetState>>;
};

/** Filter for repository changesets. */
export type RepositoryChangesetWhereInput = {
  /** Logical AND - all conditions must match. */
  _and?: InputMaybe<Array<RepositoryChangesetWhereInput>>;
  /** Logical NOT - negates the condition. */
  _not?: InputMaybe<RepositoryChangesetWhereInput>;
  /** Logical OR - at least one condition must match. */
  _or?: InputMaybe<Array<RepositoryChangesetWhereInput>>;
  /** Filter by repository branch. */
  branch?: InputMaybe<StringFilter>;
  /**
   * Filter files within matching repositories.
   * Useful for filtering to specific file patterns (e.g., all build.gradle.kts files).
   */
  files?: InputMaybe<FileChangeWhereInput>;
  /** Only return repositories with results (filesWithResults > 0). */
  onlyWithResults?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by repository origin. */
  origin?: InputMaybe<StringFilter>;
  /** Filter by repository path. */
  path?: InputMaybe<StringFilter>;
  /** Filter by repository result state. */
  state?: InputMaybe<RepositoryChangesetStateFilter>;
};

/**
 * A commit result for a single repository within an organization-level commit operation.
 * Use `__typename` to determine the current state.
 */
export type RepositoryCommit = {
  repository: Repository;
};

/**
 * Repository commit was canceled.
 * Use `options.__typename` to determine the specific commit type.
 */
export type RepositoryCommitCanceled = RepositoryCommit & {
  __typename?: 'RepositoryCommitCanceled';
  finishedAt: Scalars['DateTime']['output'];
  /** The commit options. Use `__typename` to determine commit type. */
  options: CommitOptions;
  repository: Repository;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * -----------------------------------------------------------------------------
 * Connections
 * -----------------------------------------------------------------------------
 */
export type RepositoryCommitConnection = {
  __typename?: 'RepositoryCommitConnection';
  /**
   * Count of repository commits that have reached a terminal state
   * (succeeded, failed, canceled, or no changes). Pair with `count`
   * to show progress: "Completed X / Y". This and the three totals
   * below span the whole job (after any `where` filter), not the
   * current page; canceled has no total of its own, so subtract the
   * other three from this.
   */
  completedCount: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  edges: Array<RepositoryCommitEdge>;
  /** Terminal with an error; the repository carries the message. */
  failedCount: Scalars['Int']['output'];
  /** Terminal with the patch applied but nothing left to commit. */
  noChangesCount: Scalars['Int']['output'];
  pageInfo: PageInfo;
  /** Terminal with a branch pushed or a pull request opened. */
  succeededCount: Scalars['Int']['output'];
};

export type RepositoryCommitEdge = {
  __typename?: 'RepositoryCommitEdge';
  cursor: Scalars['String']['output'];
  node: RepositoryCommit;
};

/**
 * Repository commit failed with an error.
 * Use `options.__typename` to determine the specific commit type.
 */
export type RepositoryCommitFailed = RepositoryCommit & {
  __typename?: 'RepositoryCommitFailed';
  /** Human-readable error message. */
  errorMessage: Scalars['String']['output'];
  finishedAt: Scalars['DateTime']['output'];
  /** The commit options. Use `__typename` to determine commit type. */
  options: CommitOptions;
  repository: Repository;
  /** Number of retry attempts made. */
  retryCount?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Repository commit completed but yielded no changes.
 * Generally occurs when applying a patch does not produce any changes to commit.
 * Use `options.__typename` to determine the specific commit type.
 */
export type RepositoryCommitNoChanges = RepositoryCommit & {
  __typename?: 'RepositoryCommitNoChanges';
  finishedAt: Scalars['DateTime']['output'];
  /** The commit options. Use `__typename` to determine commit type. */
  options: CommitOptions;
  repository: Repository;
  startedAt: Scalars['DateTime']['output'];
};

export type RepositoryCommitOrderByField =
  | 'BRANCH'
  | 'ORIGIN'
  | 'PATH'
  | 'STARTED_AT'
  | 'STATUS'
  /**
   * Effective last-updated time: `finishedAt` when the repository has reached a terminal
   * state, otherwise `startedAt`.
   */
  | 'UPDATED_AT';

export type RepositoryCommitOrderByInput = {
  direction?: SortOrder;
  field: RepositoryCommitOrderByField;
};

/**
 * Repository commit is queued and waiting to be processed.
 * Use `options.__typename` to determine the specific commit type.
 */
export type RepositoryCommitQueued = RepositoryCommit & {
  __typename?: 'RepositoryCommitQueued';
  /** The commit options. Use `__typename` to determine commit type. */
  options: CommitOptions;
  /** Time when rate limit expires (if rate limited). */
  rateLimitReset?: Maybe<Scalars['DateTime']['output']>;
  repository: Repository;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Repository commit is actively being processed.
 * Use `options.__typename` to determine the specific commit type.
 */
export type RepositoryCommitRunning = RepositoryCommit & {
  __typename?: 'RepositoryCommitRunning';
  /** The commit options. Use `__typename` to determine commit type. */
  options: CommitOptions;
  repository: Repository;
  startedAt: Scalars['DateTime']['output'];
};

/** Result status of a single repository within a commit operation. */
export type RepositoryCommitStatus =
  | 'CANCELED'
  | 'FAILED'
  | 'NO_CHANGES'
  | 'QUEUED'
  | 'RUNNING'
  | 'SUCCEEDED';

export type RepositoryCommitStatusFilter = {
  _eq?: InputMaybe<RepositoryCommitStatus>;
  _in?: InputMaybe<Array<RepositoryCommitStatus>>;
  _neq?: InputMaybe<RepositoryCommitStatus>;
  _nin?: InputMaybe<Array<RepositoryCommitStatus>>;
};

/**
 * Repository commit completed successfully.
 * Use `__typename` to determine the specific commit type.
 */
export type RepositoryCommitSucceeded = {
  finishedAt: Scalars['DateTime']['output'];
  repository: Repository;
  /** Link to the commit or pull request result. */
  resultLink?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
};

/**
 * Filter input for repository-level commit queries. Applied across the whole commit worklist
 * before pagination, so a search matches repositories that fall on later pages.
 */
export type RepositoryCommitWhereInput = {
  _and?: InputMaybe<Array<RepositoryCommitWhereInput>>;
  _not?: InputMaybe<RepositoryCommitWhereInput>;
  _or?: InputMaybe<Array<RepositoryCommitWhereInput>>;
  /** Filter by branch. */
  branch?: InputMaybe<StringFilter>;
  /** Filter by repository origin (the SCM host, e.g. github.com). */
  origin?: InputMaybe<StringFilter>;
  /**
   * Filter by repository path (e.g. moderneinc/rewrite). Use `_icontains` to back the commit
   * view's repository search box.
   */
  path?: InputMaybe<StringFilter>;
  /** Filter by commit result status. */
  status?: InputMaybe<RepositoryCommitStatusFilter>;
};

export type RepositoryConnection = {
  __typename?: 'RepositoryConnection';
  count: Scalars['Int']['output'];
  edges: Array<RepositoryEdge>;
  pageInfo: PageInfo;
};

export type RepositoryEdge = {
  __typename?: 'RepositoryEdge';
  cursor: Scalars['String']['output'];
  node: Repository;
};

export type RepositoryErrorReason =
  | 'FAILED_LOAD_AST'
  | 'FAILED_LOAD_RECIPE'
  | 'RECIPE_ERROR'
  | 'TIMEOUT';

export type RepositoryInput = {
  branch: Scalars['String']['input'];
  origin: Scalars['String']['input'];
  path: Scalars['String']['input'];
};

export type RepositoryOrderByField =
  | 'BRANCH'
  | 'CHANGESET'
  | 'LST_ARTIFACT_PUBLISHED'
  | 'ORIGIN'
  | 'PATH';

export type RepositoryOrderByInput = {
  direction?: SortOrder;
  field: RepositoryOrderByField;
};

/**
 * -----------------------------------------------------------------------------
 * Repository Recipe Run - State Machine
 * -----------------------------------------------------------------------------
 */
export type RepositoryRecipeRun = {
  authorization: RepositoryAuthorization;
  repository: Repository;
  results: FileChangeConnection;
  syncStatus?: Maybe<RepositorySyncStatus>;
};


/**
 * -----------------------------------------------------------------------------
 * Repository Recipe Run - State Machine
 * -----------------------------------------------------------------------------
 */
export type RepositoryRecipeRunResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileChangeOrderByInput>>;
  where?: InputMaybe<FileChangeWhereInput>;
};

export type RepositoryRecipeRunCanceled = RepositoryChangeset & RepositoryRecipeRun & {
  __typename?: 'RepositoryRecipeRunCanceled';
  authorization: RepositoryAuthorization;
  /**
   * Why this repository stopped, when there is more to say than "the run was canceled".
   * Null for the ordinary case, where a repository simply had not run yet.
   *
   * Set when the CLI had to leave the repository behind because it never stopped when
   * asked, in which case this carries the stack it was wedged in and the source file it
   * was on. That is the only account of such a wedge that leaves the host running the CLI.
   */
  message?: Maybe<Scalars['String']['output']>;
  repository: Repository;
  results: FileChangeConnection;
  syncStatus?: Maybe<RepositorySyncStatus>;
};


export type RepositoryRecipeRunCanceledResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileChangeOrderByInput>>;
  where?: InputMaybe<FileChangeWhereInput>;
};

export type RepositoryRecipeRunConnection = {
  __typename?: 'RepositoryRecipeRunConnection';
  count: Scalars['Int']['output'];
  edges: Array<RepositoryRecipeRunEdge>;
  pageInfo: PageInfo;
};

export type RepositoryRecipeRunEdge = {
  __typename?: 'RepositoryRecipeRunEdge';
  cursor: Scalars['String']['output'];
  node: RepositoryRecipeRun;
};

export type RepositoryRecipeRunError = RepositoryChangeset & RepositoryRecipeRun & {
  __typename?: 'RepositoryRecipeRunError';
  authorization: RepositoryAuthorization;
  errorReason?: Maybe<RepositoryErrorReason>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  repository: Repository;
  results: FileChangeConnection;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  syncStatus?: Maybe<RepositorySyncStatus>;
};


export type RepositoryRecipeRunErrorResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileChangeOrderByInput>>;
  where?: InputMaybe<FileChangeWhereInput>;
};

export type RepositoryRecipeRunFinished = RepositoryChangeset & RepositoryRecipeRun & {
  __typename?: 'RepositoryRecipeRunFinished';
  authorization: RepositoryAuthorization;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  repository: Repository;
  results: FileChangeConnection;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  syncStatus?: Maybe<RepositorySyncStatus>;
  timeSavings?: Maybe<Scalars['Duration']['output']>;
};


export type RepositoryRecipeRunFinishedResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileChangeOrderByInput>>;
  where?: InputMaybe<FileChangeWhereInput>;
};

export type RepositoryRecipeRunNoLst = RepositoryChangeset & RepositoryRecipeRun & {
  __typename?: 'RepositoryRecipeRunNoLst';
  authorization: RepositoryAuthorization;
  repository: Repository;
  results: FileChangeConnection;
  syncStatus?: Maybe<RepositorySyncStatus>;
};


export type RepositoryRecipeRunNoLstResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileChangeOrderByInput>>;
  where?: InputMaybe<FileChangeWhereInput>;
};

export type RepositoryRecipeRunOrderByField =
  | 'ORIGIN'
  | 'PATH'
  | 'STATE';

export type RepositoryRecipeRunOrderByInput = {
  direction?: SortOrder;
  field: RepositoryRecipeRunOrderByField;
};

export type RepositoryRecipeRunQueued = RepositoryChangeset & RepositoryRecipeRun & {
  __typename?: 'RepositoryRecipeRunQueued';
  authorization: RepositoryAuthorization;
  queuedAt?: Maybe<Scalars['DateTime']['output']>;
  repository: Repository;
  results: FileChangeConnection;
  syncStatus?: Maybe<RepositorySyncStatus>;
};


export type RepositoryRecipeRunQueuedResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileChangeOrderByInput>>;
  where?: InputMaybe<FileChangeWhereInput>;
};

export type RepositoryRecipeRunRunning = RepositoryChangeset & RepositoryRecipeRun & {
  __typename?: 'RepositoryRecipeRunRunning';
  authorization: RepositoryAuthorization;
  repository: Repository;
  results: FileChangeConnection;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  syncStatus?: Maybe<RepositorySyncStatus>;
};


export type RepositoryRecipeRunRunningResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileChangeOrderByInput>>;
  where?: InputMaybe<FileChangeWhereInput>;
};

export type RepositoryRecipeRunWhereInput = {
  _and?: InputMaybe<Array<RepositoryRecipeRunWhereInput>>;
  _not?: InputMaybe<RepositoryRecipeRunWhereInput>;
  _or?: InputMaybe<Array<RepositoryRecipeRunWhereInput>>;
  origin?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
};

/**
 * One repository as one push left it, a fact rather than a process: it landed or the remote
 * refused it, so it has no state. Its `.moderne/run/<id>` directory is named by `id`.
 */
export type RepositoryRevision = RepositoryChangeset & {
  __typename?: 'RepositoryRevision';
  /** The agent that pushed it, or null for a push from a checkout no agent worked in. */
  agent?: Maybe<Agent>;
  /**
   * This repository's earlier changes, newest first, down to the recipe run's result when a run
   * made the changeset, or what the search found when a saved search did. A chain rather than a
   * graph because the remote refuses a push that does not fast-forward the tip; accept a merge
   * and this becomes `parents`.
   */
  ancestors: Array<RepositoryChangeset>;
  authorization: RepositoryAuthorization;
  id: Scalars['ID']['output'];
  /** The `moderne-message` push option. */
  message?: Maybe<Scalars['String']['output']>;
  /**
   * The repository as it stood just before `change`, which is this revision or one of its
   * ancestors: the previous revision, or the recipe run's or the search's result. What a blame
   * range's "prior to this change" opens. Null when only the base commit came before it, or for
   * an id not in this chain.
   */
  priorTo?: Maybe<RepositoryChangeset>;
  pushedAt: Scalars['DateTime']['output'];
  /** The identity the remote verified at the push, which the commit's author line need not be. */
  pushedBy: User;
  repository: Repository;
  /**
   * The whole difference from the base commit to `tipCommit`, however many commits and pushes
   * came before, never the delta of this push alone. What one agent changed is the difference
   * between two revisions' results.
   */
  results: FileChangeConnection;
  /**
   * Provenance only; the objects are not retained. A later push must descend from it or name
   * this change as its parent.
   */
  tipCommit: Scalars['String']['output'];
};


/**
 * One repository as one push left it, a fact rather than a process: it landed or the remote
 * refused it, so it has no state. Its `.moderne/run/<id>` directory is named by `id`.
 */
export type RepositoryRevisionPriorToArgs = {
  change: Scalars['ID']['input'];
};


/**
 * One repository as one push left it, a fact rather than a process: it landed or the remote
 * refused it, so it has no state. Its `.moderne/run/<id>` directory is named by `id`.
 */
export type RepositoryRevisionResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileChangeOrderByInput>>;
  where?: InputMaybe<FileChangeWhereInput>;
};

/**
 * One repository the search covered: what it found there, as a recipe run's search results are
 * shown. Its `results` are the files it matched, each a `RecipeRunFileChange` whose `diff` changes
 * nothing and marks every match with a `SearchResult` marker.
 */
export type RepositorySearchResult = RepositoryChangeset & {
  __typename?: 'RepositorySearchResult';
  authorization: RepositoryAuthorization;
  /** Files with at least one match. */
  filesWithResults: Scalars['Int']['output'];
  /** Matches in them. */
  matches: Scalars['Int']['output'];
  repository: Repository;
  results: FileChangeConnection;
};


/**
 * One repository the search covered: what it found there, as a recipe run's search results are
 * shown. Its `results` are the files it matched, each a `RecipeRunFileChange` whose `diff` changes
 * nothing and marks every match with a `SearchResult` marker.
 */
export type RepositorySearchResultResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileChangeOrderByInput>>;
  where?: InputMaybe<FileChangeWhereInput>;
};

/**
 * Sync status of a repository within a recipe run.
 * Tracks whether the repository has been synced (cloned + LST downloaded)
 * before the recipe execution phase begins.
 *
 * `SKIPPED` indicates the CLI elected not to sync the repository — typically
 * because there is no LST available to fetch — and is distinct from `FAILED`,
 * which indicates an actual error during the sync attempt. `CANCELED` is set
 * when sync was interrupted (e.g., the run was canceled before the repository's
 * sync completed).
 */
export type RepositorySyncStatus =
  | 'CANCELED'
  | 'FAILED'
  | 'PENDING'
  | 'SKIPPED'
  | 'SYNCED';

/** Filter input for Repository queries using typed field filters. */
export type RepositoryWhereInput = {
  /** Logical AND - all conditions must match */
  _and?: InputMaybe<Array<RepositoryWhereInput>>;
  /** Logical NOT - negates the condition */
  _not?: InputMaybe<RepositoryWhereInput>;
  /** Logical OR - at least one condition must match */
  _or?: InputMaybe<Array<RepositoryWhereInput>>;
  branch?: InputMaybe<StringFilter>;
  changeset?: InputMaybe<StringFilter>;
  lstArtifact?: InputMaybe<LstArtifactWhereInput>;
  origin?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
};

export type ReviewDecision =
  | 'APPROVED'
  | 'CHANGES_REQUESTED'
  | 'REVIEW_NOT_REQUIRED'
  | 'REVIEW_REQUIRED'
  | 'UNKNOWN';

export type ReviewDecisionFilter = {
  _eq?: InputMaybe<ReviewDecision>;
  _in?: InputMaybe<Array<ReviewDecision>>;
  _neq?: InputMaybe<ReviewDecision>;
  _nin?: InputMaybe<Array<ReviewDecision>>;
};

export type ReviewStatus = {
  __typename?: 'ReviewStatus';
  approvedBy?: Maybe<Array<Scalars['String']['output']>>;
  reviewDecision: ReviewDecision;
};

/** A push's file change: the difference between two trees, with no recipe attribution. */
export type RevisionFileChange = FileChange & {
  __typename?: 'RevisionFileChange';
  afterSourcePath?: Maybe<Scalars['Path']['output']>;
  beforeSourcePath?: Maybe<Scalars['Path']['output']>;
  /**
   * Which change in the repository's chain made each changed line of `diff` what it is, in
   * the order the lines appear in it. Context lines are the base commit's and fall in no range.
   */
  blame: Array<DiffBlameRange>;
  diff?: Maybe<Patch>;
  path: Scalars['Path']['output'];
};


/** A push's file change: the difference between two trees, with no recipe attribution. */
export type RevisionFileChangeDiffArgs = {
  markupLevel?: InputMaybe<MarkupLevel>;
  showWhitespaceOnlyChanges?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RevokeScmTokenInput = {
  /** The VCS origin to revoke the token for (e.g., github.com, gitlab.com). */
  origin: Scalars['String']['input'];
};

/** Result of revoking an SCM OAuth token. */
export type RevokeTokenResult = {
  __typename?: 'RevokeTokenResult';
  /** Error message if revocation failed. */
  error?: Maybe<Scalars['String']['output']>;
  /** True if the token was revoked (or didn't exist). */
  success: Scalars['Boolean']['output'];
};

export type RunDevCenterInput = {
  /** The organization to run DevCenter for. */
  organizationId: Scalars['ID']['input'];
  /** The DevCenter recipe to run. */
  recipeId: Scalars['ID']['input'];
};

/**
 * -----------------------------------------------------------------------------
 * Input Types
 * -----------------------------------------------------------------------------
 */
export type RunRecipeInput = {
  /**
   * A one-off recipe bundle to take the recipe from: the id `mod config recipes bundle push`
   * printed. The bundle's recipes stand in for published recipes of the same names, for this run
   * only, and the run records which bundle it used. A bundle can be cited only by whoever uploaded
   * it, within a day of the upload.
   */
  bundleId?: InputMaybe<Scalars['ID']['input']>;
  /** Exclude files matching these patterns. */
  excludeFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Run against all repositories in this organization, or with `scopeId` against those of them the
   * changeset has results in.
   */
  organizationId: Scalars['ID']['input'];
  /** Optional parent changeset ID this recipe run is derived from. */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** The recipe to run with any configured options. */
  recipe: RecipeInput;
  /**
   * A changeset to keep the run to: of the organization's repositories, the run covers only the ones
   * the changeset has results in, each at its current LST. Those are the repositories its saved
   * search matched in, the ones its recipe run changed or found something in, and the ones a session
   * has pushed to, which is what a team joining the changeset syncs. A run kept to the search that
   * found the work covers everything the work is about without syncing every repository of the
   * organization to find out. The changeset must have finished, and you must be able to see it. The
   * run's `scope` names it.
   */
  scopeId?: InputMaybe<Scalars['ID']['input']>;
};

export type S3Configuration = {
  __typename?: 'S3Configuration';
  connectivity: HttpToolConnectivity;
  endpointUrl?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  resourceId: Scalars['String']['output'];
  skipSsl: Scalars['Boolean']['output'];
  skipValidateConnectivity: Scalars['Boolean']['output'];
};

/**
 * An access token for a specific SCM origin. When provided on a commit mutation,
 * these tokens are preferred over stored OAuth tokens.
 */
export type ScmAccessToken = {
  origin: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ScmConnection = {
  isAuthorized: Scalars['Boolean']['output'];
  resourceId: Scalars['String']['output'];
  tokens: Array<ScmTokenInfo>;
};

/** An SCM organization (GitHub owner, GitLab group, Bitbucket project) and how many repositories it holds. */
export type ScmOrganizationRepositoryCount = {
  __typename?: 'ScmOrganizationRepositoryCount';
  /** Repositories in this organization. */
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /**
   * Sum of each repository's `results` count. Null until every repository has finished,
   * and for runs whose result counts were not precomputed.
   */
  resultCount?: Maybe<Scalars['Int']['output']>;
};

export type ScmTokenInfo = {
  __typename?: 'ScmTokenInfo';
  created: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScmType =
  | 'AZURE_DEVOPS'
  | 'BITBUCKET'
  | 'BITBUCKET_CLOUD'
  | 'GITHUB'
  | 'GITLAB';

export type SearchResult = Marker & {
  __typename?: 'SearchResult';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

/**
 * Handle returned by `createConversation` / `sendMessage`. Clients should
 * poll `conversation.messages(after: initialCursor)` using
 * `turnState.recommendedPollIntervalMs` as the cadence hint.
 */
export type SendMessageResult = {
  __typename?: 'SendMessageResult';
  conversation: Conversation;
  initialCursor: Scalars['String']['output'];
  turnState: ConversationTurnState;
};

export type SortOrder =
  | 'ASC'
  | 'DESC';

export type StringFilter = {
  _contains?: InputMaybe<Scalars['String']['input']>;
  _endsWith?: InputMaybe<Scalars['String']['input']>;
  _eq?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive contains */
  _icontains?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** True to match null values, false to match non-null values */
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  _startsWith?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A text message from either the human user or the chatbot.
 * Check the `user` field to distinguish sender.
 */
export type TextMessage = Message & {
  __typename?: 'TextMessage';
  content: Scalars['Markdown']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  state: MessageState;
  /** True when the LLM response was cut off by the token limit. */
  truncated: Scalars['Boolean']['output'];
  user: User;
};

export type TranscriptConnection = {
  __typename?: 'TranscriptConnection';
  count: Scalars['Int']['output'];
  edges: Array<TranscriptSpanEdge>;
  pageInfo: PageInfo;
};

/**
 * The whole transcript as one OTLP JSON trace, rendered on download rather than stored, since the
 * spans already are.
 */
export type TranscriptExport = {
  __typename?: 'TranscriptExport';
  bytes: Scalars['Int']['output'];
  /** When the spans it renders arrived. */
  uploadedAt: Scalars['DateTime']['output'];
  /** URL path to download the trace (relative to the service base URL). */
  url: Scalars['String']['output'];
};

/** One span of a transcript. Spans are flat; a reader rebuilds the tree from `parentId`. */
export type TranscriptSpan = {
  __typename?: 'TranscriptSpan';
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  kind: TranscriptSpanKind;
  /** The model, the tool, or the agent, by kind. */
  name: Scalars['String']['output'];
  outputTokens?: Maybe<Scalars['Int']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  /** The repository a tool call worked in, when the CLI could tell. */
  repository?: Maybe<Repository>;
  startedAt: Scalars['DateTime']['output'];
};

export type TranscriptSpanEdge = {
  __typename?: 'TranscriptSpanEdge';
  cursor: Scalars['String']['output'];
  node: TranscriptSpan;
};

export type TranscriptSpanKind =
  | 'AGENT_INVOCATION'
  | 'MODEL_CALL'
  | 'TOOL_CALL';

export type TranscriptSpanKindFilter = {
  _eq?: InputMaybe<TranscriptSpanKind>;
  _in?: InputMaybe<Array<TranscriptSpanKind>>;
  _neq?: InputMaybe<TranscriptSpanKind>;
  _nin?: InputMaybe<Array<TranscriptSpanKind>>;
};

export type TranscriptWhereInput = {
  _and?: InputMaybe<Array<TranscriptWhereInput>>;
  _not?: InputMaybe<TranscriptWhereInput>;
  _or?: InputMaybe<Array<TranscriptWhereInput>>;
  branch?: InputMaybe<StringFilter>;
  errorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<TranscriptSpanKindFilter>;
  origin?: InputMaybe<StringFilter>;
  /** One subtree. */
  parentId?: InputMaybe<IdFilter>;
  path?: InputMaybe<StringFilter>;
};

export type UiConfiguration = {
  __typename?: 'UiConfiguration';
  cliDownloadInstructions?: Maybe<CliDownloadInstructionLink>;
  loginLinks?: Maybe<Array<MoreHelpLink>>;
  loginText?: Maybe<Scalars['String']['output']>;
  moreHelp?: Maybe<Array<MoreHelpLink>>;
};

/** The installation lives in the universal marketplace, visible to every tenant. */
export type UniversalInstallScope = {
  __typename?: 'UniversalInstallScope';
  /** Always true. Present so the type has a selectable field. */
  universal: Scalars['Boolean']['output'];
};

export type UpdateUserOrganizationInput = {
  /** The ID of the organization to update. */
  id: Scalars['ID']['input'];
  /** The new name for the organization. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Repositories to include in the organization. If provided, replaces the current list and must name at least one. */
  repositories?: InputMaybe<Array<RepositoryInput>>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  lastActive?: Maybe<Scalars['DateTime']['output']>;
  moddy: Moddy;
  role?: Maybe<UserRole>;
  tokens: AccessTokenConnection;
  /**
   * username is the JWT `name` claim (a display name, e.g. "Scott Jungling"),
   * not the email, so it is not masked. See doc/mask-user-pii-app-stack.md for the
   * residual email-as-username edge case and the planned follow-up.
   */
  username?: Maybe<Scalars['String']['output']>;
};


export type UserTokensArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccessTokenOrderByInput>>;
  where?: InputMaybe<AccessTokenWhereInput>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  count: Scalars['Int']['output'];
  edges: Array<UsersEdge>;
  pageInfo: PageInfo;
};

/** The installation lives in a specific user's personal marketplace. */
export type UserInstallScope = {
  __typename?: 'UserInstallScope';
  user: User;
};

export type UserOrderByField =
  | 'EMAIL'
  | 'LAST_ACTIVE'
  | 'ROLE'
  | 'USERNAME';

export type UserOrderByInput = {
  direction?: SortOrder;
  field: UserOrderByField;
};

export type UserRole =
  | 'ADMIN'
  | 'USER';

export type UserWhereInput = {
  _and?: InputMaybe<Array<UserWhereInput>>;
  _not?: InputMaybe<UserWhereInput>;
  _or?: InputMaybe<Array<UserWhereInput>>;
  email?: InputMaybe<StringFilter>;
  /** Filter by the number of Moderne access tokens the user holds (e.g. { _gt: 0 } for users with at least one token). */
  tokenCount?: InputMaybe<IntFilter>;
};

export type UsersEdge = {
  __typename?: 'UsersEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

/**
 * -----------------------------------------------------------------------------
 * Visualizations
 * -----------------------------------------------------------------------------
 */
export type Visualization = {
  descriptor: VisualizationDescriptor;
  id: Scalars['ID']['output'];
};

/**
 * The reader owns these types and resolves the `visualizations` field on recipe runs.
 * The visualizer provides the runVisualization mutation and uses stubs to reference these.
 */
export type VisualizationAvailable = Visualization & {
  __typename?: 'VisualizationAvailable';
  /** The changeset (recipe run or batch change) this visualization is available for. */
  changesetId: Scalars['ID']['output'];
  descriptor: VisualizationDescriptor;
  id: Scalars['ID']['output'];
};

export type VisualizationConnection = {
  __typename?: 'VisualizationConnection';
  count: Scalars['Int']['output'];
  edges: Array<VisualizationEdge>;
  pageInfo: PageInfo;
};

export type VisualizationDataGridOutput = VisualizationOutput & {
  __typename?: 'VisualizationDataGridOutput';
  /**
   * Moderne data grid JSON, rendered client-side by the grid components
   * (MIME types: application/vnd.moderne.datagrid+json, application/vnd.moderne.treedatagrid+json)
   */
  data: Scalars['Base64']['output'];
  format: DataGridFormat;
};

export type VisualizationDescriptor = {
  __typename?: 'VisualizationDescriptor';
  description: Scalars['Markdown']['output'];
  displayName: Scalars['Markdown']['output'];
  image: Scalars['Base64']['output'];
  name: Scalars['String']['output'];
  options: Array<VisualizationOption>;
};

export type VisualizationEdge = {
  __typename?: 'VisualizationEdge';
  cursor: Scalars['String']['output'];
  node: Visualization;
};

export type VisualizationError = Visualization & {
  __typename?: 'VisualizationError';
  changesetId: Scalars['ID']['output'];
  descriptor: VisualizationDescriptor;
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  repositories: VisualizationRepositoryConnection;
  startedAt: Scalars['DateTime']['output'];
  /** Who ran this visualization. Null for runs that predate attribution. */
  user?: Maybe<User>;
};


export type VisualizationErrorRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type VisualizationFinished = Visualization & {
  __typename?: 'VisualizationFinished';
  changesetId: Scalars['ID']['output'];
  descriptor: VisualizationDescriptor;
  duration?: Maybe<Scalars['Duration']['output']>;
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  output: VisualizationOutput;
  repositories: VisualizationRepositoryConnection;
  startedAt: Scalars['DateTime']['output'];
  /** Who ran this visualization. Null for runs that predate attribution. */
  user?: Maybe<User>;
};


export type VisualizationFinishedRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type VisualizationImageOutput = VisualizationOutput & {
  __typename?: 'VisualizationImageOutput';
  data: Scalars['Base64']['output'];
  format: ImageFormat;
};

export type VisualizationOption = {
  __typename?: 'VisualizationOption';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  example?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  valid?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  value?: Maybe<Scalars['Object']['output']>;
};

export type VisualizationOptionInput = {
  name: Scalars['String']['input'];
  value: Scalars['Object']['input'];
};

export type VisualizationOrderByField =
  | 'STARTED_AT'
  | 'VISUALIZATION';

export type VisualizationOrderByInput = {
  direction?: SortOrder;
  field: VisualizationOrderByField;
};

/**
 * -----------------------------------------------------------------------------
 * Visualization Output Types
 * -----------------------------------------------------------------------------
 */
export type VisualizationOutput = {
  data: Scalars['Base64']['output'];
};

export type VisualizationPlotlyOutput = VisualizationOutput & {
  __typename?: 'VisualizationPlotlyOutput';
  /** Plotly JSON data (MIME type: application/vnd.plotly.v1+json) */
  data: Scalars['Base64']['output'];
};

/**
 * -----------------------------------------------------------------------------
 * Visualization Entity Stubs
 * -----------------------------------------------------------------------------
 * The concrete visualization types are owned by changeset:reader.
 * These entity stubs allow this service to return Visualization from the mutation.
 * The reader resolves the full fields via federation.
 */
export type VisualizationProcessing = Visualization & {
  __typename?: 'VisualizationProcessing';
  changesetId: Scalars['ID']['output'];
  descriptor: VisualizationDescriptor;
  id: Scalars['ID']['output'];
  repositories: VisualizationRepositoryConnection;
  startedAt: Scalars['DateTime']['output'];
  /** Who ran this visualization. Null for runs that predate attribution. */
  user?: Maybe<User>;
};


/**
 * -----------------------------------------------------------------------------
 * Visualization Entity Stubs
 * -----------------------------------------------------------------------------
 * The concrete visualization types are owned by changeset:reader.
 * These entity stubs allow this service to return Visualization from the mutation.
 * The reader resolves the full fields via federation.
 */
export type VisualizationProcessingRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type VisualizationRepository = {
  __typename?: 'VisualizationRepository';
  repository: Repository;
  state: VisualizationRepositoryRunState;
  stateMessage?: Maybe<Scalars['String']['output']>;
};

export type VisualizationRepositoryConnection = {
  __typename?: 'VisualizationRepositoryConnection';
  count: Scalars['Int']['output'];
  edges: Array<VisualizationRepositoryEdge>;
  pageInfo: PageInfo;
};

export type VisualizationRepositoryEdge = {
  __typename?: 'VisualizationRepositoryEdge';
  cursor: Scalars['String']['output'];
  node: VisualizationRepository;
};

/**
 * -----------------------------------------------------------------------------
 * Repository Visualization Types
 * -----------------------------------------------------------------------------
 */
export type VisualizationRepositoryRunState =
  | 'ERROR'
  | 'FINISHED'
  | 'FINISHED_EMPTY'
  | 'NO_LST'
  | 'PROCESSING'
  | 'QUEUED';

export type VisualizationWhereInput = {
  _and?: InputMaybe<Array<VisualizationWhereInput>>;
  _not?: InputMaybe<VisualizationWhereInput>;
  _or?: InputMaybe<Array<VisualizationWhereInput>>;
  id?: InputMaybe<IdFilter>;
  visualization?: InputMaybe<StringFilter>;
};

export type YamlRecipeBundle = RecipeBundle & {
  __typename?: 'YamlRecipeBundle';
  /**
   * The primary recipe in this bundle. When specified, only this recipe
   * is shown in marketplace categories, hiding other recipes from this bundle.
   */
  primary?: Maybe<RecipeDescriptor>;
  recipeCount?: Maybe<Scalars['Int']['output']>;
  requestedVersion?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  yaml: Scalars['Base64']['output'];
};

export type YamlRecipeBundleInput = {
  /**
   * The ID of the primary recipe in this bundle. When specified, only this recipe
   * will be shown in the marketplace categories, hiding other recipes from this bundle.
   * This is used for the Moderne Builder feature where users build complex composite
   * recipes and we don't want to expose intermediate recipes in the marketplace.
   */
  primary?: InputMaybe<Scalars['ID']['input']>;
  yaml: Scalars['Base64']['input'];
};

export const isAuditLogsDownloadAAuditLogsDownloadError = (instance: AuditLogsDownloadError | AuditLogsDownloadFinished | AuditLogsDownloadProcessing | unknown): instance is AuditLogsDownloadError => {
            return (instance as AuditLogsDownloadError)?.__typename === 'AuditLogsDownloadError';
        }
        
export const isAuditLogsDownloadAAuditLogsDownloadFinished = (instance: AuditLogsDownloadError | AuditLogsDownloadFinished | AuditLogsDownloadProcessing | unknown): instance is AuditLogsDownloadFinished => {
            return (instance as AuditLogsDownloadFinished)?.__typename === 'AuditLogsDownloadFinished';
        }
        
export const isAuditLogsDownloadAAuditLogsDownloadProcessing = (instance: AuditLogsDownloadError | AuditLogsDownloadFinished | AuditLogsDownloadProcessing | unknown): instance is AuditLogsDownloadProcessing => {
            return (instance as AuditLogsDownloadProcessing)?.__typename === 'AuditLogsDownloadProcessing';
        }
        
export const isBulkPullRequestActionABulkPullRequestActionCanceled = (instance: BulkPullRequestActionCanceled | BulkPullRequestActionError | BulkPullRequestActionFinished | BulkPullRequestActionQueued | BulkPullRequestActionRunning | unknown): instance is BulkPullRequestActionCanceled => {
            return (instance as BulkPullRequestActionCanceled)?.__typename === 'BulkPullRequestActionCanceled';
        }
        
export const isBulkPullRequestActionABulkPullRequestActionError = (instance: BulkPullRequestActionCanceled | BulkPullRequestActionError | BulkPullRequestActionFinished | BulkPullRequestActionQueued | BulkPullRequestActionRunning | unknown): instance is BulkPullRequestActionError => {
            return (instance as BulkPullRequestActionError)?.__typename === 'BulkPullRequestActionError';
        }
        
export const isBulkPullRequestActionABulkPullRequestActionFinished = (instance: BulkPullRequestActionCanceled | BulkPullRequestActionError | BulkPullRequestActionFinished | BulkPullRequestActionQueued | BulkPullRequestActionRunning | unknown): instance is BulkPullRequestActionFinished => {
            return (instance as BulkPullRequestActionFinished)?.__typename === 'BulkPullRequestActionFinished';
        }
        
export const isBulkPullRequestActionABulkPullRequestActionQueued = (instance: BulkPullRequestActionCanceled | BulkPullRequestActionError | BulkPullRequestActionFinished | BulkPullRequestActionQueued | BulkPullRequestActionRunning | unknown): instance is BulkPullRequestActionQueued => {
            return (instance as BulkPullRequestActionQueued)?.__typename === 'BulkPullRequestActionQueued';
        }
        
export const isBulkPullRequestActionABulkPullRequestActionRunning = (instance: BulkPullRequestActionCanceled | BulkPullRequestActionError | BulkPullRequestActionFinished | BulkPullRequestActionQueued | BulkPullRequestActionRunning | unknown): instance is BulkPullRequestActionRunning => {
            return (instance as BulkPullRequestActionRunning)?.__typename === 'BulkPullRequestActionRunning';
        }
        
export const isChangelogBulkPullRequestActionAChangelogBulkPullRequestActionCanceled = (instance: ChangelogBulkPullRequestActionCanceled | ChangelogBulkPullRequestActionError | ChangelogBulkPullRequestActionFinished | ChangelogBulkPullRequestActionQueued | ChangelogBulkPullRequestActionRunning | unknown): instance is ChangelogBulkPullRequestActionCanceled => {
            return (instance as ChangelogBulkPullRequestActionCanceled)?.__typename === 'ChangelogBulkPullRequestActionCanceled';
        }
        
export const isChangelogBulkPullRequestActionAChangelogBulkPullRequestActionError = (instance: ChangelogBulkPullRequestActionCanceled | ChangelogBulkPullRequestActionError | ChangelogBulkPullRequestActionFinished | ChangelogBulkPullRequestActionQueued | ChangelogBulkPullRequestActionRunning | unknown): instance is ChangelogBulkPullRequestActionError => {
            return (instance as ChangelogBulkPullRequestActionError)?.__typename === 'ChangelogBulkPullRequestActionError';
        }
        
export const isChangelogBulkPullRequestActionAChangelogBulkPullRequestActionFinished = (instance: ChangelogBulkPullRequestActionCanceled | ChangelogBulkPullRequestActionError | ChangelogBulkPullRequestActionFinished | ChangelogBulkPullRequestActionQueued | ChangelogBulkPullRequestActionRunning | unknown): instance is ChangelogBulkPullRequestActionFinished => {
            return (instance as ChangelogBulkPullRequestActionFinished)?.__typename === 'ChangelogBulkPullRequestActionFinished';
        }
        
export const isChangelogBulkPullRequestActionAChangelogBulkPullRequestActionQueued = (instance: ChangelogBulkPullRequestActionCanceled | ChangelogBulkPullRequestActionError | ChangelogBulkPullRequestActionFinished | ChangelogBulkPullRequestActionQueued | ChangelogBulkPullRequestActionRunning | unknown): instance is ChangelogBulkPullRequestActionQueued => {
            return (instance as ChangelogBulkPullRequestActionQueued)?.__typename === 'ChangelogBulkPullRequestActionQueued';
        }
        
export const isChangelogBulkPullRequestActionAChangelogBulkPullRequestActionRunning = (instance: ChangelogBulkPullRequestActionCanceled | ChangelogBulkPullRequestActionError | ChangelogBulkPullRequestActionFinished | ChangelogBulkPullRequestActionQueued | ChangelogBulkPullRequestActionRunning | unknown): instance is ChangelogBulkPullRequestActionRunning => {
            return (instance as ChangelogBulkPullRequestActionRunning)?.__typename === 'ChangelogBulkPullRequestActionRunning';
        }
        
export const isChangelogEntryAChangelogCommit = (instance: ChangelogCommit | ChangelogPullRequest | unknown): instance is ChangelogCommit => {
            return (instance as ChangelogCommit)?.__typename === 'ChangelogCommit';
        }
        
export const isChangelogEntryAChangelogPullRequest = (instance: ChangelogCommit | ChangelogPullRequest | unknown): instance is ChangelogPullRequest => {
            return (instance as ChangelogPullRequest)?.__typename === 'ChangelogPullRequest';
        }
        
export const isChangelogPullRequestActionAChangelogPullRequestActionCanceled = (instance: ChangelogPullRequestActionCanceled | ChangelogPullRequestActionFailed | ChangelogPullRequestActionQueued | ChangelogPullRequestActionRunning | ChangelogPullRequestActionSucceeded | unknown): instance is ChangelogPullRequestActionCanceled => {
            return (instance as ChangelogPullRequestActionCanceled)?.__typename === 'ChangelogPullRequestActionCanceled';
        }
        
export const isChangelogPullRequestActionAChangelogPullRequestActionFailed = (instance: ChangelogPullRequestActionCanceled | ChangelogPullRequestActionFailed | ChangelogPullRequestActionQueued | ChangelogPullRequestActionRunning | ChangelogPullRequestActionSucceeded | unknown): instance is ChangelogPullRequestActionFailed => {
            return (instance as ChangelogPullRequestActionFailed)?.__typename === 'ChangelogPullRequestActionFailed';
        }
        
export const isChangelogPullRequestActionAChangelogPullRequestActionQueued = (instance: ChangelogPullRequestActionCanceled | ChangelogPullRequestActionFailed | ChangelogPullRequestActionQueued | ChangelogPullRequestActionRunning | ChangelogPullRequestActionSucceeded | unknown): instance is ChangelogPullRequestActionQueued => {
            return (instance as ChangelogPullRequestActionQueued)?.__typename === 'ChangelogPullRequestActionQueued';
        }
        
export const isChangelogPullRequestActionAChangelogPullRequestActionRunning = (instance: ChangelogPullRequestActionCanceled | ChangelogPullRequestActionFailed | ChangelogPullRequestActionQueued | ChangelogPullRequestActionRunning | ChangelogPullRequestActionSucceeded | unknown): instance is ChangelogPullRequestActionRunning => {
            return (instance as ChangelogPullRequestActionRunning)?.__typename === 'ChangelogPullRequestActionRunning';
        }
        
export const isChangelogPullRequestActionAChangelogPullRequestActionSucceeded = (instance: ChangelogPullRequestActionCanceled | ChangelogPullRequestActionFailed | ChangelogPullRequestActionQueued | ChangelogPullRequestActionRunning | ChangelogPullRequestActionSucceeded | unknown): instance is ChangelogPullRequestActionSucceeded => {
            return (instance as ChangelogPullRequestActionSucceeded)?.__typename === 'ChangelogPullRequestActionSucceeded';
        }
        
export const isCommitOptionsABranchCommitOptions = (instance: BranchCommitOptions | ForkCommitOptions | ForkPullRequestOptions | PullRequestOptions | unknown): instance is BranchCommitOptions => {
            return (instance as BranchCommitOptions)?.__typename === 'BranchCommitOptions';
        }
        
export const isCommitOptionsAForkCommitOptions = (instance: BranchCommitOptions | ForkCommitOptions | ForkPullRequestOptions | PullRequestOptions | unknown): instance is ForkCommitOptions => {
            return (instance as ForkCommitOptions)?.__typename === 'ForkCommitOptions';
        }
        
export const isCommitOptionsAForkPullRequestOptions = (instance: BranchCommitOptions | ForkCommitOptions | ForkPullRequestOptions | PullRequestOptions | unknown): instance is ForkPullRequestOptions => {
            return (instance as ForkPullRequestOptions)?.__typename === 'ForkPullRequestOptions';
        }
        
export const isCommitOptionsAPullRequestOptions = (instance: BranchCommitOptions | ForkCommitOptions | ForkPullRequestOptions | PullRequestOptions | unknown): instance is PullRequestOptions => {
            return (instance as PullRequestOptions)?.__typename === 'PullRequestOptions';
        }
        
export const isConnectorToolAArtifactoryConfiguration = (instance: ArtifactoryConfiguration | AzureDevOpsConfiguration | BitbucketCloudConfiguration | BitbucketConfiguration | GenericHttpToolConfiguration | GitLabConfiguration | GithubConfiguration | GoConfiguration | LlmConfiguration | MavenConfiguration | NpmConfiguration | NugetConfiguration | OrganizationConfiguration | PypiConfiguration | S3Configuration | unknown): instance is ArtifactoryConfiguration => {
            return (instance as ArtifactoryConfiguration)?.__typename === 'ArtifactoryConfiguration';
        }
        
export const isConnectorToolAAzureDevOpsConfiguration = (instance: ArtifactoryConfiguration | AzureDevOpsConfiguration | BitbucketCloudConfiguration | BitbucketConfiguration | GenericHttpToolConfiguration | GitLabConfiguration | GithubConfiguration | GoConfiguration | LlmConfiguration | MavenConfiguration | NpmConfiguration | NugetConfiguration | OrganizationConfiguration | PypiConfiguration | S3Configuration | unknown): instance is AzureDevOpsConfiguration => {
            return (instance as AzureDevOpsConfiguration)?.__typename === 'AzureDevOpsConfiguration';
        }
        
export const isConnectorToolABitbucketCloudConfiguration = (instance: ArtifactoryConfiguration | AzureDevOpsConfiguration | BitbucketCloudConfiguration | BitbucketConfiguration | GenericHttpToolConfiguration | GitLabConfiguration | GithubConfiguration | GoConfiguration | LlmConfiguration | MavenConfiguration | NpmConfiguration | NugetConfiguration | OrganizationConfiguration | PypiConfiguration | S3Configuration | unknown): instance is BitbucketCloudConfiguration => {
            return (instance as BitbucketCloudConfiguration)?.__typename === 'BitbucketCloudConfiguration';
        }
        
export const isConnectorToolABitbucketConfiguration = (instance: ArtifactoryConfiguration | AzureDevOpsConfiguration | BitbucketCloudConfiguration | BitbucketConfiguration | GenericHttpToolConfiguration | GitLabConfiguration | GithubConfiguration | GoConfiguration | LlmConfiguration | MavenConfiguration | NpmConfiguration | NugetConfiguration | OrganizationConfiguration | PypiConfiguration | S3Configuration | unknown): instance is BitbucketConfiguration => {
            return (instance as BitbucketConfiguration)?.__typename === 'BitbucketConfiguration';
        }
        
export const isConnectorToolAGenericHttpToolConfiguration = (instance: ArtifactoryConfiguration | AzureDevOpsConfiguration | BitbucketCloudConfiguration | BitbucketConfiguration | GenericHttpToolConfiguration | GitLabConfiguration | GithubConfiguration | GoConfiguration | LlmConfiguration | MavenConfiguration | NpmConfiguration | NugetConfiguration | OrganizationConfiguration | PypiConfiguration | S3Configuration | unknown): instance is GenericHttpToolConfiguration => {
            return (instance as GenericHttpToolConfiguration)?.__typename === 'GenericHttpToolConfiguration';
        }
        
export const isConnectorToolAGitLabConfiguration = (instance: ArtifactoryConfiguration | AzureDevOpsConfiguration | BitbucketCloudConfiguration | BitbucketConfiguration | GenericHttpToolConfiguration | GitLabConfiguration | GithubConfiguration | GoConfiguration | LlmConfiguration | MavenConfiguration | NpmConfiguration | NugetConfiguration | OrganizationConfiguration | PypiConfiguration | S3Configuration | unknown): instance is GitLabConfiguration => {
            return (instance as GitLabConfiguration)?.__typename === 'GitLabConfiguration';
        }
        
export const isConnectorToolAGithubConfiguration = (instance: ArtifactoryConfiguration | AzureDevOpsConfiguration | BitbucketCloudConfiguration | BitbucketConfiguration | GenericHttpToolConfiguration | GitLabConfiguration | GithubConfiguration | GoConfiguration | LlmConfiguration | MavenConfiguration | NpmConfiguration | NugetConfiguration | OrganizationConfiguration | PypiConfiguration | S3Configuration | unknown): instance is GithubConfiguration => {
            return (instance as GithubConfiguration)?.__typename === 'GithubConfiguration';
        }
        
export const isConnectorToolAGoConfiguration = (instance: ArtifactoryConfiguration | AzureDevOpsConfiguration | BitbucketCloudConfiguration | BitbucketConfiguration | GenericHttpToolConfiguration | GitLabConfiguration | GithubConfiguration | GoConfiguration | LlmConfiguration | MavenConfiguration | NpmConfiguration | NugetConfiguration | OrganizationConfiguration | PypiConfiguration | S3Configuration | unknown): instance is GoConfiguration => {
            return (instance as GoConfiguration)?.__typename === 'GoConfiguration';
        }
        
export const isConnectorToolALlmConfiguration = (instance: ArtifactoryConfiguration | AzureDevOpsConfiguration | BitbucketCloudConfiguration | BitbucketConfiguration | GenericHttpToolConfiguration | GitLabConfiguration | GithubConfiguration | GoConfiguration | LlmConfiguration | MavenConfiguration | NpmConfiguration | NugetConfiguration | OrganizationConfiguration | PypiConfiguration | S3Configuration | unknown): instance is LlmConfiguration => {
            return (instance as LlmConfiguration)?.__typename === 'LlmConfiguration';
        }
        
export const isConnectorToolAMavenConfiguration = (instance: ArtifactoryConfiguration | AzureDevOpsConfiguration | BitbucketCloudConfiguration | BitbucketConfiguration | GenericHttpToolConfiguration | GitLabConfiguration | GithubConfiguration | GoConfiguration | LlmConfiguration | MavenConfiguration | NpmConfiguration | NugetConfiguration | OrganizationConfiguration | PypiConfiguration | S3Configuration | unknown): instance is MavenConfiguration => {
            return (instance as MavenConfiguration)?.__typename === 'MavenConfiguration';
        }
        
export const isConnectorToolANpmConfiguration = (instance: ArtifactoryConfiguration | AzureDevOpsConfiguration | BitbucketCloudConfiguration | BitbucketConfiguration | GenericHttpToolConfiguration | GitLabConfiguration | GithubConfiguration | GoConfiguration | LlmConfiguration | MavenConfiguration | NpmConfiguration | NugetConfiguration | OrganizationConfiguration | PypiConfiguration | S3Configuration | unknown): instance is NpmConfiguration => {
            return (instance as NpmConfiguration)?.__typename === 'NpmConfiguration';
        }
        
export const isConnectorToolANugetConfiguration = (instance: ArtifactoryConfiguration | AzureDevOpsConfiguration | BitbucketCloudConfiguration | BitbucketConfiguration | GenericHttpToolConfiguration | GitLabConfiguration | GithubConfiguration | GoConfiguration | LlmConfiguration | MavenConfiguration | NpmConfiguration | NugetConfiguration | OrganizationConfiguration | PypiConfiguration | S3Configuration | unknown): instance is NugetConfiguration => {
            return (instance as NugetConfiguration)?.__typename === 'NugetConfiguration';
        }
        
export const isConnectorToolAOrganizationConfiguration = (instance: ArtifactoryConfiguration | AzureDevOpsConfiguration | BitbucketCloudConfiguration | BitbucketConfiguration | GenericHttpToolConfiguration | GitLabConfiguration | GithubConfiguration | GoConfiguration | LlmConfiguration | MavenConfiguration | NpmConfiguration | NugetConfiguration | OrganizationConfiguration | PypiConfiguration | S3Configuration | unknown): instance is OrganizationConfiguration => {
            return (instance as OrganizationConfiguration)?.__typename === 'OrganizationConfiguration';
        }
        
export const isConnectorToolAPypiConfiguration = (instance: ArtifactoryConfiguration | AzureDevOpsConfiguration | BitbucketCloudConfiguration | BitbucketConfiguration | GenericHttpToolConfiguration | GitLabConfiguration | GithubConfiguration | GoConfiguration | LlmConfiguration | MavenConfiguration | NpmConfiguration | NugetConfiguration | OrganizationConfiguration | PypiConfiguration | S3Configuration | unknown): instance is PypiConfiguration => {
            return (instance as PypiConfiguration)?.__typename === 'PypiConfiguration';
        }
        
export const isConnectorToolAS3Configuration = (instance: ArtifactoryConfiguration | AzureDevOpsConfiguration | BitbucketCloudConfiguration | BitbucketConfiguration | GenericHttpToolConfiguration | GitLabConfiguration | GithubConfiguration | GoConfiguration | LlmConfiguration | MavenConfiguration | NpmConfiguration | NugetConfiguration | OrganizationConfiguration | PypiConfiguration | S3Configuration | unknown): instance is S3Configuration => {
            return (instance as S3Configuration)?.__typename === 'S3Configuration';
        }
        
export const isDataTableADataTableAvailable = (instance: DataTableAvailable | DataTableError | DataTableFinished | DataTableProcessing | DataTableQueued | unknown): instance is DataTableAvailable => {
            return (instance as DataTableAvailable)?.__typename === 'DataTableAvailable';
        }
        
export const isDataTableADataTableError = (instance: DataTableAvailable | DataTableError | DataTableFinished | DataTableProcessing | DataTableQueued | unknown): instance is DataTableError => {
            return (instance as DataTableError)?.__typename === 'DataTableError';
        }
        
export const isDataTableADataTableFinished = (instance: DataTableAvailable | DataTableError | DataTableFinished | DataTableProcessing | DataTableQueued | unknown): instance is DataTableFinished => {
            return (instance as DataTableFinished)?.__typename === 'DataTableFinished';
        }
        
export const isDataTableADataTableProcessing = (instance: DataTableAvailable | DataTableError | DataTableFinished | DataTableProcessing | DataTableQueued | unknown): instance is DataTableProcessing => {
            return (instance as DataTableProcessing)?.__typename === 'DataTableProcessing';
        }
        
export const isDataTableADataTableQueued = (instance: DataTableAvailable | DataTableError | DataTableFinished | DataTableProcessing | DataTableQueued | unknown): instance is DataTableQueued => {
            return (instance as DataTableQueued)?.__typename === 'DataTableQueued';
        }
        
export const isDevCenterRunADevCenterRunCanceled = (instance: DevCenterRunCanceled | DevCenterRunError | DevCenterRunFinished | DevCenterRunRunning | unknown): instance is DevCenterRunCanceled => {
            return (instance as DevCenterRunCanceled)?.__typename === 'DevCenterRunCanceled';
        }
        
export const isDevCenterRunADevCenterRunError = (instance: DevCenterRunCanceled | DevCenterRunError | DevCenterRunFinished | DevCenterRunRunning | unknown): instance is DevCenterRunError => {
            return (instance as DevCenterRunError)?.__typename === 'DevCenterRunError';
        }
        
export const isDevCenterRunADevCenterRunFinished = (instance: DevCenterRunCanceled | DevCenterRunError | DevCenterRunFinished | DevCenterRunRunning | unknown): instance is DevCenterRunFinished => {
            return (instance as DevCenterRunFinished)?.__typename === 'DevCenterRunFinished';
        }
        
export const isDevCenterRunADevCenterRunRunning = (instance: DevCenterRunCanceled | DevCenterRunError | DevCenterRunFinished | DevCenterRunRunning | unknown): instance is DevCenterRunRunning => {
            return (instance as DevCenterRunRunning)?.__typename === 'DevCenterRunRunning';
        }
        
export const isFileChangeARecipeRunFileChange = (instance: RecipeRunFileChange | RevisionFileChange | unknown): instance is RecipeRunFileChange => {
            return (instance as RecipeRunFileChange)?.__typename === 'RecipeRunFileChange';
        }
        
export const isFileChangeARevisionFileChange = (instance: RecipeRunFileChange | RevisionFileChange | unknown): instance is RevisionFileChange => {
            return (instance as RevisionFileChange)?.__typename === 'RevisionFileChange';
        }
        
export const isMarkerAMarkup = (instance: Markup | SearchResult | unknown): instance is Markup => {
            return (instance as Markup)?.__typename === 'Markup';
        }
        
export const isMarkerASearchResult = (instance: Markup | SearchResult | unknown): instance is SearchResult => {
            return (instance as SearchResult)?.__typename === 'SearchResult';
        }
        
export const isMessageADataTableSqlMessage = (instance: DataTableSqlMessage | DataTablesMessage | ErrorMessage | RecipeOptionsMessage | RecipeRunMessage | RecipeSearchMessage | TextMessage | unknown): instance is DataTableSqlMessage => {
            return (instance as DataTableSqlMessage)?.__typename === 'DataTableSqlMessage';
        }
        
export const isMessageADataTablesMessage = (instance: DataTableSqlMessage | DataTablesMessage | ErrorMessage | RecipeOptionsMessage | RecipeRunMessage | RecipeSearchMessage | TextMessage | unknown): instance is DataTablesMessage => {
            return (instance as DataTablesMessage)?.__typename === 'DataTablesMessage';
        }
        
export const isMessageAErrorMessage = (instance: DataTableSqlMessage | DataTablesMessage | ErrorMessage | RecipeOptionsMessage | RecipeRunMessage | RecipeSearchMessage | TextMessage | unknown): instance is ErrorMessage => {
            return (instance as ErrorMessage)?.__typename === 'ErrorMessage';
        }
        
export const isMessageARecipeOptionsMessage = (instance: DataTableSqlMessage | DataTablesMessage | ErrorMessage | RecipeOptionsMessage | RecipeRunMessage | RecipeSearchMessage | TextMessage | unknown): instance is RecipeOptionsMessage => {
            return (instance as RecipeOptionsMessage)?.__typename === 'RecipeOptionsMessage';
        }
        
export const isMessageARecipeRunMessage = (instance: DataTableSqlMessage | DataTablesMessage | ErrorMessage | RecipeOptionsMessage | RecipeRunMessage | RecipeSearchMessage | TextMessage | unknown): instance is RecipeRunMessage => {
            return (instance as RecipeRunMessage)?.__typename === 'RecipeRunMessage';
        }
        
export const isMessageARecipeSearchMessage = (instance: DataTableSqlMessage | DataTablesMessage | ErrorMessage | RecipeOptionsMessage | RecipeRunMessage | RecipeSearchMessage | TextMessage | unknown): instance is RecipeSearchMessage => {
            return (instance as RecipeSearchMessage)?.__typename === 'RecipeSearchMessage';
        }
        
export const isMessageATextMessage = (instance: DataTableSqlMessage | DataTablesMessage | ErrorMessage | RecipeOptionsMessage | RecipeRunMessage | RecipeSearchMessage | TextMessage | unknown): instance is TextMessage => {
            return (instance as TextMessage)?.__typename === 'TextMessage';
        }
        
export const isOrganizationChangesetAOrganizationRecipeRunCanceled = (instance: OrganizationRecipeRunCanceled | OrganizationRecipeRunError | OrganizationRecipeRunFinished | OrganizationRecipeRunQueued | OrganizationRecipeRunRunning | OrganizationRecipeRunSyncing | OrganizationRevision | OrganizationSearch | unknown): instance is OrganizationRecipeRunCanceled => {
            return (instance as OrganizationRecipeRunCanceled)?.__typename === 'OrganizationRecipeRunCanceled';
        }
        
export const isOrganizationChangesetAOrganizationRecipeRunError = (instance: OrganizationRecipeRunCanceled | OrganizationRecipeRunError | OrganizationRecipeRunFinished | OrganizationRecipeRunQueued | OrganizationRecipeRunRunning | OrganizationRecipeRunSyncing | OrganizationRevision | OrganizationSearch | unknown): instance is OrganizationRecipeRunError => {
            return (instance as OrganizationRecipeRunError)?.__typename === 'OrganizationRecipeRunError';
        }
        
export const isOrganizationChangesetAOrganizationRecipeRunFinished = (instance: OrganizationRecipeRunCanceled | OrganizationRecipeRunError | OrganizationRecipeRunFinished | OrganizationRecipeRunQueued | OrganizationRecipeRunRunning | OrganizationRecipeRunSyncing | OrganizationRevision | OrganizationSearch | unknown): instance is OrganizationRecipeRunFinished => {
            return (instance as OrganizationRecipeRunFinished)?.__typename === 'OrganizationRecipeRunFinished';
        }
        
export const isOrganizationChangesetAOrganizationRecipeRunQueued = (instance: OrganizationRecipeRunCanceled | OrganizationRecipeRunError | OrganizationRecipeRunFinished | OrganizationRecipeRunQueued | OrganizationRecipeRunRunning | OrganizationRecipeRunSyncing | OrganizationRevision | OrganizationSearch | unknown): instance is OrganizationRecipeRunQueued => {
            return (instance as OrganizationRecipeRunQueued)?.__typename === 'OrganizationRecipeRunQueued';
        }
        
export const isOrganizationChangesetAOrganizationRecipeRunRunning = (instance: OrganizationRecipeRunCanceled | OrganizationRecipeRunError | OrganizationRecipeRunFinished | OrganizationRecipeRunQueued | OrganizationRecipeRunRunning | OrganizationRecipeRunSyncing | OrganizationRevision | OrganizationSearch | unknown): instance is OrganizationRecipeRunRunning => {
            return (instance as OrganizationRecipeRunRunning)?.__typename === 'OrganizationRecipeRunRunning';
        }
        
export const isOrganizationChangesetAOrganizationRecipeRunSyncing = (instance: OrganizationRecipeRunCanceled | OrganizationRecipeRunError | OrganizationRecipeRunFinished | OrganizationRecipeRunQueued | OrganizationRecipeRunRunning | OrganizationRecipeRunSyncing | OrganizationRevision | OrganizationSearch | unknown): instance is OrganizationRecipeRunSyncing => {
            return (instance as OrganizationRecipeRunSyncing)?.__typename === 'OrganizationRecipeRunSyncing';
        }
        
export const isOrganizationChangesetAOrganizationRevision = (instance: OrganizationRecipeRunCanceled | OrganizationRecipeRunError | OrganizationRecipeRunFinished | OrganizationRecipeRunQueued | OrganizationRecipeRunRunning | OrganizationRecipeRunSyncing | OrganizationRevision | OrganizationSearch | unknown): instance is OrganizationRevision => {
            return (instance as OrganizationRevision)?.__typename === 'OrganizationRevision';
        }
        
export const isOrganizationChangesetAOrganizationSearch = (instance: OrganizationRecipeRunCanceled | OrganizationRecipeRunError | OrganizationRecipeRunFinished | OrganizationRecipeRunQueued | OrganizationRecipeRunRunning | OrganizationRecipeRunSyncing | OrganizationRevision | OrganizationSearch | unknown): instance is OrganizationSearch => {
            return (instance as OrganizationSearch)?.__typename === 'OrganizationSearch';
        }
        
export const isOrganizationCommitAOrganizationCommitCanceled = (instance: OrganizationCommitCanceled | OrganizationCommitError | OrganizationCommitFinished | OrganizationCommitQueued | OrganizationCommitRunning | unknown): instance is OrganizationCommitCanceled => {
            return (instance as OrganizationCommitCanceled)?.__typename === 'OrganizationCommitCanceled';
        }
        
export const isOrganizationCommitAOrganizationCommitError = (instance: OrganizationCommitCanceled | OrganizationCommitError | OrganizationCommitFinished | OrganizationCommitQueued | OrganizationCommitRunning | unknown): instance is OrganizationCommitError => {
            return (instance as OrganizationCommitError)?.__typename === 'OrganizationCommitError';
        }
        
export const isOrganizationCommitAOrganizationCommitFinished = (instance: OrganizationCommitCanceled | OrganizationCommitError | OrganizationCommitFinished | OrganizationCommitQueued | OrganizationCommitRunning | unknown): instance is OrganizationCommitFinished => {
            return (instance as OrganizationCommitFinished)?.__typename === 'OrganizationCommitFinished';
        }
        
export const isOrganizationCommitAOrganizationCommitQueued = (instance: OrganizationCommitCanceled | OrganizationCommitError | OrganizationCommitFinished | OrganizationCommitQueued | OrganizationCommitRunning | unknown): instance is OrganizationCommitQueued => {
            return (instance as OrganizationCommitQueued)?.__typename === 'OrganizationCommitQueued';
        }
        
export const isOrganizationCommitAOrganizationCommitRunning = (instance: OrganizationCommitCanceled | OrganizationCommitError | OrganizationCommitFinished | OrganizationCommitQueued | OrganizationCommitRunning | unknown): instance is OrganizationCommitRunning => {
            return (instance as OrganizationCommitRunning)?.__typename === 'OrganizationCommitRunning';
        }
        
export const isOrganizationRecipeRunAOrganizationRecipeRunCanceled = (instance: OrganizationRecipeRunCanceled | OrganizationRecipeRunError | OrganizationRecipeRunFinished | OrganizationRecipeRunQueued | OrganizationRecipeRunRunning | OrganizationRecipeRunSyncing | unknown): instance is OrganizationRecipeRunCanceled => {
            return (instance as OrganizationRecipeRunCanceled)?.__typename === 'OrganizationRecipeRunCanceled';
        }
        
export const isOrganizationRecipeRunAOrganizationRecipeRunError = (instance: OrganizationRecipeRunCanceled | OrganizationRecipeRunError | OrganizationRecipeRunFinished | OrganizationRecipeRunQueued | OrganizationRecipeRunRunning | OrganizationRecipeRunSyncing | unknown): instance is OrganizationRecipeRunError => {
            return (instance as OrganizationRecipeRunError)?.__typename === 'OrganizationRecipeRunError';
        }
        
export const isOrganizationRecipeRunAOrganizationRecipeRunFinished = (instance: OrganizationRecipeRunCanceled | OrganizationRecipeRunError | OrganizationRecipeRunFinished | OrganizationRecipeRunQueued | OrganizationRecipeRunRunning | OrganizationRecipeRunSyncing | unknown): instance is OrganizationRecipeRunFinished => {
            return (instance as OrganizationRecipeRunFinished)?.__typename === 'OrganizationRecipeRunFinished';
        }
        
export const isOrganizationRecipeRunAOrganizationRecipeRunQueued = (instance: OrganizationRecipeRunCanceled | OrganizationRecipeRunError | OrganizationRecipeRunFinished | OrganizationRecipeRunQueued | OrganizationRecipeRunRunning | OrganizationRecipeRunSyncing | unknown): instance is OrganizationRecipeRunQueued => {
            return (instance as OrganizationRecipeRunQueued)?.__typename === 'OrganizationRecipeRunQueued';
        }
        
export const isOrganizationRecipeRunAOrganizationRecipeRunRunning = (instance: OrganizationRecipeRunCanceled | OrganizationRecipeRunError | OrganizationRecipeRunFinished | OrganizationRecipeRunQueued | OrganizationRecipeRunRunning | OrganizationRecipeRunSyncing | unknown): instance is OrganizationRecipeRunRunning => {
            return (instance as OrganizationRecipeRunRunning)?.__typename === 'OrganizationRecipeRunRunning';
        }
        
export const isOrganizationRecipeRunAOrganizationRecipeRunSyncing = (instance: OrganizationRecipeRunCanceled | OrganizationRecipeRunError | OrganizationRecipeRunFinished | OrganizationRecipeRunQueued | OrganizationRecipeRunRunning | OrganizationRecipeRunSyncing | unknown): instance is OrganizationRecipeRunSyncing => {
            return (instance as OrganizationRecipeRunSyncing)?.__typename === 'OrganizationRecipeRunSyncing';
        }
        
export const isPullRequestActionAPullRequestActionCanceled = (instance: PullRequestActionCanceled | PullRequestActionFailed | PullRequestActionQueued | PullRequestActionRunning | PullRequestActionSucceeded | unknown): instance is PullRequestActionCanceled => {
            return (instance as PullRequestActionCanceled)?.__typename === 'PullRequestActionCanceled';
        }
        
export const isPullRequestActionAPullRequestActionFailed = (instance: PullRequestActionCanceled | PullRequestActionFailed | PullRequestActionQueued | PullRequestActionRunning | PullRequestActionSucceeded | unknown): instance is PullRequestActionFailed => {
            return (instance as PullRequestActionFailed)?.__typename === 'PullRequestActionFailed';
        }
        
export const isPullRequestActionAPullRequestActionQueued = (instance: PullRequestActionCanceled | PullRequestActionFailed | PullRequestActionQueued | PullRequestActionRunning | PullRequestActionSucceeded | unknown): instance is PullRequestActionQueued => {
            return (instance as PullRequestActionQueued)?.__typename === 'PullRequestActionQueued';
        }
        
export const isPullRequestActionAPullRequestActionRunning = (instance: PullRequestActionCanceled | PullRequestActionFailed | PullRequestActionQueued | PullRequestActionRunning | PullRequestActionSucceeded | unknown): instance is PullRequestActionRunning => {
            return (instance as PullRequestActionRunning)?.__typename === 'PullRequestActionRunning';
        }
        
export const isPullRequestActionAPullRequestActionSucceeded = (instance: PullRequestActionCanceled | PullRequestActionFailed | PullRequestActionQueued | PullRequestActionRunning | PullRequestActionSucceeded | unknown): instance is PullRequestActionSucceeded => {
            return (instance as PullRequestActionSucceeded)?.__typename === 'PullRequestActionSucceeded';
        }
        
export const isRecipeBundleAGitRecipeBundle = (instance: GitRecipeBundle | GoRecipeBundle | LocalRecipeBundle | MavenRecipeBundle | NpmRecipeBundle | NugetRecipeBundle | PipRecipeBundle | YamlRecipeBundle | unknown): instance is GitRecipeBundle => {
            return (instance as GitRecipeBundle)?.__typename === 'GitRecipeBundle';
        }
        
export const isRecipeBundleAGoRecipeBundle = (instance: GitRecipeBundle | GoRecipeBundle | LocalRecipeBundle | MavenRecipeBundle | NpmRecipeBundle | NugetRecipeBundle | PipRecipeBundle | YamlRecipeBundle | unknown): instance is GoRecipeBundle => {
            return (instance as GoRecipeBundle)?.__typename === 'GoRecipeBundle';
        }
        
export const isRecipeBundleALocalRecipeBundle = (instance: GitRecipeBundle | GoRecipeBundle | LocalRecipeBundle | MavenRecipeBundle | NpmRecipeBundle | NugetRecipeBundle | PipRecipeBundle | YamlRecipeBundle | unknown): instance is LocalRecipeBundle => {
            return (instance as LocalRecipeBundle)?.__typename === 'LocalRecipeBundle';
        }
        
export const isRecipeBundleAMavenRecipeBundle = (instance: GitRecipeBundle | GoRecipeBundle | LocalRecipeBundle | MavenRecipeBundle | NpmRecipeBundle | NugetRecipeBundle | PipRecipeBundle | YamlRecipeBundle | unknown): instance is MavenRecipeBundle => {
            return (instance as MavenRecipeBundle)?.__typename === 'MavenRecipeBundle';
        }
        
export const isRecipeBundleANpmRecipeBundle = (instance: GitRecipeBundle | GoRecipeBundle | LocalRecipeBundle | MavenRecipeBundle | NpmRecipeBundle | NugetRecipeBundle | PipRecipeBundle | YamlRecipeBundle | unknown): instance is NpmRecipeBundle => {
            return (instance as NpmRecipeBundle)?.__typename === 'NpmRecipeBundle';
        }
        
export const isRecipeBundleANugetRecipeBundle = (instance: GitRecipeBundle | GoRecipeBundle | LocalRecipeBundle | MavenRecipeBundle | NpmRecipeBundle | NugetRecipeBundle | PipRecipeBundle | YamlRecipeBundle | unknown): instance is NugetRecipeBundle => {
            return (instance as NugetRecipeBundle)?.__typename === 'NugetRecipeBundle';
        }
        
export const isRecipeBundleAPipRecipeBundle = (instance: GitRecipeBundle | GoRecipeBundle | LocalRecipeBundle | MavenRecipeBundle | NpmRecipeBundle | NugetRecipeBundle | PipRecipeBundle | YamlRecipeBundle | unknown): instance is PipRecipeBundle => {
            return (instance as PipRecipeBundle)?.__typename === 'PipRecipeBundle';
        }
        
export const isRecipeBundleAYamlRecipeBundle = (instance: GitRecipeBundle | GoRecipeBundle | LocalRecipeBundle | MavenRecipeBundle | NpmRecipeBundle | NugetRecipeBundle | PipRecipeBundle | YamlRecipeBundle | unknown): instance is YamlRecipeBundle => {
            return (instance as YamlRecipeBundle)?.__typename === 'YamlRecipeBundle';
        }
        
export const isRecipeDetailARecipeDetailError = (instance: RecipeDetailError | RecipeDetailFinished | RecipeDetailLoading | unknown): instance is RecipeDetailError => {
            return (instance as RecipeDetailError)?.__typename === 'RecipeDetailError';
        }
        
export const isRecipeDetailARecipeDetailFinished = (instance: RecipeDetailError | RecipeDetailFinished | RecipeDetailLoading | unknown): instance is RecipeDetailFinished => {
            return (instance as RecipeDetailFinished)?.__typename === 'RecipeDetailFinished';
        }
        
export const isRecipeDetailARecipeDetailLoading = (instance: RecipeDetailError | RecipeDetailFinished | RecipeDetailLoading | unknown): instance is RecipeDetailLoading => {
            return (instance as RecipeDetailLoading)?.__typename === 'RecipeDetailLoading';
        }
        
export const isRecipeInstallationARecipeInstallationError = (instance: RecipeInstallationError | RecipeInstallationFinished | RecipeInstallationProcessing | RecipeInstallationQueued | unknown): instance is RecipeInstallationError => {
            return (instance as RecipeInstallationError)?.__typename === 'RecipeInstallationError';
        }
        
export const isRecipeInstallationARecipeInstallationFinished = (instance: RecipeInstallationError | RecipeInstallationFinished | RecipeInstallationProcessing | RecipeInstallationQueued | unknown): instance is RecipeInstallationFinished => {
            return (instance as RecipeInstallationFinished)?.__typename === 'RecipeInstallationFinished';
        }
        
export const isRecipeInstallationARecipeInstallationProcessing = (instance: RecipeInstallationError | RecipeInstallationFinished | RecipeInstallationProcessing | RecipeInstallationQueued | unknown): instance is RecipeInstallationProcessing => {
            return (instance as RecipeInstallationProcessing)?.__typename === 'RecipeInstallationProcessing';
        }
        
export const isRecipeInstallationARecipeInstallationQueued = (instance: RecipeInstallationError | RecipeInstallationFinished | RecipeInstallationProcessing | RecipeInstallationQueued | unknown): instance is RecipeInstallationQueued => {
            return (instance as RecipeInstallationQueued)?.__typename === 'RecipeInstallationQueued';
        }
        
export const isRecipeInstallationScopeAChangesetInstallScope = (instance: ChangesetInstallScope | OrganizationInstallScope | UniversalInstallScope | UserInstallScope | unknown): instance is ChangesetInstallScope => {
            return (instance as ChangesetInstallScope)?.__typename === 'ChangesetInstallScope';
        }
        
export const isRecipeInstallationScopeAOrganizationInstallScope = (instance: ChangesetInstallScope | OrganizationInstallScope | UniversalInstallScope | UserInstallScope | unknown): instance is OrganizationInstallScope => {
            return (instance as OrganizationInstallScope)?.__typename === 'OrganizationInstallScope';
        }
        
export const isRecipeInstallationScopeAUniversalInstallScope = (instance: ChangesetInstallScope | OrganizationInstallScope | UniversalInstallScope | UserInstallScope | unknown): instance is UniversalInstallScope => {
            return (instance as UniversalInstallScope)?.__typename === 'UniversalInstallScope';
        }
        
export const isRecipeInstallationScopeAUserInstallScope = (instance: ChangesetInstallScope | OrganizationInstallScope | UniversalInstallScope | UserInstallScope | unknown): instance is UserInstallScope => {
            return (instance as UserInstallScope)?.__typename === 'UserInstallScope';
        }
        
export const isRepositoryChangesetARepositoryRecipeRunCanceled = (instance: RepositoryRecipeRunCanceled | RepositoryRecipeRunError | RepositoryRecipeRunFinished | RepositoryRecipeRunNoLst | RepositoryRecipeRunQueued | RepositoryRecipeRunRunning | RepositoryRevision | RepositorySearchResult | unknown): instance is RepositoryRecipeRunCanceled => {
            return (instance as RepositoryRecipeRunCanceled)?.__typename === 'RepositoryRecipeRunCanceled';
        }
        
export const isRepositoryChangesetARepositoryRecipeRunError = (instance: RepositoryRecipeRunCanceled | RepositoryRecipeRunError | RepositoryRecipeRunFinished | RepositoryRecipeRunNoLst | RepositoryRecipeRunQueued | RepositoryRecipeRunRunning | RepositoryRevision | RepositorySearchResult | unknown): instance is RepositoryRecipeRunError => {
            return (instance as RepositoryRecipeRunError)?.__typename === 'RepositoryRecipeRunError';
        }
        
export const isRepositoryChangesetARepositoryRecipeRunFinished = (instance: RepositoryRecipeRunCanceled | RepositoryRecipeRunError | RepositoryRecipeRunFinished | RepositoryRecipeRunNoLst | RepositoryRecipeRunQueued | RepositoryRecipeRunRunning | RepositoryRevision | RepositorySearchResult | unknown): instance is RepositoryRecipeRunFinished => {
            return (instance as RepositoryRecipeRunFinished)?.__typename === 'RepositoryRecipeRunFinished';
        }
        
export const isRepositoryChangesetARepositoryRecipeRunNoLst = (instance: RepositoryRecipeRunCanceled | RepositoryRecipeRunError | RepositoryRecipeRunFinished | RepositoryRecipeRunNoLst | RepositoryRecipeRunQueued | RepositoryRecipeRunRunning | RepositoryRevision | RepositorySearchResult | unknown): instance is RepositoryRecipeRunNoLst => {
            return (instance as RepositoryRecipeRunNoLst)?.__typename === 'RepositoryRecipeRunNoLst';
        }
        
export const isRepositoryChangesetARepositoryRecipeRunQueued = (instance: RepositoryRecipeRunCanceled | RepositoryRecipeRunError | RepositoryRecipeRunFinished | RepositoryRecipeRunNoLst | RepositoryRecipeRunQueued | RepositoryRecipeRunRunning | RepositoryRevision | RepositorySearchResult | unknown): instance is RepositoryRecipeRunQueued => {
            return (instance as RepositoryRecipeRunQueued)?.__typename === 'RepositoryRecipeRunQueued';
        }
        
export const isRepositoryChangesetARepositoryRecipeRunRunning = (instance: RepositoryRecipeRunCanceled | RepositoryRecipeRunError | RepositoryRecipeRunFinished | RepositoryRecipeRunNoLst | RepositoryRecipeRunQueued | RepositoryRecipeRunRunning | RepositoryRevision | RepositorySearchResult | unknown): instance is RepositoryRecipeRunRunning => {
            return (instance as RepositoryRecipeRunRunning)?.__typename === 'RepositoryRecipeRunRunning';
        }
        
export const isRepositoryChangesetARepositoryRevision = (instance: RepositoryRecipeRunCanceled | RepositoryRecipeRunError | RepositoryRecipeRunFinished | RepositoryRecipeRunNoLst | RepositoryRecipeRunQueued | RepositoryRecipeRunRunning | RepositoryRevision | RepositorySearchResult | unknown): instance is RepositoryRevision => {
            return (instance as RepositoryRevision)?.__typename === 'RepositoryRevision';
        }
        
export const isRepositoryChangesetARepositorySearchResult = (instance: RepositoryRecipeRunCanceled | RepositoryRecipeRunError | RepositoryRecipeRunFinished | RepositoryRecipeRunNoLst | RepositoryRecipeRunQueued | RepositoryRecipeRunRunning | RepositoryRevision | RepositorySearchResult | unknown): instance is RepositorySearchResult => {
            return (instance as RepositorySearchResult)?.__typename === 'RepositorySearchResult';
        }
        
export const isRepositoryCommitADirectCommitSucceeded = (instance: DirectCommitSucceeded | ForkAndPullRequestCommitSucceeded | ForkCommitSucceeded | PullRequestCommitSucceeded | RepositoryCommitCanceled | RepositoryCommitFailed | RepositoryCommitNoChanges | RepositoryCommitQueued | RepositoryCommitRunning | unknown): instance is DirectCommitSucceeded => {
            return (instance as DirectCommitSucceeded)?.__typename === 'DirectCommitSucceeded';
        }
        
export const isRepositoryCommitAForkAndPullRequestCommitSucceeded = (instance: DirectCommitSucceeded | ForkAndPullRequestCommitSucceeded | ForkCommitSucceeded | PullRequestCommitSucceeded | RepositoryCommitCanceled | RepositoryCommitFailed | RepositoryCommitNoChanges | RepositoryCommitQueued | RepositoryCommitRunning | unknown): instance is ForkAndPullRequestCommitSucceeded => {
            return (instance as ForkAndPullRequestCommitSucceeded)?.__typename === 'ForkAndPullRequestCommitSucceeded';
        }
        
export const isRepositoryCommitAForkCommitSucceeded = (instance: DirectCommitSucceeded | ForkAndPullRequestCommitSucceeded | ForkCommitSucceeded | PullRequestCommitSucceeded | RepositoryCommitCanceled | RepositoryCommitFailed | RepositoryCommitNoChanges | RepositoryCommitQueued | RepositoryCommitRunning | unknown): instance is ForkCommitSucceeded => {
            return (instance as ForkCommitSucceeded)?.__typename === 'ForkCommitSucceeded';
        }
        
export const isRepositoryCommitAPullRequestCommitSucceeded = (instance: DirectCommitSucceeded | ForkAndPullRequestCommitSucceeded | ForkCommitSucceeded | PullRequestCommitSucceeded | RepositoryCommitCanceled | RepositoryCommitFailed | RepositoryCommitNoChanges | RepositoryCommitQueued | RepositoryCommitRunning | unknown): instance is PullRequestCommitSucceeded => {
            return (instance as PullRequestCommitSucceeded)?.__typename === 'PullRequestCommitSucceeded';
        }
        
export const isRepositoryCommitARepositoryCommitCanceled = (instance: DirectCommitSucceeded | ForkAndPullRequestCommitSucceeded | ForkCommitSucceeded | PullRequestCommitSucceeded | RepositoryCommitCanceled | RepositoryCommitFailed | RepositoryCommitNoChanges | RepositoryCommitQueued | RepositoryCommitRunning | unknown): instance is RepositoryCommitCanceled => {
            return (instance as RepositoryCommitCanceled)?.__typename === 'RepositoryCommitCanceled';
        }
        
export const isRepositoryCommitARepositoryCommitFailed = (instance: DirectCommitSucceeded | ForkAndPullRequestCommitSucceeded | ForkCommitSucceeded | PullRequestCommitSucceeded | RepositoryCommitCanceled | RepositoryCommitFailed | RepositoryCommitNoChanges | RepositoryCommitQueued | RepositoryCommitRunning | unknown): instance is RepositoryCommitFailed => {
            return (instance as RepositoryCommitFailed)?.__typename === 'RepositoryCommitFailed';
        }
        
export const isRepositoryCommitARepositoryCommitNoChanges = (instance: DirectCommitSucceeded | ForkAndPullRequestCommitSucceeded | ForkCommitSucceeded | PullRequestCommitSucceeded | RepositoryCommitCanceled | RepositoryCommitFailed | RepositoryCommitNoChanges | RepositoryCommitQueued | RepositoryCommitRunning | unknown): instance is RepositoryCommitNoChanges => {
            return (instance as RepositoryCommitNoChanges)?.__typename === 'RepositoryCommitNoChanges';
        }
        
export const isRepositoryCommitARepositoryCommitQueued = (instance: DirectCommitSucceeded | ForkAndPullRequestCommitSucceeded | ForkCommitSucceeded | PullRequestCommitSucceeded | RepositoryCommitCanceled | RepositoryCommitFailed | RepositoryCommitNoChanges | RepositoryCommitQueued | RepositoryCommitRunning | unknown): instance is RepositoryCommitQueued => {
            return (instance as RepositoryCommitQueued)?.__typename === 'RepositoryCommitQueued';
        }
        
export const isRepositoryCommitARepositoryCommitRunning = (instance: DirectCommitSucceeded | ForkAndPullRequestCommitSucceeded | ForkCommitSucceeded | PullRequestCommitSucceeded | RepositoryCommitCanceled | RepositoryCommitFailed | RepositoryCommitNoChanges | RepositoryCommitQueued | RepositoryCommitRunning | unknown): instance is RepositoryCommitRunning => {
            return (instance as RepositoryCommitRunning)?.__typename === 'RepositoryCommitRunning';
        }
        
export const isRepositoryCommitSucceededADirectCommitSucceeded = (instance: DirectCommitSucceeded | ForkAndPullRequestCommitSucceeded | ForkCommitSucceeded | PullRequestCommitSucceeded | unknown): instance is DirectCommitSucceeded => {
            return (instance as DirectCommitSucceeded)?.__typename === 'DirectCommitSucceeded';
        }
        
export const isRepositoryCommitSucceededAForkAndPullRequestCommitSucceeded = (instance: DirectCommitSucceeded | ForkAndPullRequestCommitSucceeded | ForkCommitSucceeded | PullRequestCommitSucceeded | unknown): instance is ForkAndPullRequestCommitSucceeded => {
            return (instance as ForkAndPullRequestCommitSucceeded)?.__typename === 'ForkAndPullRequestCommitSucceeded';
        }
        
export const isRepositoryCommitSucceededAForkCommitSucceeded = (instance: DirectCommitSucceeded | ForkAndPullRequestCommitSucceeded | ForkCommitSucceeded | PullRequestCommitSucceeded | unknown): instance is ForkCommitSucceeded => {
            return (instance as ForkCommitSucceeded)?.__typename === 'ForkCommitSucceeded';
        }
        
export const isRepositoryCommitSucceededAPullRequestCommitSucceeded = (instance: DirectCommitSucceeded | ForkAndPullRequestCommitSucceeded | ForkCommitSucceeded | PullRequestCommitSucceeded | unknown): instance is PullRequestCommitSucceeded => {
            return (instance as PullRequestCommitSucceeded)?.__typename === 'PullRequestCommitSucceeded';
        }
        
export const isRepositoryRecipeRunARepositoryRecipeRunCanceled = (instance: RepositoryRecipeRunCanceled | RepositoryRecipeRunError | RepositoryRecipeRunFinished | RepositoryRecipeRunNoLst | RepositoryRecipeRunQueued | RepositoryRecipeRunRunning | unknown): instance is RepositoryRecipeRunCanceled => {
            return (instance as RepositoryRecipeRunCanceled)?.__typename === 'RepositoryRecipeRunCanceled';
        }
        
export const isRepositoryRecipeRunARepositoryRecipeRunError = (instance: RepositoryRecipeRunCanceled | RepositoryRecipeRunError | RepositoryRecipeRunFinished | RepositoryRecipeRunNoLst | RepositoryRecipeRunQueued | RepositoryRecipeRunRunning | unknown): instance is RepositoryRecipeRunError => {
            return (instance as RepositoryRecipeRunError)?.__typename === 'RepositoryRecipeRunError';
        }
        
export const isRepositoryRecipeRunARepositoryRecipeRunFinished = (instance: RepositoryRecipeRunCanceled | RepositoryRecipeRunError | RepositoryRecipeRunFinished | RepositoryRecipeRunNoLst | RepositoryRecipeRunQueued | RepositoryRecipeRunRunning | unknown): instance is RepositoryRecipeRunFinished => {
            return (instance as RepositoryRecipeRunFinished)?.__typename === 'RepositoryRecipeRunFinished';
        }
        
export const isRepositoryRecipeRunARepositoryRecipeRunNoLst = (instance: RepositoryRecipeRunCanceled | RepositoryRecipeRunError | RepositoryRecipeRunFinished | RepositoryRecipeRunNoLst | RepositoryRecipeRunQueued | RepositoryRecipeRunRunning | unknown): instance is RepositoryRecipeRunNoLst => {
            return (instance as RepositoryRecipeRunNoLst)?.__typename === 'RepositoryRecipeRunNoLst';
        }
        
export const isRepositoryRecipeRunARepositoryRecipeRunQueued = (instance: RepositoryRecipeRunCanceled | RepositoryRecipeRunError | RepositoryRecipeRunFinished | RepositoryRecipeRunNoLst | RepositoryRecipeRunQueued | RepositoryRecipeRunRunning | unknown): instance is RepositoryRecipeRunQueued => {
            return (instance as RepositoryRecipeRunQueued)?.__typename === 'RepositoryRecipeRunQueued';
        }
        
export const isRepositoryRecipeRunARepositoryRecipeRunRunning = (instance: RepositoryRecipeRunCanceled | RepositoryRecipeRunError | RepositoryRecipeRunFinished | RepositoryRecipeRunNoLst | RepositoryRecipeRunQueued | RepositoryRecipeRunRunning | unknown): instance is RepositoryRecipeRunRunning => {
            return (instance as RepositoryRecipeRunRunning)?.__typename === 'RepositoryRecipeRunRunning';
        }
        
export const isScmConnectionAAzureDevOpsConnection = (instance: AzureDevOpsConnection | BitbucketCloudConnection | BitbucketConnection | GitLabConnection | GithubConnection | unknown): instance is AzureDevOpsConnection => {
            return (instance as AzureDevOpsConnection)?.__typename === 'AzureDevOpsConnection';
        }
        
export const isScmConnectionABitbucketCloudConnection = (instance: AzureDevOpsConnection | BitbucketCloudConnection | BitbucketConnection | GitLabConnection | GithubConnection | unknown): instance is BitbucketCloudConnection => {
            return (instance as BitbucketCloudConnection)?.__typename === 'BitbucketCloudConnection';
        }
        
export const isScmConnectionABitbucketConnection = (instance: AzureDevOpsConnection | BitbucketCloudConnection | BitbucketConnection | GitLabConnection | GithubConnection | unknown): instance is BitbucketConnection => {
            return (instance as BitbucketConnection)?.__typename === 'BitbucketConnection';
        }
        
export const isScmConnectionAGitLabConnection = (instance: AzureDevOpsConnection | BitbucketCloudConnection | BitbucketConnection | GitLabConnection | GithubConnection | unknown): instance is GitLabConnection => {
            return (instance as GitLabConnection)?.__typename === 'GitLabConnection';
        }
        
export const isScmConnectionAGithubConnection = (instance: AzureDevOpsConnection | BitbucketCloudConnection | BitbucketConnection | GitLabConnection | GithubConnection | unknown): instance is GithubConnection => {
            return (instance as GithubConnection)?.__typename === 'GithubConnection';
        }
        
export const isVisualizationAVisualizationAvailable = (instance: VisualizationAvailable | VisualizationError | VisualizationFinished | VisualizationProcessing | unknown): instance is VisualizationAvailable => {
            return (instance as VisualizationAvailable)?.__typename === 'VisualizationAvailable';
        }
        
export const isVisualizationAVisualizationError = (instance: VisualizationAvailable | VisualizationError | VisualizationFinished | VisualizationProcessing | unknown): instance is VisualizationError => {
            return (instance as VisualizationError)?.__typename === 'VisualizationError';
        }
        
export const isVisualizationAVisualizationFinished = (instance: VisualizationAvailable | VisualizationError | VisualizationFinished | VisualizationProcessing | unknown): instance is VisualizationFinished => {
            return (instance as VisualizationFinished)?.__typename === 'VisualizationFinished';
        }
        
export const isVisualizationAVisualizationProcessing = (instance: VisualizationAvailable | VisualizationError | VisualizationFinished | VisualizationProcessing | unknown): instance is VisualizationProcessing => {
            return (instance as VisualizationProcessing)?.__typename === 'VisualizationProcessing';
        }
        
export const isVisualizationOutputAVisualizationDataGridOutput = (instance: VisualizationDataGridOutput | VisualizationImageOutput | VisualizationPlotlyOutput | unknown): instance is VisualizationDataGridOutput => {
            return (instance as VisualizationDataGridOutput)?.__typename === 'VisualizationDataGridOutput';
        }
        
export const isVisualizationOutputAVisualizationImageOutput = (instance: VisualizationDataGridOutput | VisualizationImageOutput | VisualizationPlotlyOutput | unknown): instance is VisualizationImageOutput => {
            return (instance as VisualizationImageOutput)?.__typename === 'VisualizationImageOutput';
        }
        
export const isVisualizationOutputAVisualizationPlotlyOutput = (instance: VisualizationDataGridOutput | VisualizationImageOutput | VisualizationPlotlyOutput | unknown): instance is VisualizationPlotlyOutput => {
            return (instance as VisualizationPlotlyOutput)?.__typename === 'VisualizationPlotlyOutput';
        }
        